webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHANGE_BASICINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHANGE_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHECK_BASICINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_EXPECTIONINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PRIVACY; });
/* unused harmony export SET_BASICINFO */
/* unused harmony export GET_CHECKCODE */
/* unused harmony export VARIFY_CHECKCODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANGE_HASAUTHED; });
/* unused harmony export CHANGE_BASICITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CHANGE_UPLOAD_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHANGE_SUBMITSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_LOGINSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_RESUME_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_AREA_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BLOCK_INDUSTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_HASAUTHEDMOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_EDUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECK_EDUINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_ALLCONFIGOTHERDATA; });
var CHANGE_BASICINFO = 'CHANGE_BASICINFO'; // 修改基本信息内容
var CHANGE_OPTION = 'CHANGE_OPTION'; // 修改state字段值
var CHECK_BASICINFO = 'CHECK_BASICINFO'; // 改变基本信息填写状态
var CHECK_EXPECTIONINFO = 'CHECK_EXPECTIONINFO'; // 改变求职期望信息状态
var SET_PRIVACY = 'SET_PRIVACY'; // 隐私设置信息设置
var SET_BASICINFO = 'SET_BASICINFO'; // 上一份简历信息初始化

var GET_CHECKCODE = 'GET_CHECKCODE'; // 获取验证码
var VARIFY_CHECKCODE = 'VARIFY_CHECKCODE'; // 校验验证码
var CHANGE_HASAUTHED = 'CHANGE_HASAUTHED'; // 改变认证状态
var CHANGE_BASICITEMS = 'CHANGE_BASICITEMS'; // 改版认证状态

var CHANGE_UPLOAD_STATE = 'CHANGE_UPLOAD_STATE'; // 图片上传状态
var CHANGE_SUBMITSTATE = 'CHANGE_SUBMITSTATE'; // 简历发布状态
var CHANGE_LOGINSTATE = 'CHANGE_LOGINSTATE'; // 更改登录状态
var SET_RESUME_COUNT = 'SET_RESUME_COUNT'; // 简历份数
var SET_AREA_DATA = 'SET_AREA_DATA'; // 区域数据

var SET_BLOCK_INDUSTRY = 'SET_BLOCK_INDUSTRY'; // 屏蔽行业框展示状态
var SET_HASAUTHEDMOBILE = 'SET_HASAUTHEDMOBILE'; // 设置后置登录使用的手机号或者已认证的手机号

var CHANGE_EDUTION = 'CHANGE_EDUTION'; // 设置教育经历状态
var CHECK_EDUINFO = 'CHECK_EDUINFO'; // 校验教育经历

var SET_ALLCONFIGOTHERDATA = 'SET_ALLCONFIGOTHERDATA'; //静态数据

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	jlDomain: '//jianli.m.58.com',
	_fromurl: encodeURIComponent(document.location.href),

	nameReg: /^[\u4e00-\u9fa5]{2,4}$/, // 姓名正则
	mobileReg: /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[6]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/, // 手机号码正则
	schoolReg: /^[\u4e00-\u9fa5]{4,20}$/, // 学校名称正则
	majorReg: /^[\u4e00-\u9fa5]{2,20}$/, // 专业名称正则
	// 出生年份列表
	birthdayList: function () {
		var birthdayYearList = [];
		var date = new Date(),
		    currYear = date.getFullYear(),
		    start = currYear - 60,
		    // 最大年龄年份
		end = currYear - 16; // 最小年龄年份

		for (var i = start; i <= end; i++) {
			birthdayYearList.push(i + '年');
		}
		return birthdayYearList;
	}(),
	// 教育经历列表(对应的id从1开始)
	educationList: ['高中以下', // 1
	'高中', // 2
	'中专/技校', // 3
	'大专', // 4
	'本科', // 5
	'硕士', // 6
	'博士', // 7
	'MBA/EMBA' // 8
	],
	// 工作经验列表
	experienceList: ['无经验', '应届生', '1年以下', '1-3年', '3-5年', '5-10年', '10年以上'],
	experienceArray: [0, 5, 6, 1, 2, 3, 4], // 工作经验列表对应的value

	// 期望薪资列表
	salaryList: ['面议', '1000元以下', '1000-2000元', '2000-3000元', '3000-5000元', '5000-8000元', '8000-12000元', '12000-25000元', '25000元以上'],

	// 毕业年份列表
	eduYearList: function () {
		var graduateYearList = [];
		var currYear = new Date().getFullYear() + 5; //应届生毕业时间推迟5年
		for (var i = currYear - 60; i <= currYear; i++) {
			graduateYearList.push(i + '年');
		}
		return graduateYearList;
	}(),

	// 毕业月份列表
	eduMonthList: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],

	// companyNameReg: /^[\u4e00-\u9fa5a-zA-Z0-9()（）\/\.&\s]{1,30}$/, // 公司名称/学校名称/专业名称正则
	// positionNameReg: /^[\u4e00-\u9fa5a-zA-Z0-9\/]{2,12}$/, // 职位名称正则
	emailReg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w{2,}/, // 验证是否包含邮箱
	qqReg: /([0-9０１２３４５６７８９零一二三四五六七八九壹贰叁肆伍陆柒捌玖]{5})/ // 验证是否包含qq号
	// contactReg: /(([qｑQＱ]+)(.?|.{1,5})(([0-9]|[０-９]|[零一二三四五六七八九]|[①-⑨]|[㈠-㈨])[-_@\~\#\$\%\^\&\*]*){5,13})|((([0-9]|[０-９]|[零一二三四五六七八九]|[①-⑨]|[㈠-㈨])[-_@\~\#\$\%\^\&\*]*){5,13}(.?|.{1,5})([qｑQＱ]+))/ // qq电话等联系方式
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
	// 获取url参数值
	getParamVal: function getParamVal(name) {
		var regex = new RegExp('[?&]' + encodeURIComponent(name) + '\\=([^&#]+)'),
		    value = (location.search.match(regex) || ['', ''])[1];
		return decodeURIComponent(value);
	},
	dataURLtoBlob: function dataURLtoBlob(dataurl, filename) {
		var arr = dataurl.split(',');
		var mime = arr[0].match(/:(.*?);/)[1];
		var bstr = atob(arr[1]);
		var n = bstr.length;
		var u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		var theBlob = new Blob([u8arr], { type: mime });
		theBlob.lastModifiedDate = new Date();
		theBlob.name = filename;
		return theBlob;
	}
};

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @module cookie
 * @description cookie操作封装
 */

var defaultOpts = {
	expiresDay: 7,
	path: '/',
	domain: '.58.com'
};

function trim(str) {
	if (typeof String.prototype.trim === 'function') {
		return String.prototype.trim.call(str);
	} else {
		return str.replace(/^\s+(.*?)\s+$/g, '$1');
	}
}

var cookie = {
	/**
  * @alias module:cookie.get
  * @description 从cookie中获取名字为name的cookie值返回的值。
  * @param {String} name cookie的名字
  * @param {Boolean} decode 返回的cookie值是否需要解码，默认为true
  * @return {String} 返回的cookie值,默认是解码后的值，如果decode传false，返回没有解码的原始值;如果不存在返回null
  * @example
  * let val = cookie.get('ipcity');//bj|北京
  * let val = cookie.get('ipcity',false);//bj%7C%u5317%u4EAC
  */
	get: function get(name) {
		var decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		var cookieValue = null;
		if (!name) {
			return cookieValue;
		}
		//cookieNameLen:name+'='
		var cookieNameLen = name.length + 1;
		var strCookie = document.cookie;
		if (strCookie) {
			var arrCookies = strCookie.split(';');
			for (var i = 0, len = arrCookies.length; i < len; i++) {
				var _cookie = trim(arrCookies[i]);
				if (_cookie.substring(0, cookieNameLen) === name + '=') {
					cookieValue = _cookie.substring(cookieNameLen);
					cookieValue = decode ? decodeURIComponent(cookieValue) : cookieValue;
					break;
				}
			}
		}
		return cookieValue;
	},
	/**
  * @alias module:cookie.getname
  * @description 从cookie中获取名字为cookieName的值中，通过&分割的名字name为属性值(这是个xx方法，不应该出现在cookie的方法中，应该是业务自己的事情，但是为了兼容老版本而保留)。
  * @param {String} cookieName cookie的名字
  * @param {String} name 查找的属性名
  * @return {String} 返回符合要求的值
  * @example
  *
  */
	getname: function getname(cookieName, name) {
		var cookieVal = this.get(cookieName);
		if (!cookieVal) {
			return '';
		}
		var regex = new RegExp('[?&"]' + encodeURIComponent(name) + '\\=([^&#]+)');
		var value = (cookieVal.match(regex) || ['', ''])[1];
		return decodeURIComponent(value);
	},
	/**
  * @alias module:cookie.set
  * @description 设置cookie。
  * @param {String} name cookie的名字
  * @param {String} value cookie的值
  * @param {Date | Number} expires cookie的过期时间，可以传一个数字，表示多少天后过期；如果穿一个Date类的值，过期时间设置为该值；如果不传采用默认过期时间,传null时设置为''
  * @param {String} path cookie的路径值，如果不传采用默认path，传null时设置为''
  * @param {String} domain cookie的域名，如果不传采用默认domain，传null时设置为''
  * @param {Boolean} secure cookie是否设置为安全，值为true是，设置secure值，否则为''
  *
  * @example
  * cookie.set('test','123');//设置一个名字为test值为123的cookie，域名，path和过期时间都是采用默认的值
  * cookie.set('test','aaa',10);//设置一个10天后过期的cookie值
  * cookie.set('test','bbb',10,'/xxx/','m.58.com');//在m.58.com域名的/xxx/路径下设置名字为test，值为bbb，过期时间为10天的cookie
  */
	set: function set(name, value, expires, path, domain, secure) {
		var undef = void 0;
		//过期时间设置
		if (value === null) {
			value = '';
			expires = -1; //过期日期设为前一天
		} else if (expires === undef) {
			expires = defaultOpts.expiresDay; //当没提供过期时间时，采用缺省过期时间
		}
		var setExpires = '';
		//如果过期时间是null或'',则cookie设置的过期时间为空，即设置session性质cookie
		if (expires) {
			var date = void 0;
			if (typeof expires === 'number') {
				date = new Date();
				date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
			} else if (expires.toUTCString) {
				date = expires;
			}
			setExpires = '; expires=' + date.toUTCString();
		}

		//path没传时，采用默认path设置；如果传null置''
		path = path === undef ? defaultOpts.path : path;
		var setPath = path ? '; path=' + path : '';

		//domain没传时，采用默认domain设置；如果传null置''
		domain = domain === undef ? defaultOpts.domain : domain;
		var setDomain = domain ? '; domain=' + domain : '';

		//secure
		var setSecure = secure === true ? '; secure' : '';
		document.cookie = [name, '=', name === 'PPU' ? value : encodeURIComponent(value), setExpires, setPath, setDomain, setSecure].join('');
	},
	/**
  * @alias module:cookie.remove
  * @description 清除名字为name的cookie。
  * @param {String} name cookie的名字
  * @example
  * cookie.set('test','123');//设置一个名字为test值为123的cookie，域名，path和过期时间都是采用默认的值
  * cookie.remove('test');//清除test cookie
  * cookie.get('test');//null
  */
	remove: function remove(name) {
		this.set(name, '', new Date(1970, 1, 1));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (cookie);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d363357",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63ff4760",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getConfigJobsData;
/* harmony export (immutable) */ __webpack_exports__["a"] = getConfigOtherData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fetch_jsonp__);


function getConfigJobsData() {
  return __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp___default()("https://jlwebapp.58.com/resumepost/targetCateIDs").then(function (res) {
    return res.json();
  });
}

function getConfigOtherData() {
  return __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp___default()("https://jlwebapp.58.com/resumepost/staticData").then(function (res) {
    return res.json();
  });
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		/**
   * 重置教育经历信息
   */
		resetEdu: function resetEdu() {
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduIndex',
				value: -1
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduState',
				value: 0
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradschool',
				value: '',
				state: null
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradmajor',
				value: '',
				state: null
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradtime',
				value: '',
				state: null
			});
		}
	}
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var mobileLogin = new window.MobileLogin({
	source: 'passport'
});

/* harmony default export */ __webpack_exports__["a"] = ({
	getAuthCode: function getAuthCode(tel, imgCode) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			//提交
			mobileLogin.getCode({
				mobile: tel,
				voicetype: 0,
				validcode: imgCode,
				callback: function callback(result) {
					resolve(result);
				}
			});
		});
	},

	freshValidateCode: function freshValidateCode() {
		return mobileLogin.freshValidateCode();
	},

	loginCommit: function loginCommit(tel, code) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			mobileLogin.loginCommit({
				mobile: tel,
				mobilecode: code,
				callback: function callback(result) {
					resolve(result);
				}
			});
		});
	}
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(352),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_basic__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_basic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_basic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_expectation__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_expectation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_expectation__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'basic',
		component: __WEBPACK_IMPORTED_MODULE_2__components_basic___default.a
	}, {
		path: '/expectation',
		name: 'expectation',
		component: __WEBPACK_IMPORTED_MODULE_3__components_expectation___default.a
	}]
}));

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(14);







if (!window.Vuex) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
}

var pageJson = window.____global.pageJson;

var global = {
	isLogin: pageJson.isLogin,
	user58pic: pageJson.user58pic,
	jobUrl: pageJson.jobUrl || '//m.58.com/job',
	source: pageJson.source ? pageJson.source : '', // 完整简历3，M微简历13，联盟18，百度百聘46，校招76
	resumeType: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('resumeType') || pageJson.resumeType, // 简历类型（完整简历1，M微简历2，联盟3）
	areaName: pageJson.areaName,
	categoryInitList: pageJson.categoryInitList // 默认选择的职位
};

// 简历发布提交字段
var submitData = {
	truename: '', //姓名（必传）
	gender: '', // 性别（必传）
	mobile: '', //手机号（必传）
	keyCode: '', //验证码
	education: '', //教育程度（必传）
	workyears: '', //工作年限（必传）
	birthday: '', //出生年份 yyyy-mm-dd（必传）
	targetAreaId: '', //意向工作地点 , 分割（必传）
	salary: '', //期望薪资（必传）
	zpcateId: '', //期望职位的归属id逗号分割（必传）
	from: global.source, //发布来源，完整简历，微简历，联盟，百度百聘（要传）校招简历
	responseid: '', // 获取手机验证码返回的responseID
	email: '', //邮箱
	native: '', //籍贯
	liveaddr: '', //现居住地
	pic: '', //头像
	educations: '', // 教育经历
	csrfToken: window.____global.csrfToken || '', // token信息
	tjfrom: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('tjfrom') || ''
};

// 隐私设置提交字段
var privacyData = {
	showStatus: 0,
	blockIndustry: 0
};

// 基础信息页面校验字段(默认是null，填写正确置为true，填写错误置为false)
var basicInfo = {
	truename: null,
	gender: null,
	mobile: null, //手机号
	keyCode: null, //验证码
	birthday: null, //出生年份 yyyy-mm-dd
	education: null, //教育程度
	workyears: null, //工作年限
	educations: null // 教育经历
};

// 求职意向页面校验字段
var expectionInfo = {
	zpcateId: false, // 期望职位(测试)
	salary: false, //期望薪资
	targetAreaId: false //意向工作地点（测试）
};

// 获取验证码接口信息
var captcha = {
	isSuccess: false,
	responseid: '',
	errorInfo: ''
};

// 投递参数信息
var deliveryObj = {
	infoId: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('infoids'),
	resumeId: '',
	deliverySource: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('deliverySource'),
	tjFrom: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('tjfrom'),
	finalCp: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('finalCp'),
	role: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('role'),
	wbtk: window.____global.csrfToken || '' // token信息
};

// 当前操作教育经历信息
var educationInfo = {
	gradschool: '', //学校名称
	gradmajor: '', //专业名称
	gradtime: '', //毕业时间
	eduIndex: -1, // 当前操作索引值
	eduState: 0 // 0-非新增非编辑状态 1-新增状态 2-编辑状态
};

// 教育经历校验字段(默认是null，填写正确置为true，填写错误置为false)
var educationCheck = {
	gradschool: null, //学校名称
	gradmajor: null, //专业名称
	gradtime: null //毕业时间
};

var state = {
	global: global,
	pagefromUrl: decodeURIComponent(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('from')) || '', // 来源页面URL
	isLogin: global.isLogin, // 登录状态
	resumeCount: 0, // 简历份数
	sessionCateList: [], // 缓存中期望职位数据
	sessionAreaList: [], // 缓存中期望区域数据
	originPic: '', // 上传的原始图片url
	areaInfo: [], // 区域信息
	hasAuthed: false, // 手机号是否已认证
	hasAuthedMobile: '', // 用户通过后置登录成功使用的手机号或者用户已认证的手机号，若使用此手机号则不再进行检查认证状态
	authMobile: '', // 后端返回的已认证的手机号
	captcha: captcha,
	basicInfo: basicInfo,
	expectionInfo: expectionInfo,
	basicInfoOk: false, // 标记基础信息页面信息填写情况
	expectionInfoOk: false, // 标记求职意向页面信息填写情况
	educationOk: false, // 标记教育经历信息填写情况
	submitData: submitData,
	privacyData: privacyData,
	resumeId: '', // 发布的简历id
	showIndustry: false, // 是否展示屏蔽行业选择
	uploadState: null, // 图片上传状态，默认为null
	submitState: null, // 基本简历发布状态，默认为null
	submitErrorInfo: '', // 简历发布错误提示
	privacySettingState: null, // 隐私设置状态
	privacyErrorInfo: '', // 隐私设置错误提示
	deliveryObj: deliveryObj, // 投递参数
	infoId: deliveryObj.infoId, // 职位id
	deliveryCode: '', // 投递返回的code
	deliveryState: false, // 投递状态
	deliveryMsg: '', //简历投递错误提示
	educationInfo: educationInfo,
	educationCheck: educationCheck,
	allConfigOtherData: {},
	showISDCaptcha: false,
	responseObj: null, // 滑动验证码返回参数
	/**
  * fromEducation：教育培训
  * fromWX：微信小程序
  * fromTT：头条小程序
  * fromBD：百度小程序
  * fromXZ：校招
  * fromCQXZ：重庆定制校招
  * fromTZ：同镇
  * defalt：默认
  */
	pagefrom: __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('pagefrom') === 'education' ? 'fromEducation' : __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('pagefrom') ? __WEBPACK_IMPORTED_MODULE_5__util__["a" /* default */].getParamVal('pagefrom') : ['63', '104', '105', '152'].indexOf(deliveryObj.deliverySource) > -1 ? 'fromWX' : deliveryObj.deliverySource === '102' ? 'fromTT' : deliveryObj.deliverySource === '103' ? 'fromBD' : deliveryObj.deliverySource === '106' ? 'fromZFB' : global.source === 76 ? 'fromXZ' : global.source === 94 ? 'fromCQXZ' : global.source === 77 ? 'fromTZ' : 'default'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
	state: state,
	getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
	actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
	mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(359),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_find__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__x_checklist__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__x_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__x_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__x_radiolist__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__x_radiolist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__x_radiolist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selected__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__selected__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-checklist',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: '请选择'
		},
		max: {
			type: Number,
			default: 5
		},
		selects: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		data: {
			type: Array
		}
	},
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_1__popup___default.a,
		XChecklist: __WEBPACK_IMPORTED_MODULE_2__x_checklist___default.a,
		XRadiolist: __WEBPACK_IMPORTED_MODULE_3__x_radiolist___default.a,
		Toast: __WEBPACK_IMPORTED_MODULE_4__toast___default.a,
		Selected: __WEBPACK_IMPORTED_MODULE_5__selected___default.a
	},
	computed: {
		isShowFooter: function isShowFooter() {
			return this.currentSelected.length > 0;
		}
	},
	watch: {
		selects: function selects(val) {
			this.updateValue(val);
		},
		value: function value(val) {
			this.show = val;
		},
		currentValue: function currentValue(val) {
			if (val.length === this.level) {
				this.setSelValue(val[this.level - 1]);
				this.$emit('on-change', this.currentSelected);
			}
			//选中数据变化时，联动更新列表数据
			this.updateData();
		}
	},
	methods: {
		//关闭
		close: function close() {
			//如果点击右上角的关闭，则不保存当前选择的数据，重置为初始化的数据
			if (this.currentValue.length === this.level) {
				this.updateValue(this.selects);
			}
			this.$emit('on-close');
		},

		//确认
		confirm: function confirm() {
			this.$emit('on-confirm', this.currentSelected);
		},

		//达到限制
		limit: function limit(val) {
			this.isShowToast = true;
		},

		//更新选择数据
		updateValue: function updateValue(val) {
			this.currentValue.pop();
			this.currentValue.push(val);
		},

		//设置当前选择的数据
		setSelValue: function setSelValue(val) {
			this.currentSelected = val;
		},

		//初始化选中数据
		initCurrentValue: function initCurrentValue() {
			var _this = this;

			var currentId = this.selects[0] && this.selects[0]['id']; //当前列表选中项的ID（如果当前列表有多个选中项则取第一个的ID）

			//因为列表数据是根据选中数据联动的，即currentData数组长度等于currentValue
			//所以无默认选中项时，初始化需要push一个空值

			if (this.selects.length === 0 && this.level > 1) {
				this.currentValue.push({});
				return;
			}
			this.currentValue.push(this.selects);

			//根据最后一级选中项的值反向生成前面的选中项
			for (var index = this.level - 1; index > 0; index--) {
				this.data[index].forEach(function (item) {
					var currentIndex = item.list.findIndex(function (secondItem) {
						return secondItem.id === currentId;
					});
					if (currentIndex !== -1) {
						currentId = item['parentId'];
						_this.currentValue.unshift({
							id: currentId
						});
						return;
					}
				});
			}
		},

		//更新列表数据
		updateData: function updateData() {
			var currentId = void 0;
			for (var index = 0; index < this.level; index++) {
				//首列数据不做更新
				if (index === 0 && this.currentData[index]) {
					continue;
				}
				//初始化首列数据
				if (index === 0 && this.currentData[index] === undefined) {
					this.currentData.push(this.data[0]);
					continue;
				}

				//初始化或更新非首列数据
				currentId = this.currentValue[index - 1]['id'];
				if (!currentId) {
					return;
				}
				var temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_find___default()(this.data[index], function (item) {
					return item['parentId'] === currentId;
				});
				this.currentData[index] = temp['list'];
			}
		}
	},
	data: function data() {
		return {
			level: this.data.length, //选择列表层级
			currentSelected: [], //追踪返回的选中数据
			currentData: [], //当前列表数据
			currentValue: [], //当前所有选中数据
			show: this.value, //是否展示弹窗
			isShowToast: false //是否展示提示
		};
	},
	created: function created() {
		this.initCurrentValue();
	}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroller__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scroller__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: {
			type: Boolean,
			default: false
		},
		selects: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		max: {
			type: Number,
			default: 5
		}
	},
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_0__popup___default.a,
		Scroller: __WEBPACK_IMPORTED_MODULE_1__scroller___default.a
	},
	computed: {
		selLength: function selLength() {
			return this.currentValue.length;
		}
	},
	watch: {
		value: function value(val) {
			this.show = val;
		},
		selects: function selects(val) {
			this.currentValue = val;
		},
		selLength: function selLength(val) {
			this.setPosition();
		}
	},
	methods: {
		confirm: function confirm() {
			this.$emit('confirm', this.currentValue);
		},

		//删除
		remove: function remove(id) {
			var index = this.findIndex(this.currentValue, id);
			this.currentValue.splice(index, 1);
			this.$emit('update', this.currentValue);
		},

		//查找下标
		findIndex: function findIndex(arr, id) {
			var index = arr.findIndex(function (item) {
				return item.id === id;
			});
			return index;
		},

		//设置位置
		setPosition: function setPosition() {
			var _this = this;

			this.$nextTick(function () {
				var srollerWrapWidth = _this.$el.getElementsByClassName('v5-checklist-selected-scroller-wrap')[0].offsetWidth;
				var srollerWidth = _this.$el.getElementsByClassName('v5-checklist-selected-list')[0].offsetWidth;
				if (srollerWidth > srollerWrapWidth) {
					_this.positionX = srollerWidth - srollerWrapWidth;
				}
			});
		},

		//设置底部已选择列表宽
		setSelListDomWidth: function setSelListDomWidth() {
			var selListDom = this.$el.getElementsByClassName('v5-checklist-selected-list')[0],
			    selListDomWidth = 60,
			    selListChilds = selListDom.children;

			for (var i = 0, l = selListChilds.length; i < l; i++) {
				selListDomWidth += selListChilds[i].offsetWidth;
			}
			selListDom.style.width = selListDomWidth + 'px';
		}
	},
	data: function data() {
		return {
			positionX: 0,
			currentValue: this.selects,
			show: this.value
		};
	},
	updated: function updated() {
		this.setSelListDomWidth();
	},
	mounted: function mounted() {
		this.setSelListDomWidth();
	}
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__x_button__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__x_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__x_button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-confirm',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: '提示'
		},
		text: {
			type: String
		},
		confirmText: {
			type: String,
			default: '确定'
		},
		cancelText: {
			type: String,
			default: '取消'
		},
		isLockScroll: {
			type: Boolean,
			default: true
		}
	},
	components: {
		XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a,
		XButton: __WEBPACK_IMPORTED_MODULE_1__x_button___default.a
	},
	watch: {
		value: function value(val) {
			this.show = val;
		},
		show: function show(val) {
			this.$emit('input', val);
		}
	},
	methods: {
		confirm: function confirm() {
			this.show = false;
			this.$emit('on-confirm');
		},
		cancel: function cancel() {
			this.show = false;
			this.$emit('on-cancel');
		}
	},
	data: function data() {
		return {
			show: this.value
		};
	}
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_debounce__ = __webpack_require__(126);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-loading',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		delay: {
			type: Number,
			default: 0
		}
	},
	watch: {
		value: function value(val) {
			if (this.visible === val) return;

			this.update();
		},
		visible: function visible(val) {
			this.$emit('input', val);
		}
	},
	methods: {
		update: function update() {
			this.visible = this.value;
		}
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			//延时展示，减少loading闪烁
			if (_this.delay) {
				_this.update = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_debounce__["a" /* default */])(_this.update, _this.delay);
			}
		});
	},
	data: function data() {
		return {
			visible: this.value
		};
	}
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-popup',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		isShowMask: {
			type: Boolean,
			default: true
		},
		isLockScroll: {
			type: Boolean,
			default: true
		},
		position: {
			type: String,
			default: 'bottom'
		},
		height: {
			type: String,
			default: 'auto'
		},
		width: String
	},
	watch: {
		value: function value(val) {
			this.show = val;
		},
		show: function show(val) {
			this.$emit('input', val);
		}
	},
	computed: {
		styles: function styles() {
			var styles = {
				height: this.height
			};
			if (this.width !== '') {
				styles.width = this.width;
			}
			return styles;
		}
	},
	methods: {
		lockScroll: function lockScroll(e) {
			if (this.isLockScroll) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
		hidePopup: function hidePopup() {
			this.show = false;
		}
	},
	data: function data() {
		return {
			show: this.value
		};
	}
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroller__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__render__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__render__);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-scroller',
	props: {
		autoResize: {
			type: Boolean,
			default: true
		},
		positionX: {
			type: Number,
			default: 0
		},
		positionY: {
			type: Number,
			default: 0
		},
		scrollingX: {
			type: Boolean,
			default: false
		},
		scrollingY: {
			type: Boolean,
			default: true
		},
		animating: {
			type: Boolean,
			default: true
		},
		animationDuration: {
			type: Number,
			default: 250
		},
		bouncing: {
			type: Boolean,
			default: true
		},
		locking: {
			type: Boolean,
			default: true
		},
		paging: {
			type: Boolean,
			default: false
		},
		snapping: {
			type: Boolean,
			default: false
		},
		size: {
			type: Number,
			default: 100
		},
		zooming: {
			type: Boolean,
			default: false
		},
		minZoom: {
			type: Number,
			default: 0.5
		},
		maxZoom: {
			type: Number,
			default: 3
		}
	},
	watch: {
		positionX: function positionX(val) {
			this.scroller.scrollTo(val, this.positionY);
		},
		positionY: function positionY(val) {
			this.scroller.scrollTo(this.positionX, val);
		}
	},
	methods: {
		init: function init() {
			if (this.isInstall) return;
			this.isInstall = true;

			//设置位置
			var rect = this.container.getBoundingClientRect();
			this.scroller.setPosition(rect.left + this.container.clientLeft, rect.top + this.container.clientTop);

			//设置size
			this.resize();

			//设置初始位置
			if (this.positionX || this.positionY) {
				this.scroller.scrollTo(this.positionX, this.positionY);
			}

			//设置snapping
			if (this.snapping) {
				this.scroller.setSnapSize(this.contentW / this.size, this.contentH / this.size);
			}
		},

		//设置容器大小
		resize: function resize() {
			this.contentW = this.content.offsetWidth;
			this.contentH = this.content.offsetHeight;
			this.scroller.setDimensions(this.container.clientWidth, this.container.clientHeight, this.contentW, this.contentH);
		},
		touchStart: function touchStart(e) {
			// 如果在表单元素上发生初始化，则不要做出反应
			if (e.target.tagName.match(/input|textarea|select/i)) {
				return;
			}
			this.scroller.doTouchStart(e.touches, e.timeStamp);
			this.$emit('on-touchstart', e);
		},
		touchMove: function touchMove(e) {
			e.preventDefault();
			this.scroller.doTouchMove(e.touches, e.timeStamp);
			this.$emit('on-touchmove', e);
		},
		touchEnd: function touchEnd(e) {
			this.scroller.doTouchEnd(e.timeStamp);
			this.$emit('on-touchend', e);
		},
		scrollEnd: function scrollEnd() {
			var position = this.scroller.getValues();
			this.$emit('on-scrollend', position);
		}
	},
	updated: function updated() {
		var _this = this;

		this.$nextTick(function () {
			_this.init();
			if (_this.autoResize) {
				_this.resize();
			}
		});
	},
	mounted: function mounted() {
		var _this2 = this;

		this.container = document.getElementById(this.containerId);
		this.content = this.container.firstChild;
		this.$nextTick(function () {
			_this2.scroller = new __WEBPACK_IMPORTED_MODULE_0__Scroller___default.a(__WEBPACK_IMPORTED_MODULE_1__render___default()(_this2.content), {
				scrollingX: _this2.scrollingX,
				scrollingY: _this2.scrollingY,
				animating: _this2.animating,
				animationDuration: _this2.animationDuration,
				bouncing: _this2.bouncing,
				locking: _this2.locking,
				paging: _this2.paging,
				snapping: _this2.snapping,
				zooming: _this2.zooming,
				minZoom: _this2.minZoom,
				maxZoom: _this2.maxZoom,
				scrollingComplete: _this2.scrollEnd
			});
			_this2.contentW = _this2.content.offsetWidth;
			_this2.contentH = _this2.content.offsetHeight;

			//初始化
			if (_this2.contentW || _this2.contentH) {
				_this2.init();
			}
		});
	},
	data: function data() {
		return {
			containerId: 'scroller-' + Math.random().toString(36).substring(3, 10),
			container: undefined,
			content: undefined,
			contentW: 0,
			contentH: 0,
			isInstall: false,
			scroller: undefined
		};
	}
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-toast',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		text: {
			type: String
		},
		time: {
			type: Number,
			default: 2000
		},
		position: {
			type: String,
			default: 'middle'
		}
	},
	computed: {
		transition: function transition() {
			if (this.position === 'top') {
				return 'v5-fade-from-top';
			}
			if (this.position === 'bottom') {
				return 'v5-fade-from-bottom';
			}

			return 'v5-fade';
		}
	},
	watch: {
		value: function value(val) {
			this.show = val;
		},
		show: function show(val) {
			var _this = this;

			this.$emit('input', val);
			if (val) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(function () {
					_this.show = false;
				}, this.time);
			}
		}
	},
	data: function data() {
		return {
			show: this.value
		};
	}
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_active__ = __webpack_require__(124);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-button',
	props: {
		text: {
			type: String
		},
		delay: {
			type: Number,
			default: 0
		}
	},
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_active__["a" /* default */]],
	methods: {
		next: function next(e) {
			var _this = this;

			setTimeout(function () {
				_this.$emit('on-click', e);
			}, this.delay);
		}
	}
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_uuid__ = __webpack_require__(68);

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-x-checklist',
	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_uuid__["a" /* default */]],
	props: {
		options: {
			type: Array
		},
		value: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		max: {
			type: Number,
			default: 3
		}
	},
	computed: {
		limit: function limit() {
			return this.currentValue.length > this.max;
		}
	},
	watch: {
		value: function value(val) {
			this.setCurrentValue(val);
		},
		options: function options(val) {
			this.createIndex(val);
		}
	},
	methods: {
		change: function change(item) {
			if (this.limit) {
				this.$emit('on-limit');
				this.currentValue.pop();
				return;
			}
			item['checked'] = !item['checked'];
			this.$emit('input', this.getValue());
		},
		isDisabled: function isDisabled(item) {
			if (item['checked']) {
				return false;
			}
			if (this.currentValue.length > this.max) {
				return true;
			}
			return false;
		},
		createIndex: function createIndex(arr) {
			var _this = this;

			arr.forEach(function (item) {
				//添加选中状态
				item['checked'] = _this.currentValue.indexOf(item.id) !== -1;
				//建立索引
				_this.indexing[item.id] = item;
			});
		},
		getValue: function getValue() {
			var _this2 = this;

			return this.currentValue.map(function (item) {
				return _this2.indexing[item];
			});
		},
		setCurrentValue: function setCurrentValue(arr) {
			var _this3 = this;

			this.currentValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default()(arr, function (item) {
				if (_this3.indexing[item.id]) {
					_this3.indexing[item.id]['checked'] = true;
				}
				return item.id;
			});
		}
	},
	data: function data() {
		return {
			indexing: {}, //索引
			currentValue: []
		};
	},
	created: function created() {
		//转换
		this.setCurrentValue(this.value);
		//生成列表数据索引
		this.createIndex(this.options);
	}
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-x-dialog',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		isMask: {
			type: Boolean,
			default: true
		},
		isLockScroll: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		value: function value(val) {
			this.show = val;
		}
	},
	methods: {
		lockScroll: function lockScroll(e) {
			if (this.isLockScroll) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
		clickMask: function clickMask() {
			this.$emit('on-click-mask');
		}
	},
	data: function data() {
		return {
			show: this.value
		};
	}
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_uuid__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'v5-x-radiolist',
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_uuid__["a" /* default */]],
	props: {
		options: {
			type: Array
		},
		value: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: {
		getValue: function getValue(id) {
			var _this = this;

			return [].find.call(this.options, function (item) {
				return item.id === _this.currentValue;
			});
		},
		change: function change() {
			this.$emit('input', this.getValue());
		}
	},
	watch: {
		value: function value(val) {
			this.currentValue = val['id'];
		},
		options: function options(val) {
			this.currentData = val;
		}
	},
	data: function data() {
		return {
			currentValue: this.value['id'],
			currentData: this.options
		};
	}
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nav__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_configData__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//





// import vconsole from 'vconsole';
// const vConsole = new vconsole();

/* harmony default export */ __webpack_exports__["default"] = ({
	name: "app",
	components: {
		Nav: __WEBPACK_IMPORTED_MODULE_1__components_nav___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["resumeType", "pagefromLog", "pagetypeLog", "pagefrom"])),
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			window.clickLog && window.clickLog("from=jlfb_fillout_normal_all" + _this.pagetypeLog);
			window.clickLog && window.clickLog("from=jlfb_fillout_normal" + _this.pagefromLog);

			/*
   *简历发布来源：微信：70百度：71头条：70支付宝：70
   */
			if ([70, 71].indexOf(parseInt(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('sourceid'), 10)) > -1) {
				window.clickLog && clickLog("from=page1_show");
			}
		}, 200);

		this.getConfigOtherData();
	},

	methods: {
		getConfigOtherData: function getConfigOtherData() {
			var _this2 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_configData__["a" /* getConfigOtherData */])().then(function (data) {
				_this2.$store.commit('SET_ALLCONFIGOTHERDATA', data);
			});
		}
	}
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_myInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_myInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_myInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			isError: false,
			majorTip: '专业名称',
			major: '',
			maxLength: 20,
			state: false // 填写状态
		};
	},
	created: function created() {
		this.gradmajor && this.checkMajor(this.gradmajor); // 初始化编辑数据
	},

	watch: {
		gradmajor: function gradmajor(val) {
			this.major = val;
		},
		eduIndex: function eduIndex(val) {
			this.gradmajor && this.checkMajor(this.gradmajor);
		}
	},
	methods: {
		majorClick: function majorClick(value) {
			// 第一次点击
			if (value === '') {
				this.isError = false;
				this.majorTip = '请输入专业名称2-20个汉字';
			}
		},
		checkMajor: function checkMajor(value) {
			this.major = value;
			if (value === '') {
				this.isError = true;
				this.majorTip = '专业名称';
				this.state = false;
			} else if (!__WEBPACK_IMPORTED_MODULE_1__util_config__["a" /* default */].majorReg.test(value)) {
				this.isError = true;
				this.majorTip = '只能填写2-20个汉字';
				this.state = false;
			} else {
				this.isError = false;
				this.majorTip = '专业名称';
				this.state = true;
			}
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradmajor',
				value: value,
				state: this.state
			});
		},

		// 点击保存检查为空
		checkNull: function checkNull() {
			this.checkMajor('');
		}
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['gradmajor', 'eduIndex']),
	components: {
		myInput: __WEBPACK_IMPORTED_MODULE_2__common_myInput___default.a
	}
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_myInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_myInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_myInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			isError: false,
			schoolTip: '学校名称',
			school: '',
			maxLength: 20,
			state: false // 填写状态
		};
	},
	created: function created() {
		this.gradschool && this.checkSchool(this.gradschool); // 初始化编辑数据
	},

	watch: {
		gradschool: function gradschool(val) {
			this.school = val;
		},
		eduIndex: function eduIndex(val) {
			this.gradschool && this.checkSchool(this.gradschool);
		}
	},
	methods: {
		schoolClick: function schoolClick(value) {
			// 第一次点击
			if (value === '') {
				this.isError = false;
				this.schoolTip = '请输入学校名称4-20个汉字';
			}
		},
		checkSchool: function checkSchool(value) {
			this.school = value;
			if (value === '') {
				this.isError = true;
				this.schoolTip = '学校名称';
				this.state = false;
			} else if (!__WEBPACK_IMPORTED_MODULE_1__util_config__["a" /* default */].schoolReg.test(value)) {
				this.isError = true;
				this.schoolTip = '只能填写4-20个汉字';
				this.state = false;
			} else {
				this.isError = false;
				this.schoolTip = '学校名称';
				this.state = true;
			}
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradschool',
				value: value,
				state: this.state
			});
		},

		// 点击保存检查为空
		checkNull: function checkNull() {
			this.checkSchool('');
		}
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['gradschool', 'eduIndex']),
	components: {
		myInput: __WEBPACK_IMPORTED_MODULE_2__common_myInput___default.a
	}
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_selectScroll__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_selectScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_selectScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			showBox: false, // 日期控件展示标志
			showTip: false, // 显示提示信息
			time: '', // 当前选中的日期
			timeTip: '毕业时间', // 提示信息
			DateObj: {
				title: '请选择您毕业的时间',
				btnText: '确定',
				selectedText: '请选择'
			},
			DateArray: [{
				selectedIndex: __WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduYearList.length - 1,
				list: ['', ''].concat(__WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduYearList).concat(['', ''])
			}, {
				selectedIndex: 0,
				list: ['', ''].concat(__WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduMonthList).concat(['', ''])
			}]
		};
	},
	created: function created() {
		if (this.pagefrom === 'fromCQXZ') {
			this.DateArray[0].selectedIndex = __WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduYearList.length - 6; // 重庆校招毕业时间默认当年
		}
		// 日期初始化
		var originTime = this.gradtime.split('年');
		if (originTime.length > 1) {
			var yearIndex = __WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduYearList.findIndex(function (el) {
				return el === originTime[0] + '\u5E74';
			});
			var monthIndex = __WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].eduMonthList.findIndex(function (el) {
				return el === originTime[1];
			});
			this.scrollEnd(yearIndex, 0);
			this.scrollEnd(monthIndex, 1);
			this.checkTime();
		}
	},

	watch: {
		gradtime: function gradtime(val) {
			this.time = val;
		},
		time: function time(val) {
			this.showTip = !!val;
		}
	},
	methods: {
		/**
   * 日期控件展示
   */
		showPopup: function showPopup() {
			this.showBox = true;
			this.checkTime();
		},

		/**
   * 滚动结束触发选择
   */
		scrollEnd: function scrollEnd(select, index) {
			this.$set(this.DateArray[index], 'selectedIndex', select); // 更新选择项的index
			this.time = this.getTime;
			this.checkTime();
		},
		checkTime: function checkTime() {
			this.time = this.getTime;
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradtime',
				value: this.time,
				state: true
			});
		},

		/**
   * 关闭控件
   */
		finishSelect: function finishSelect() {
			this.showBox = false;
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['gradtime', 'pagefrom']), {
		// 日期格式化
		getTime: function getTime() {
			var yearIndex = this.DateArray[0].selectedIndex + 2,
			    monthIndex = this.DateArray[1].selectedIndex + 2;
			return '' + this.DateArray[0].list[yearIndex] + this.DateArray[1].list[monthIndex];
		}
	}),
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_popup___default.a,
		selectScroll: __WEBPACK_IMPORTED_MODULE_3__common_selectScroll___default.a
	}
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_toast__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gradSchool__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gradSchool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__gradSchool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gradMajor__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gradMajor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__gradMajor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gradTime__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gradTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gradTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_eduMixin__ = __webpack_require__(92);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			nameObj: {
				gradschool: '学校名称',
				gradmajor: '专业名称',
				gradtime: '毕业时间'
			},
			errorTip: false,
			errorInfo: '',
			showStay: false,
			showLimit: false,
			time: 1500
		};
	},

	mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_eduMixin__["a" /* default */]],
	mounted: function mounted() {
		// 添加按下态监听
		var basicList = Array.prototype.slice.call(document.getElementsByClassName('basic-info-detail'));
		basicList.forEach(function (item, index) {
			item.addEventListener('touchstart', function (e) {
				this.parentNode.className += ' item-active';
			});
			item.addEventListener('touchmove', function (e) {
				this.parentNode.className = this.parentNode.className.replace(/item-active/g, '');
			});
			item.addEventListener('touchend', function (e) {
				this.parentNode.className = this.parentNode.className.replace(/item-active/g, '');
			});
		});
	},

	methods: {
		/**
   * 保存教育经历
   */
		saveEdu: function saveEdu() {
			if (this.educationOk) {
				if (this.eduIndex === -1) {
					// 新增保存
					this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["g" /* CHECK_BASICINFO */], {
						key: 'educations',
						value: this.getAddEdu,
						state: true
					});
				} else {
					// 编辑保存
					this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["g" /* CHECK_BASICINFO */], {
						key: 'educations',
						value: this.getEditEdu,
						state: true
					});
				}
				// 保存教育经历埋点
				window.clickLog && window.clickLog('from=xiaozhao_resumecreate1_education_complete');
				// 重置当前数据
				this.resetEdu();
			} else {
				for (var prop in this.educationCheck) {
					if (this.educationCheck.hasOwnProperty(prop) && !this.educationCheck[prop]) {
						this.errorInfo = '您的' + this.nameObj[prop] + '填写有误，请修改';
						this.errorTip = true;
						break;
					}
					if (this.educations.length === 0) {
						this.errorInfo = '您的教育经历未添加，请添加';
						this.errorTip = true;
					}
				}
			}
		},

		/**
   * 删除教育经历
   */
		deleteEdu: function deleteEdu() {
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["g" /* CHECK_BASICINFO */], {
				key: 'educations',
				value: this.getDeleteEdu,
				state: JSON.parse(this.getDeleteEdu).length > 0
			});
			this.resetEdu();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['educationCheck', 'educations', 'gradschool', 'gradmajor', 'gradtime', 'eduState', 'eduIndex', 'educationOk']), {
		/**
   * 新增教育经历数据
   */
		getAddEdu: function getAddEdu() {
			var addEdu = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.educations));
			addEdu.push({
				id: this.educations.length,
				school: this.gradschool,
				professional: this.gradmajor,
				startDate: '',
				endDate: this.getTime
			});
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(addEdu);
		},

		/**
   * 编辑教育经历数据
   */
		getEditEdu: function getEditEdu() {
			var editEdu = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.educations));
			editEdu[this.eduIndex] = {
				id: this.eduIndex,
				school: this.gradschool,
				professional: this.gradmajor,
				startDate: '',
				endDate: this.getTime
			};
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(editEdu);
		},

		/**
   * 删除教育经历数据
   */
		getDeleteEdu: function getDeleteEdu() {
			var _this = this;

			var editEdu = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.educations));
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(editEdu.filter(function (el, n) {
				return n !== _this.eduIndex;
			}));
		},

		/**
   * 是否可点击
   */
		noRight: function noRight() {
			return !this.gradschool || !this.gradmajor || !this.gradtime;
		},

		/**
   * 格式化毕业时间
   */
		getTime: function getTime() {
			var timeArr = this.gradtime.split('年');
			if (timeArr.length > 1) {
				var year = timeArr[0];
				var month = timeArr[1].split('月')[0];
				return year + '-' + month + '-01';
			} else {
				return '';
			}
		}
	}),
	components: {
		GradSchool: __WEBPACK_IMPORTED_MODULE_6__gradSchool___default.a,
		GradMajor: __WEBPACK_IMPORTED_MODULE_7__gradMajor___default.a,
		GradTime: __WEBPACK_IMPORTED_MODULE_8__gradTime___default.a,
		Toast: __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_toast___default.a
	}
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['eduList', 'index', 'eduLength'],
	methods: {
		/**
   * 进入教育经历编辑状态
   */
		editEdu: function editEdu() {
			window.scrollTo(0, document.documentElement.clientHeight);
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduIndex',
				value: this.index
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduState',
				value: 2
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradschool',
				value: this.eduList.school,
				state: true
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradmajor',
				// value: this.eduList.profession || this.eduList.professional,
				value: this.eduList.professional,
				state: true
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* CHECK_EDUINFO */], {
				key: 'gradtime',
				value: this.getTime,
				state: true
			});
		}
	},
	computed: {
		/**
   * 格式化毕业时间
   */
		getTime: function getTime() {
			var timeArr = this.eduList.endDate.split('-');
			return timeArr.length > 1 ? timeArr[0] + '\u5E74' + timeArr[1] + '\u6708' : '';
		}
	}
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eduList__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eduList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eduList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eduAdd__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eduAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__eduAdd__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		/**
   * 进入新增状态
   */
		addEdu: function addEdu() {
			window.scrollTo(0, document.documentElement.clientHeight);
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduState',
				value: 1
			});
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* CHANGE_EDUTION */], {
				key: 'eduIndex',
				value: -1
			});
			// 新增教育经历点击埋点
			window.clickLog && window.clickLog('from=xiaozhao_resumecreate_addeducation');
		}
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['educations', 'eduIndex', 'eduState']),
	components: {
		EduList: __WEBPACK_IMPORTED_MODULE_2__eduList___default.a,
		EduAdd: __WEBPACK_IMPORTED_MODULE_3__eduAdd___default.a
	}
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectScroll__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_selectScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			showBox: false,
			selectedItem: 0,
			hasSelectedNum: 0,
			btnText: "确定",
			multSelectArray: [{
				key: "birthday",
				name: "出生年份",
				title: "请选择您的出生年份",
				list: ["", ""].concat(__WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].birthdayList).concat(["", ""]),
				selectedIndex: 37, // 默认23岁（1995年）
				selectedText: "请选择",
				hasSelected: false,
				isError: false // 为空时错误标注
			}, {
				key: "education",
				name: "最高学历",
				title: "请选择您的最高学历",
				list: ["", ""].concat(__WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].educationList).concat(["", ""]),
				selectedIndex: 3, // 默认大专
				selectedText: "请选择",
				hasSelected: false,
				isError: false
			}, {
				key: "workyears",
				name: "工作时间",
				title: "请选择您参加工作的时间",
				list: ["", ""].concat(__WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].experienceList).concat(["", ""]),
				selectedIndex: 4, // 默认选择3-5年
				selectedText: "请选择",
				hasSelected: false,
				isError: false
			}]
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(["birthday", "education", "workyears", "pagetypeLog", "educations", "pagefrom"])),
	watch: {
		// 默认渲染上一份简历信息
		birthday: function birthday(val) {
			this.setBirthday(val);
		},
		education: function education(val) {
			this.setEducation(val);
		},
		workyears: function workyears(val) {
			this.setWorkyears(val);
		},


		// 深度监控
		multSelectArray: {
			handler: function handler(curVal, oldVal) {
				if (this.hasSelectedNum < 3) {
					var num = 0;
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(curVal), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var item = _step.value;

							if (item.hasSelected) {
								num++;
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					this.hasSelectedNum = num;
				}
				this.setEduState();
			},

			deep: true
		},
		hasSelectedNum: function hasSelectedNum(val) {
			if (val === 3) {
				this.btnText = "完成";
			}
		}
	},
	created: function created() {
		if (this.pagefrom === 'fromCQXZ' && this.multSelectArray.length > 2) {
			this.multSelectArray[2].selectedIndex = 1; // 重庆校招默认选应届生
		}
		// 若有值初始化
		if (this.birthday) {
			this.setBirthday(this.birthday);
		}
		if (this.education) {
			this.setEducation(this.education);
		}
		if (this.workyears) {
			this.setWorkyears(this.workyears);
		}
		this.setEduState();
	},

	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default.a,
		selectScroll: __WEBPACK_IMPORTED_MODULE_4__common_selectScroll___default.a
	},
	methods: {
		/**
   * 设置教育经历必填状态
   * !【大专及以上 + 校招 + 应届生】状态置为 true
   *  【大专及以上 + 校招 + 应届生 + educations.length > 0】状态置为 true
   */
		setEduState: function setEduState() {
			var eduflag = this.education > 3 && (this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") && this.workyears === 5;
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["g" /* CHECK_BASICINFO */], {
				key: "educations",
				value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.educations),
				state: !eduflag || eduflag && this.educations.length > 0
			});
		},

		// 默认渲染上一份简历信息
		setBirthday: function setBirthday(val) {
			var defaultText = val.split("-")[0] + "年",
			    birthdaySelect = this.multSelectArray[0],
			    index = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].birthdayList.indexOf(defaultText);

			this.$set(birthdaySelect, "selectedIndex", index);
			this.$set(birthdaySelect, "selectedText", defaultText);
			this.$set(birthdaySelect, "hasSelected", true);
		},
		setEducation: function setEducation(val) {
			var index = val - 1,
			    // 教育经历从1开始
			educationSelect = this.multSelectArray[1],
			    defaultText = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].educationList[index];

			this.$set(educationSelect, "selectedIndex", index);
			this.$set(educationSelect, "selectedText", defaultText);
			this.$set(educationSelect, "hasSelected", true);
		},
		setWorkyears: function setWorkyears(val) {
			var index = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].experienceArray.indexOf(val),
			    defaultText = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].experienceList[index],
			    experienceSelect = this.multSelectArray[2];

			this.$set(experienceSelect, "selectedIndex", index);
			this.$set(experienceSelect, "selectedText", defaultText);
			this.$set(experienceSelect, "hasSelected", true);
		},

		// end

		hidePopup: function hidePopup() {
			this.showBox = false;
		},
		showPopup: function showPopup() {
			this.showBox = true;
		},
		chooseItem: function chooseItem(index) {
			this.selectedItem = index;
			this.scrollEnd(this.multSelectArray[index].selectedIndex); // 初始化选择

			if (!this.showBox) {
				this.showBox = true;
			}

			this.clickLog(index, "click");
		},
		nextSelect: function nextSelect(selectedItem) {
			// 已全部选完
			if (this.hasSelectedNum === 3) {
				this.showBox = false;
			} else {
				var nextNoSelect = selectedItem + 1;
				if (nextNoSelect > 2) {
					// 没有全选完，但选到了最后面一个，跳转到未选择项
					nextNoSelect = 0;
				}

				// 如果该项已经选择，则进行递归
				if (this.multSelectArray[nextNoSelect].hasSelected) {
					this.nextSelect(nextNoSelect);
				} else {
					this.chooseItem(nextNoSelect);
				}
			}
		},
		scrollEnd: function scrollEnd(index) {
			var selectedIndex = index + 2,
			    // 实际选择项
			selectedOption = this.multSelectArray[this.selectedItem],
			    // 当前选择的item
			selectedValue = ""; // 选择项的值(默认为对应的index)

			this.$set(selectedOption, "selectedText", selectedOption.list[selectedIndex]); // 更新选择项的text
			this.$set(selectedOption, "selectedIndex", index); // 更新选择项的index
			this.$set(selectedOption, "hasSelected", true); // 更新选择项的状态

			// 如果是工作经验或出生年份，提交的字段值进行转换
			switch (selectedOption.key) {
				case "birthday":
					var birthdayText = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].birthdayList[index];
					selectedValue = birthdayText.substring(0, birthdayText.length - 1) + "-01-01";
					break;
				case "workyears":
					selectedValue = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* default */].experienceArray[index];
					break;
				case "education":
					// 教育经历从1开始
					selectedValue = index + 1;
					break;
			}

			//  检查是否已填写完整
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["g" /* CHECK_BASICINFO */], {
				key: selectedOption.key,
				value: selectedValue,
				state: true
			});
		},
		checkNull: function checkNull(item) {
			// 没有填写项对应的index
			var index = ["birthday", "education", "workyears"].indexOf(item);
			this.$set(this.multSelectArray[index], "isError", true); // 置为error状态

			this.clickLog(index, "error");
		},
		clickLog: function clickLog(index, type) {
			if (type === "click") {
				switch (index) {
					case 0:
						window.clickLog && window.clickLog("from=jl_birthdayclick" + this.pagetypeLog);
						break;
					case 1:
						window.clickLog && window.clickLog("from=jl_degreeclick" + this.pagetypeLog);
						break;
					case 2:
						window.clickLog && window.clickLog("from=jl_workyearclick" + this.pagetypeLog);
						break;
				}
			} else if (type === "error") {
				switch (index) {
					case 0:
						window.clickLog && window.clickLog("from=jl_birthdaymiss" + this.pagetypeLog);
						break;
					case 1:
						window.clickLog && window.clickLog("from=jl_degreemiss" + this.pagetypeLog);
						break;
					case 2:
						window.clickLog && window.clickLog("from=jl_workyearmiss" + this.pagetypeLog);
						break;
				}
			}
		}
	}
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: {
			type: Boolean,
			default: false
		},
		dataUrl: {
			type: String,
			default: '' // 转base64码后的data字段
		}
	},
	data: function data() {
		return {
			isIOS: navigator.userAgent.match(/iphone/i),
			showBox: false,
			overlayTopClass: 'img-top-default',
			overlayBottomClass: 'img-bottom-default',
			overlayClass: '',
			imgWidth: 'auto',
			imgHeight: 'auto',
			isWidthImg: false,
			toTop: 0,
			toLeft: 0,
			$img: '',
			$container: '',
			$overlay: '',
			$overlayTop: '',
			imageDom: new Image(),
			scale: 0.5, // 压缩系数
			overlayTop: 0, // overlay到顶部距离
			overlayTopheight: 0, // 顶部遮罩层高度
			clientWidth: document.documentElement.clientWidth, // 设备宽度
			clientHeight: document.documentElement.clientHeight, // 设备高度
			event_state: {} // Save the initial event details and container state
		};
	},

	watch: {
		value: function value(val) {
			this.showBox = val;
		},
		showBox: function showBox(val) {
			this.$emit('input', val);
		},
		dataUrl: function dataUrl(val) {
			if (val) {
				this.initCanvas();
			}
		}
	},
	mounted: function mounted() {
		this.$container = this.$refs.container;
		this.$img = this.$refs.img;
		this.$overlay = this.$refs.overlay;
		this.$overlayTop = this.$refs.overlayTop;
		// 适配
		var ratio = this.clientWidth / this.clientHeight;
		if (ratio > 0.7) {
			this.overlayTopClass = 'img-top-short';
			this.overlayBottomClass = 'img-bottom-short';
			this.overlayClass = 'overlay-short';
		}
		this.initCanvas();
	},

	methods: {
		initCanvas: function initCanvas() {
			var _this = this;

			if (this.dataUrl) {
				// ios传来的是url，需要image设置允许跨域
				if (this.isIOS) {
					this.imageDom.setAttribute('crossOrigin', 'Anonymous');
				}
				this.imageDom.src = this.dataUrl;
				this.imageDom.onload = function () {
					_this.overlayTop = _this.$overlay.getBoundingClientRect().top;
					_this.overlayTopheight = _this.$overlayTop.getBoundingClientRect().height;

					var width = _this.$img.width,
					    height = _this.$img.height;

					if (height < width) {
						_this.isWidthImg = true;
						_this.imgHeight = '100vw';
						_this.imgWidth = 'auto';
						_this.toTop = _this.overlayTopheight;
					} else {
						_this.isWidthImg = false;
						_this.imgWidth = '100%';
						_this.imgHeight = 'auto';
						_this.toLeft = 0;
					}
				};
			}
		},
		startMoving: function startMoving(e) {
			e.preventDefault();
			e.stopPropagation();
			this.saveEventState(e);
		},
		moving: function moving(e) {
			var touches = void 0,
			    mouse = {},
			    left = 0,
			    top = 0;
			e.preventDefault();
			e.stopPropagation();

			touches = e.touches;
			if (this.isWidthImg) {
				var imgWidth = this.$img.getBoundingClientRect().width,
				    minLeft = this.clientWidth - imgWidth;

				mouse.x = (e.clientX || e.pageX || touches[0].clientX) + document.body.scrollLeft;

				left = mouse.x - (this.event_state.mouse_x - this.event_state.container_left);
				// 防止左右超出裁剪框
				if (left > 0) {
					this.toLeft = 0;
				} else if (left < minLeft) {
					this.toLeft = minLeft;
				} else {
					this.toLeft = left;
				}
			} else {
				var minTop = this.clientWidth - this.$img.getBoundingClientRect().height + this.overlayTop;

				mouse.y = (e.clientY || e.pageY || touches[0].clientY) + document.body.scrollTop;
				top = mouse.y - (this.event_state.mouse_y - this.event_state.container_top);
				// 防止上下超出裁剪框
				if (top > this.overlayTopheight) {
					this.toTop = this.overlayTopheight;
				} else if (top < minTop) {
					this.toTop = minTop;
				} else {
					this.toTop = top;
				}
			}
		},
		endMoving: function endMoving(e) {
			e.preventDefault();
		},
		saveEventState: function saveEventState(e) {
			// Save the initial event details and container state
			this.event_state.container_width = this.$container.getBoundingClientRect().width;
			this.event_state.container_height = this.$container.getBoundingClientRect().height;
			this.event_state.container_left = this.$container.getBoundingClientRect().left;
			this.event_state.container_top = this.$container.getBoundingClientRect().top;
			this.event_state.mouse_x = (e.clientX || e.pageX || e.touches[0].clientX) + document.body.scrollLeft;
			this.event_state.mouse_y = (e.clientY || e.pageY || e.touches[0].clientY) + document.body.scrollTop;

			this.event_state.evnt = e;
		},
		cancel: function cancel() {
			this.showBox = false;
			this.$emit('chooseOther');
		},
		croper: function croper() {
			var cropCanvas = void 0,
			    left = 0,
			    top = 0,
			    width = this.$overlay.getBoundingClientRect().width,
			    height = this.$overlay.getBoundingClientRect().height,
			    widthP = this.imageDom.width / this.clientWidth,
			    heightP = this.imageDom.height / this.clientWidth;
			if (this.isWidthImg) {
				left = -this.$container.getBoundingClientRect().left;
				left = left * heightP;
				width = width * heightP;
				height = height * heightP;
			} else {
				top = this.overlayTop - this.$container.getBoundingClientRect().top;
				top = top * widthP;
				width = width * widthP;
				height = height * widthP;
			}

			cropCanvas = document.createElement('canvas');
			cropCanvas.width = width;
			cropCanvas.height = height;
			cropCanvas.getContext('2d').drawImage(this.imageDom, left, top, width, height, 0, 0, width, height);
			this.$emit('afterCrop', cropCanvas.toDataURL('image/jpeg', 0.5));
		}
	}
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_components_popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_components_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_components_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectBox__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__selectBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__preview__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cutImg__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cutImg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cutImg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FixDirect__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(1);





 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import uploadImg from './uploadImg';
// import gaussVag from '../../../util/gaussVag';



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_components_popup___default.a,
		Toast: __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast___default.a,
		Loading: __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading___default.a,
		selextBox: __WEBPACK_IMPORTED_MODULE_6__selectBox___default.a,
		preview: __WEBPACK_IMPORTED_MODULE_7__preview___default.a,
		cutImg: __WEBPACK_IMPORTED_MODULE_8__cutImg___default.a
	},
	data: function data() {
		return {
			dataUrl: "",
			showImg: false, // 是否有头像
			imgTip: "头像，一个好工作的开始",
			showSelectBox: false,
			showPreview: false,
			showCutBox: false,
			showToast: false,
			showLoading: false,
			toastTip: "头像上传成功",
			maxSize: 10, // 文件大小限制
			time: 1000,
			isIOS: navigator.userAgent.match(/iphone/i)
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])(["pic", "uploadState", "originPic", "pagetypeLog"])),
	watch: {
		pic: function pic(val) {
			this.setPic(val);
		},
		originPic: function originPic(val) {
			if (val) {
				this.dataUrl = val;
			}
		}
	},
	mounted: function mounted() {
		this.setPic(this.pic);
	},

	methods: {
		setPic: function setPic(val) {
			var _this = this;

			if (val !== "") {
				this.$refs.img.onload = function () {
					_this.showImg = true;
					// gaussVag(val); // 模糊背景
					window.clickLog && window.clickLog("from=post_jianli_zhaopiansuccess_pre_new" + _this.pagetypeLog);
				};
			}
		},
		imgBtnClick: function imgBtnClick() {
			window.clickLog && window.clickLog("from=post_jianli_zhaopian_new" + this.pagetypeLog);
			if (this.pic === "") {
				this.showSelectBox = true;
			} else {
				this.showPreview = true;
			}
		},
		changImg: function changImg() {
			this.showPop();
		},
		showPop: function showPop() {
			this.showSelectBox = true;
		},
		hidePop: function hidePop() {
			this.showSelectBox = false;
		},
		choose58pic: function choose58pic(imgUrl) {
			this.showSelectBox = false;
			this.chooseImg(imgUrl);
		},
		chooseImg: function chooseImg(imgUrl) {
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["j" /* CHANGE_BASICINFO */], {
				key: "pic",
				value: imgUrl
			});
			this.toastTip = "头像上传成功";
			this.showToast = true;
		},
		chooseOther: function chooseOther() {
			this.showSelectBox = true;
			this.dataUrl = "";
		},

		// 选择本地图片
		imgSelect: function imgSelect(file) {
			var self = this;
			// 文件类型和大小控制
			if (!/^image/.test(file.type)) {
				this.toastTip = "图片格式有误";
				this.showToast = true;
				return false;
			} else if (file.size > this.maxSize * 1024 * 1024) {
				this.toastTip = "\u56FE\u7247\u4E0D\u80FD\u5927\u4E8E" + this.maxSize + "M";
				this.showToast = true;
				return false;
			}

			// 看支持不支持FileReader
			if (!window.FileReader) {
				this.toastTip = "请升级浏览器或选择其他浏览器";
				this.showToast = true;
				return;
			}

			this.showLoading = true;

			// 旋转ios/三星手机竖图片
			var fixDirect = new __WEBPACK_IMPORTED_MODULE_9__FixDirect__["a" /* default */]();
			fixDirect.init(file, function (base64Data) {
				// 如果是IOS，上传之后再裁剪
				if (self.isIOS) {
					self.uploadImg(base64Data);
				} else {
					self.showLoading = false;
					self.dataUrl = base64Data;
					self.showCutBox = true;
				}
			});
			this.showSelectBox = false;
		},

		// IOS上传原图
		uploadImg: function uploadImg(dataUrl) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(dataUrl === "")) {
									_context.next = 4;
									break;
								}

								_this2.toastTip = "图片解析有误，请重新选择一张图片";
								_this2.showToast = true;
								return _context.abrupt("return");

							case 4:
								_context.next = 6;
								return _this2.$store.dispatch("uploadImg", {
									dataUrl: dataUrl,
									isOrigin: true
								});

							case 6:
								// 上传成功，显示裁剪框
								_this2.showLoading = false;
								if (_this2.originPic !== "") {
									_this2.showCutBox = true;
								} else {
									_this2.toastTip = "头像选择失败";
									_this2.showToast = true;
								}

							case 8:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},

		// 裁剪之后上传
		submit: function submit(dataUrl) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(dataUrl === "")) {
									_context2.next = 4;
									break;
								}

								_this3.toastTip = "图片解析有误，请重新选择一张图片";
								_this3.showToast = true;
								return _context2.abrupt("return");

							case 4:
								_this3.showLoading = true;
								_context2.next = 7;
								return _this3.$store.dispatch("uploadImg", {
									dataUrl: dataUrl,
									isOrigin: false
								});

							case 7:
								_this3.showCutBox = false;
								_this3.showLoading = false;
								if (_this3.uploadState) {
									_this3.toastTip = "头像上传成功";
								} else {
									_this3.toastTip = "头像上传失败";
								}
								_this3.showToast = true;

							case 11:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		}
	}
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			showBox: false,
			imgUrl: '',
			imgClass: ''
		};
	},

	watch: {
		value: function value(val) {
			this.showBox = val;
		},
		showBox: function showBox(val) {
			this.$emit('input', val);
		},
		imgSrc: function imgSrc(val) {
			// 默认头像,大图展示为200*200的图片
			var array = val.split('/');
			if (array.indexOf('img.58cdn.com.cn') > -1) {
				this.imgUrl = val.replace('_126.png', '_200.png');
			} else {
				this.imgUrl = val;
			}
		}
	},
	mounted: function mounted() {
		var clientWidth = document.documentElement.clientWidth,
		    clientHeight = document.documentElement.clientHeight;

		if (clientWidth / clientHeight > 0.65) {
			this.imgClass = 'picture-short';
		}
	},

	methods: {
		hideBox: function hideBox() {
			this.showBox = false;
		},
		changeImg: function changeImg() {
			this.hideBox();
			this.$emit('changImg');
		}
	}
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			showSelect: false,
			showVirtual: false,
			selectedItem: '',
			file: '', // 本地图片文件
			items: ['//img.58cdn.com.cn/m58/img/man1_126.png', '//img.58cdn.com.cn/m58/img/man2_126.png', '//img.58cdn.com.cn/m58/img/man3_126.png', '//img.58cdn.com.cn/m58/img/man4_126.png', '//img.58cdn.com.cn/m58/img/woman1_126.png', '//img.58cdn.com.cn/m58/img/woman2_126.png', '//img.58cdn.com.cn/m58/img/woman3_126.png', '//img.58cdn.com.cn/m58/img/woman4_126.png']
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user58pic'])),
	watch: {
		value: function value(val) {
			this.showSelect = val;
		}
	},
	methods: {
		hidePop: function hidePop() {
			this.$emit('hidePop');
		},
		selectUserPic: function selectUserPic() {
			this.$emit('choose58pic', this.user58pic);
		},
		showVirtualBox: function showVirtualBox() {
			this.showSelect = false;
			this.showVirtual = true;
		},
		chooseVirtual: function chooseVirtual(imgUrl, index) {
			if (index !== this.selectedItem) {
				this.selectedItem = index;
				this.$emit('chooseImg', imgUrl);
			}
		},
		backSelect: function backSelect() {
			this.showVirtual = false;
			this.showSelect = true;
		},
		handleFileChange: function handleFileChange(e) {
			// 选择文件的base64
			// if (typeof e.target === 'undefined') {
			// 	this.file = e[0];
			// } else {
			// 	this.file = e.target.files[0];
			// }

			// 选择文件
			this.file = this.$refs.inputer.files[0];
			if (!this.file) {
				return;
			}

			this.$emit('imgSelect', this.file);
		}
	}
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_toast__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loginGuide__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loginGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loginGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headPortrait__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__headPortrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__name__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sex__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobile_mobile__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobile_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mobile_mobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mobile_loginCaptcha__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mobile_loginCaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mobile_loginCaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__experience__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__experience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__experience__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__education__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__education___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__education__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoadSDK__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LimitFn__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_myDialog__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_myDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_myDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_cookie__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_js_cookie__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_backAlert__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_eduMixin__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    loginGuide: __WEBPACK_IMPORTED_MODULE_2__loginGuide___default.a,
    headPortrait: __WEBPACK_IMPORTED_MODULE_3__headPortrait___default.a,
    name: __WEBPACK_IMPORTED_MODULE_4__name___default.a,
    sex: __WEBPACK_IMPORTED_MODULE_5__sex___default.a,
    mobile: __WEBPACK_IMPORTED_MODULE_6__mobile_mobile___default.a,
    loginCaptcha: __WEBPACK_IMPORTED_MODULE_7__mobile_loginCaptcha___default.a,
    experience: __WEBPACK_IMPORTED_MODULE_8__experience___default.a,
    myEducation: __WEBPACK_IMPORTED_MODULE_9__education___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_toast___default.a,
    myDialog: __WEBPACK_IMPORTED_MODULE_12__common_myDialog___default.a
  },
  data: function data() {
    return {
      nameObj: {
        truename: "姓名",
        gender: "性别",
        mobile: "手机号",
        keyCode: "验证码",
        birthday: "出生年份",
        education: "最高学历",
        workyears: "工作时间",
        educations: "教育经历"
      },
      errorTip: false,
      errorInfo: "",
      showStay: false,
      showLimit: false,
      time: 1500,
      limitObj: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_eduMixin__["a" /* default */]],
  created: function created() {
    this.limitObj = new __WEBPACK_IMPORTED_MODULE_11__LimitFn__["a" /* LimitFn */](this.pagefromUrl, this.$v5);

    // 加载sdk
    var loadSDK = new __WEBPACK_IMPORTED_MODULE_10__LoadSDK__["a" /* LoadSDK */]();
    loadSDK[this.pagefrom] && loadSDK[this.pagefrom]();

    var ppu = __WEBPACK_IMPORTED_MODULE_16__util__["a" /* default */].getParamVal("ppu"); //已登录进入，URL中携带PPU信息，将PPU信息写入cookie
    if (ppu) {
      __WEBPACK_IMPORTED_MODULE_15_js_cookie___default.a.set('PPU', decodeURIComponent(ppu), { domain: '58.com', expires: 7 }); // 小程序跳转来的设置登录态

      // 更改登录状态
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_19__store_mutation_types__["d" /* CHANGE_LOGINSTATE */], true);
    }

    if (this.isLogin) {
      // 获取简历份数
      this.$store.dispatch("getResumeCount", __WEBPACK_IMPORTED_MODULE_14__util_cookie__["a" /* default */].getname("PPU", "UID"));

      if (this.areaInfo.length < 1) {
        // 获取上一份简历基本信息
        this.$store.dispatch("getLastResumeInfo");

        // 获取账号绑定的手机号
        this.$store.dispatch("checkMobileAuth");

        // 获取用户隐私设置
        this.$store.dispatch("getPrivacy");
      }
    }
    if (this.areaInfo.length < 1) {
      this.$store.dispatch("getAreaInfo");
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["a" /* mapGetters */])(["basicInfoOk", "basicInfo", "isLogin", "resumeType", "resumeCount", "jobUrl", "pagefromUrl", "pagefromLog", "pagetypeLog", "deliveryCode", "education", "workyears", "pagefrom", "areaInfo"]), {
    // 教育经历是否必填
    needEducation: function needEducation() {
      // 大专及以上 + 校招 + 应届生必填
      return this.education > 3 && (this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") && this.workyears === 5;
    }
  }),
  watch: {
    resumeCount: function resumeCount(val) {
      if (val < 3) {
        return;
      }
      // 当简历份数达到3份上限时则提示引导
      if (this.pagefrom == "default") {
        this.showLimit = true;
        return;
      }
      this.limitObj[this.pagefrom]();
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 挽留弹窗展现
    if (["fromWX", "fromBD", "fromZFB", "fromTT", "fromTZ"].indexOf(this.pagefrom) === -1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_backAlert__["a" /* default */])(function () {
        _this.showStay = true;
      }, this.pagefromLog);
    }

    // 添加按下态监听
    var basicList = Array.prototype.slice.call(document.getElementsByClassName("basic-info-detail")),
        sexList = Array.prototype.slice.call(document.getElementsByClassName("user-sex")),
        chooseList = Array.prototype.slice.call(document.getElementsByClassName("choose-detail")),
        DomList = basicList.concat(sexList, chooseList);

    DomList.forEach(function (item, index) {
      item.addEventListener("touchstart", function (e) {
        this.parentNode.className += " item-active";
      });
      item.addEventListener("touchmove", function (e) {
        this.parentNode.className = this.parentNode.className.replace(/item-active/g, "");
      });
      item.addEventListener("touchend", function (e) {
        this.parentNode.className = this.parentNode.className.replace(/item-active/g, "");
      });
    });
    // 渠道来源埋点
    var sourceid = __WEBPACK_IMPORTED_MODULE_16__util__["a" /* default */].getParamVal("sourceid");
    window.clickLog && window.clickLog("from=qudao_from_" + sourceid);

    // 校招来源埋点
    this.pagefrom === "fromXZ" && window.clickLog && window.clickLog("from=xiaozhao_resumecreate1_show");
    this.pagefrom === "fromCQXZ" && window.clickLog && window.clickLog("from=chongqingxiaozhao_resumecreate1_show");

    setTimeout(function () {
      //mp从小程序我的页面进入
      var fromPageName = __WEBPACK_IMPORTED_MODULE_16__util__["a" /* default */].getParamVal("platform") || "";
      if (_this.pagefrom === "fromWX" && fromPageName === "mp") {
        window.clickLog && window.clickLog("from=58yg_nojlpost_page1_show");
      } else if (_this.pagefrom === "fromWX") {
        window.clickLog && window.clickLog("from=58yg_jlpost_page1_show");
      }
    }, 200);
  },

  methods: {
    nextStep: function nextStep() {
      // 按钮点击，不区分可点击态
      window.clickLog && window.clickLog("from=jl_basicsaveall_all" + this.pagetypeLog);
      window.clickLog && window.clickLog("from=jl_basicsaveall" + this.pagefromLog);

      if (this.basicInfoOk) {
        //高亮
        /*
        *简历发布来源：微信：70百度：71头条：70支付宝：70
        */
        if ([70, 71].indexOf(parseInt(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* default */].getParamVal('sourceid'), 10)) > -1) {
          window.clickLog && clickLog("from=page1_save_click");
        }

        window.clickLog && window.clickLog("from=jl_basicsave_all" + this.pagetypeLog);
        window.clickLog && window.clickLog("from=jl_basicsave" + this.pagefromLog);

        // 校招来源保存埋点
        this.pagefrom === "fromXZ" && window.clickLog && window.clickLog("from=xiaozhao_resumecreate_save");
        this.pagefrom === "fromCQXZ" && window.clickLog && window.clickLog("from=chongqingxiaozhao_resumecreate_save");

        window.history.pushState({}, "", ""); // 防止跳转之后点击返回再次弹出提示框
        this.$router.push("expectation");
      } else {
        // 未填写的项进行错误提示
        var obj = this.basicInfo,
            isFirstError = true;

        for (var prop in obj) {
          // 第一个错误信息toast提示，错误样式处理只需触发为空的项
          if (isFirstError && obj.hasOwnProperty(prop) && !obj[prop]) {
            this.errorInfo = "您的" + this.nameObj[prop] + "填写有误，请修改";
            this.errorTip = true;
            isFirstError = false;
          }
          if (obj.hasOwnProperty(prop) && obj[prop] === null && prop !== "keyCode") {
            // 多选弹框
            if (prop === "birthday" || prop === "education" || prop === "workyears") {
              this.$refs.experience.checkNull(prop);
            } else if (prop === "mobile" && !this.isLogin) {
              this.$refs.loginMobile.checkNull();
            } else {
              this.$refs[prop].checkNull();
            }
          }
        }
      }
    },
    quit: function quit() {
      this.showStay = false;
      window.clickLog && window.clickLog("from=jianli_post_no_full" + this.pagefromLog);

      // 从发布完成页或完善页返回回来的再次点击回退需回退三步
      window.history.go(-1);
    },
    noQuit: function noQuit() {
      this.showStay = false;
      window.history.pushState({}, "", "");

      window.clickLog && window.clickLog("from=jianli_post_yes_full" + this.pagefromLog);
    },
    goMyResume: function goMyResume() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_13__util_config__["a" /* default */].jlDomain + "/resumeupdate/resumelist?from=publish";
    },
    goJobList: function goJobList() {
      if (this.resumeType === 3) {
        window.location.replace(this.pagefromUrl);
      } else {
        window.location.href = this.jobUrl;
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.resetEdu(); // 重置教育经历信息
    next();
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(14);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		login: function login() {
			window.clickLog && window.clickLog('from=fillout_micro_loginclk_new');
			var _fromurl = __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].getParamVal('from');
			window.location.href = '//m.m.58.com/login/?path=' + encodeURIComponent(_fromurl);
		}
	}
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_login__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			imgCode: '',
			imgCodeUrl: '',
			isError: false,
			errorInfo: '验证码输入错误'
		};
	},
	created: function created() {
		this.freshValidateCode();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['pagetypeLog'])),
	watch: {
		imgCode: function imgCode(val) {
			if (val.length === 4) {
				this.isError = false;
			}
		}
	},
	methods: {
		freshValidateCode: function freshValidateCode() {
			this.imgCodeUrl = __WEBPACK_IMPORTED_MODULE_1__util_login__["a" /* default */].freshValidateCode();
		},
		checkInput: function checkInput() {
			if (this.imgCode === '') {
				this.errorInfo = '请输入验证码';
				window.clickLog && window.clickLog('from=jl_tupiancode_wrong' + this.pagetypeLog);
			} else if (this.imgCode.length < 4) {
				this.errorInfo = '验证码输入错误';
				window.clickLog && window.clickLog('from=jl_tupiancode_wrong' + this.pagetypeLog);
			}
		},
		checkImgCode: function checkImgCode() {
			if (this.imgCode === '') {
				this.errorInfo = '请输入验证码';
				window.clickLog && window.clickLog('from=jl_tupiancode_wrong' + this.pagetypeLog);
			} else if (this.imgCode.length < 4) {
				this.errorInfo = '验证码输入错误';
				window.clickLog && window.clickLog('from=jl_tupiancode_wrong' + this.pagetypeLog);
			} else {
				this.$emit('getCheckCode', this.imgCode);
				this.errorInfo = '验证码输入错误';
			}
			this.isError = true;
		},
		cancel: function cancel() {
			this.$emit('closeImgBox');
		}
	}
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_login__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_cookie__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_myInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_myInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_myInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgCode__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    myInput: __WEBPACK_IMPORTED_MODULE_5__common_myInput___default.a,
    imgCode: __WEBPACK_IMPORTED_MODULE_6__imgCode___default.a
  },
  data: function data() {
    return {
      imgCodeUrl: "",
      showImgCodeBox: false,
      mobileLogin: undefined,

      inputType: "tel", // 输入框类型，默认展示数字键
      mobileTip: "输入手机号", // 手机号框
      mobile: "",
      mobileIsError: false,
      mobileMaxLength: 11,

      checkCodeTip: "请输入6位验证码", // 验证码框
      checkCode: "",
      checkCodeIsError: false,
      checkCodeMaxLength: 6,
      focusCheckCode: false,

      mobileRight: false, // 手机号是否正确
      getCheckCodeText: "获取验证码",
      btnState: "",
      showCheckCode: false, // 是否展示验证码框
      checkCodeState: false, // 验证码状态
      isIOS: navigator.userAgent.match(/iphone/i)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(["pagetypeLog", "pagefrom"])),
  methods: {
    // 手机号项点击
    mobileClick: function mobileClick(value) {
      if (value === "") {
        this.mobileIsError = false;
        this.mobileTip = "请输入11位手机号码";
      }
      window.clickLog && window.clickLog("from=jl_phonenumclk_nologin" + this.pagetypeLog);
    },


    // 手机号由正确状态改为错误状态时，隐藏获取验证码按钮
    mobileChange: function mobileChange(mobile) {
      if (mobile.length < 11) {
        this.mobileRight = false;
      }
    },


    // 检查手机号
    checkMobile: function checkMobile(value) {
      // 检查前默认将手机号填写状态置为false
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
        key: "mobile",
        value: value,
        state: false
      });
      if (value === "") {
        this.mobileIsError = true;
        this.mobileRight = false;
        this.mobileTip = "输入手机号";
        window.clickLog && window.clickLog("from=jl_phonenum_wrong" + this.pagetypeLog);
      } else if (!__WEBPACK_IMPORTED_MODULE_2__util_config__["a" /* default */].mobileReg.test(value)) {
        this.mobileIsError = true;
        this.mobileRight = false;
        this.mobileTip = "手机号码格式不对";
        window.clickLog && window.clickLog("from=jl_phonenum_wrong" + this.pagetypeLog);
      } else {
        // 百度小程序、头条小程序设置手机号认证通过
        if (this.pagefrom == "fromBD" || this.pagefrom == "fromTT") {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
            key: "mobile",
            value: value,
            state: true
          });
        }
        // 如果手机号输入达11位且正确，则进行检查认证
        this.mobileIsError = false;
        this.mobileRight = true;
        this.mobileTip = "手机号";
        this.mobile = value;
      }
    },


    // 验证码点击
    checkCodeClick: function checkCodeClick(value) {
      if (value === "") {
        this.checkCodeIsError = false;
        this.checkCodeTip = "请输入6位验证码";
      }
    },


    // 校验验证码
    verifyCheckCode: function verifyCheckCode(value) {
      var _this = this;

      // 检查前默认将手机号填写状态置为false
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
        key: "keyCode",
        value: value,
        state: false
      });
      if (value === "") {
        this.checkCodeIsError = true;
        this.checkCodeTip = "输入验证码";
        window.clickLog && window.clickLog("from=jl_numcode_wrong" + this.pagetypeLog);
      } else if (value.length < 6) {
        this.checkCodeState = false;
        this.checkCodeIsError = true;
        this.checkCodeTip = "请输入6位验证码";
        window.clickLog && window.clickLog("from=jl_numcode_wrong" + this.pagetypeLog);
      } else {
        //fix: 临时解决登录SDK和头条SDK冲问题
        //TODO: 推动登录SDK兼容eval被重置问题
        if (this.pagefrom == "fromTT" && !window.eval) {
          window.eval = function () {};
        }

        __WEBPACK_IMPORTED_MODULE_3__util_login__["a" /* default */].loginCommit(this.mobile, value).then(function (res) {
          // 登录成功,展示为手机号展示框
          if (res.code === 0) {
            // 获取该账号下的简历份数
            _this.$store.dispatch("getResumeCount", __WEBPACK_IMPORTED_MODULE_4__util_cookie__["a" /* default */].getname("PPU", "UID"));

            // 更改提交的手机号
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
              key: "mobile",
              value: _this.mobile,
              state: true
            });

            // 更改提交的验证码号
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
              key: "keyCode",
              value: _this.checkCode,
              state: true
            });

            // 更改认证状态
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["h" /* CHANGE_HASAUTHED */], {
              auth: true,
              authMobile: _this.mobile
            });

            // 存储登录使用的手机号
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["i" /* SET_HASAUTHEDMOBILE */], _this.mobile);

            // 更改登录状态
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["d" /* CHANGE_LOGINSTATE */], true);

            window.clickLog && window.clickLog("from=jl_numcode_right" + _this.pagetypeLog);
          } else {
            _this.checkCodeIsError = true;
            _this.checkCodeTip = "验证码输入错误";
            window.clickLog && window.clickLog("from=jl_numcode_wrong" + _this.pagetypeLog);
          }
        }).catch(function (e) {
          _this.checkCodeIsError = true;
          _this.checkCodeTip = "验证码输入错误";
          console.log(e);
        });
      }
    },


    // 获取手机验证码点击事件
    getCheckCode: function getCheckCode() {
      var _this2 = this;

      var imgCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (this.btnState === "") {
        // 当imgcode为空时为获取按钮点击
        if (imgCode === "") {
          window.clickLog && window.clickLog("from=jl_phonecode_btn" + this.pagetypeLog);
        }
        __WEBPACK_IMPORTED_MODULE_3__util_login__["a" /* default */].getAuthCode(this.mobile, imgCode).then(function (res) {
          // 发送成功
          if (res.code === 0) {
            _this2.showImgCodeBox = false;
            _this2.btnState = "disabled";
            _this2.countDown();
            _this2.showCheckCode = true;

            // 非ios时将焦点置于验证码框，ios不进行焦点转移
            if (_this2.isIOS) {
              _this2.checkCodeTip = "输入验证码";
            } else {
              _this2.focusCheckCode = true;
            }

            window.clickLog && window.clickLog("from=jl_numcode_show" + _this2.pagetypeLog);
            // 图片验证码正确（未登录态）
            if (imgCode !== "") {
              window.clickLog && window.clickLog("from=jl_tupiancode_right" + _this2.pagetypeLog);
            }
          } else if (res.code === 785 || res.code === 786) {
            // 图片验证码报错（未登录态）
            if (imgCode === "") {
              window.clickLog && window.clickLog("from=jl_tupiancode_show" + _this2.pagetypeLog);
            } else {
              window.clickLog && window.clickLog("from=jl_tupiancode_wrong" + _this2.pagetypeLog);
            }
            _this2.showImgCodeBox = true;
          } else {
            // 提示错误信息
            _this2.mobileTip = res.msg;
            _this2.mobileIsError = true;
          }
        });
      }
    },


    // 关闭图片验证码框
    closeImgBox: function closeImgBox() {
      this.showImgCodeBox = false;
    },


    // 按钮倒计时
    countDown: function countDown() {
      var _this3 = this;

      var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;

      if (wait === 0) {
        this.getCheckCodeText = "重新获取";
        this.btnState = "";
      } else {
        this.getCheckCodeText = "已发送" + wait + "s";
        wait--;
        setTimeout(function () {
          _this3.countDown(wait);
        }, 1000);
      }
    },


    // 点击保存检查为空
    checkNull: function checkNull() {
      this.checkMobile("");
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_myInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_myInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_myInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		myInput: __WEBPACK_IMPORTED_MODULE_5__common_myInput___default.a
	},
	data: function data() {
		return {
			inputType: "tel", // input框类型
			mobileTip: "输入手机号", // 手机号框
			mobile: "",
			mobileIsError: false,
			mobileMaxLength: 11,

			checkCodeTip: "请输入6位验证码", // 验证码框
			checkCode: "",
			checkCodeIsError: false,
			checkCodeMaxLength: 6,
			focusCheckCode: false, // 验证码获取焦点

			mobileRight: false, // 手机号是否正确
			getCheckCodeText: "获取验证码",
			timer: undefined,
			btnState: "",
			showCheckCode: false, // 是否展示验证码框
			checkCodeState: false, // 验证码状态
			mobileAuthState: false, // 手机号认证状态
			isIOS: navigator.userAgent.match(/iphone/i)
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(["hasAuthedMobile", "authMobile", "hasAuthed", "captcha", "getCaptchaState", "getCaptchaErrorInfo", "checkCodeRight", "pagetypeLog"])),
	watch: {
		authMobile: function authMobile(val) {
			this.setMobile(val);
		},
		hasAuthed: function hasAuthed(val) {
			this.setAuthed(val);
		},
		checkCodeRight: function checkCodeRight(val) {
			this.checkCodeState = val;
		},
		checkCodeState: function checkCodeState(val) {
			// 验证码正确，收起验证码框，手机号设为已认证状态
			if (val) {
				this.checkCodeIsError = false;
				this.checkCodeTip = "验证码";
				this.showCheckCode = false;
				this.mobileAuthState = true;
				this.mobileIsError = false;
				this.mobileTip = "手机号";
			} else {
				this.checkCodeIsError = true;
				this.checkCodeTip = "验证码输入错误";
			}
		}
	},
	created: function created() {
		this.setMobile(this.authMobile);
		this.setAuthed(this.hasAuthed);
	},

	methods: {
		// 手机号初始化
		setMobile: function setMobile(val) {
			if (val && this.mobile === "") {
				this.mobile = val;
				if (!this.hasAuthed) {
					this.mobileRight = true;
					this.mobileIsError = true;
					this.mobileTip = "手机号未验证";
				}
			}
		},
		setAuthed: function setAuthed(val) {
			this.mobileAuthState = val; // 认证状态存储在缓存中
			if (val) {
				this.mobileIsError = false;
				this.mobileTip = "手机号";
				this.showCheckCode = false; // 验证码框隐藏
			} else {
				this.mobileIsError = true;
				this.mobileTip = "手机号未验证";
			}
		},

		// 手机号项点击
		mobileClick: function mobileClick(value) {
			if (value === "") {
				this.mobileIsError = false;
				this.mobileTip = "请输入11位手机号码";
			}
			window.clickLog && window.clickLog("from=jl_phonenumclk_login" + this.pagetypeLog);
		},


		// 手机号由正确状态改为错误状态时，隐藏获取验证码按钮
		mobileChange: function mobileChange(mobile) {
			if (mobile.length < 11) {
				this.mobileRight = false;
				this.mobileAuthState = false;
				// 修改认证状态为false
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["h" /* CHANGE_HASAUTHED */], {
					auth: false
				});

				// 清除计时器
				clearTimeout(this.timer);
				this.getCheckCodeText = "获取验证码";
				this.btnState = "";
			}
		},


		// 检查手机号
		checkMobile: function checkMobile(value) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								// 检查前默认将手机号填写状态置为false
								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["g" /* CHECK_BASICINFO */], {
									key: "mobile",
									value: value,
									state: false
								});

								if (!(value === "")) {
									_context.next = 8;
									break;
								}

								_this.mobileAuthState = false;
								_this.mobileIsError = true;
								_this.mobileRight = false;
								_this.mobileTip = "输入手机号";
								_context.next = 26;
								break;

							case 8:
								if (__WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* default */].mobileReg.test(value)) {
									_context.next = 15;
									break;
								}

								_this.mobileAuthState = false;
								_this.mobileIsError = true;
								_this.mobileRight = false;
								_this.mobileTip = "手机号码格式不对";
								_context.next = 26;
								break;

							case 15:
								if (!(value === _this.hasAuthedMobile)) {
									_context.next = 20;
									break;
								}

								_this.mobileAuthState = true;
								// 修改认证状态为true
								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["h" /* CHANGE_HASAUTHED */], {
									auth: true
								});
								_context.next = 26;
								break;

							case 20:
								// 如果手机号输入达11位且正确，则进行检查认证
								_this.mobileIsError = false;
								_this.mobileTip = "手机号";
								_this.mobile = value;
								_context.next = 25;
								return _this.$store.dispatch("checkMobileAuth", value);

							case 25:
								_this.mobileRight = true;

							case 26:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},


		// 验证码点击
		checkCodeClick: function checkCodeClick(value) {
			if (value === "") {
				this.checkCodeIsError = false;
				this.checkCodeTip = "请输入6位验证码";
			}
		},


		// 校验验证码
		verifyCheckCode: function verifyCheckCode(value) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								// 检查前默认将验证码填写状态置为false
								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["g" /* CHECK_BASICINFO */], {
									key: "keyCode",
									value: value,
									state: false
								});

								if (!(value === "")) {
									_context2.next = 6;
									break;
								}

								_this2.checkCodeIsError = true;
								_this2.checkCodeTip = "输入验证码";
								_context2.next = 15;
								break;

							case 6:
								if (!(value.length < 6)) {
									_context2.next = 12;
									break;
								}

								_this2.checkCodeState = false;
								_this2.checkCodeIsError = true;
								_this2.checkCodeTip = "请输入6位验证码";
								_context2.next = 15;
								break;

							case 12:
								_context2.next = 14;
								return _this2.$store.dispatch("verifyCheckCode", {
									mobile: _this2.mobile,
									code: value
								});

							case 14:

								if (!_this2.checkCodeRight) {
									_this2.checkCodeIsError = true;
									_this2.checkCodeTip = "验证码输入错误";
								}

							case 15:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},


		// 获取手机验证码点击事件
		getCheckCode: function getCheckCode() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(_this3.btnState === "")) {
									_context3.next = 4;
									break;
								}

								_context3.next = 3;
								return _this3.$store.dispatch("getCheckCode", _this3.mobile);

							case 3:
								// 发送成功
								if (_this3.getCaptchaState) {
									_this3.btnState = "disabled";
									_this3.countDown();
									_this3.checkCodeState = false;
									_this3.showCheckCode = true;

									// 非ios时将焦点置于验证码框，ios不进行焦点转移
									if (_this3.isIOS) {
										_this3.checkCodeTip = "输入验证码";
									} else {
										_this3.focusCheckCode = true;
									}
								} else {
									// 提示错误信息
									_this3.mobileTip = _this3.getCaptchaErrorInfo;
									_this3.mobileIsError = true;
								}

							case 4:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},


		// 按钮倒计时
		countDown: function countDown() {
			var _this4 = this;

			var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;

			if (wait === 0) {
				this.getCheckCodeText = "重新获取";
				this.btnState = "";
			} else {
				this.getCheckCodeText = "已发送" + wait + "s";
				wait--;
				this.timer = setTimeout(function () {
					_this4.countDown(wait);
				}, 1000);
			}
		},


		// 点击保存检查为空
		checkNull: function checkNull() {
			this.checkMobile("");
		}
	}
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_myInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_myInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_myInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		myInput: __WEBPACK_IMPORTED_MODULE_3__common_myInput___default.a
	},
	data: function data() {
		return {
			isError: false,
			nameTip: "输入姓名",
			name: "",
			maxLength: 4,
			state: false // 填写状态
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["truename", "pagetypeLog"])),
	watch: {
		truename: function truename(val) {
			this.name = this.truename;
		}
	},
	created: function created() {
		this.name = this.truename;
	},

	methods: {
		nameClick: function nameClick(value) {
			// 第一次点击
			if (value === "") {
				this.isError = false;
				this.nameTip = "真实姓名请填写2-4个汉字";
			}
			window.clickLog && window.clickLog("from=jl_nameclk" + this.pagetypeLog);
		},
		checkName: function checkName(value) {
			this.name = value;
			if (value === "") {
				this.isError = true;
				this.nameTip = "输入姓名";
				this.state = false;
				window.clickLog && window.clickLog("from=jl_namemiss" + this.pagetypeLog);
			} else if (!__WEBPACK_IMPORTED_MODULE_2__util_config__["a" /* default */].nameReg.test(value)) {
				this.isError = true;
				this.nameTip = "只能填写2-4个汉字";
				this.state = false;
				window.clickLog && window.clickLog("from=jl_namemiss" + this.pagetypeLog);
			} else {
				this.isError = false;
				this.nameTip = "真实姓名";
				this.state = true;
			}
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
				key: "truename",
				value: value,
				state: this.state
			});
		},

		// 点击保存检查为空
		checkNull: function checkNull() {
			this.checkName("");
		}
	}
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			selectedMale: false,
			selectedFemale: false,
			isError: false,
			isFirst: true
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["gender", "pagetypeLog"])),
	watch: {
		gender: function gender(val) {
			if (this.isFirst) {
				this.sexSelect(val);
				this.isFirst = false;
			}
		}
	},
	created: function created() {
		if (this.isFirst && this.gender !== "") {
			this.sexSelect(this.gender);
			this.isFirst = false;
		}
	},

	methods: {
		sexSelect: function sexSelect(val) {
			window.clickLog && window.clickLog("from=jl_sexclk" + this.pagetypeLog);
			if (this.selectedMale === true || this.selectedFemale === true) {
				// 解决当初始化为空，点击第一次无反应情况bug
				if (this.isFirst) {
					return;
				}
				this.selectedMale = false;
				this.selectedFemale = false;
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
					key: "gender",
					value: "",
					state: null
				});
			} else {
				if (val === false) {
					this.selectedMale = true;
					this.selectedFemale = false;
				} else {
					this.selectedFemale = true;
					this.selectedMale = false;
				}
				this.isError = false;
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CHECK_BASICINFO */], {
					key: "gender",
					value: val,
					state: true
				});
			}
		},

		// 点击保存检查为空
		checkNull: function checkNull() {
			window.clickLog && window.clickLog("from=jl_sexmiss" + this.pagetypeLog);
			this.isError = true;
		}
	}
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		title: {
			type: String,
			default: ''
		},
		content: {
			type: String,
			default: ''
		},
		btnCancel: {
			type: String,
			default: ''
		},
		btnConfirm: {
			type: String,
			default: ''
		}
	},
	methods: {
		confirm: function confirm() {
			this.$emit('confirm');
		},
		cancel: function cancel() {
			this.$emit('cancel');
		}
	}
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		isError: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: ''
		},
		tipText: {
			type: String,
			default: ''
		},
		maxLength: {
			type: Number,
			default: 30
		},
		isFocusing: {
			type: Boolean,
			default: false
		},
		inputType: {
			type: String,
			default: 'text'
		},
		inputID: {
			type: String,
			default: ''
		}
	},
	created: function created() {
		this.content = this.text;
		if (this.text) {
			this.showTip = true;
		}
	},

	watch: {
		text: function text(val) {
			this.content = val;
			if (val) {
				this.showTip = true;
			}
		},
		content: function content(val) {
			if (val || this.focusing) {
				this.showTip = true;
			} else {
				this.showTip = false;
			}
			// 输入内容达到上限时(并且是输入过程中)进行校验
			if (val.length === this.maxLength && this.focusing) {
				this.$emit('blurEvent', val);
			} else {
				// 将改变后的值反给父级
				this.$emit('on-change', val);
			}
		},
		isFocusing: function isFocusing(val) {
			if (val) {
				this.tipClick();
			}
		}
	},
	data: function data() {
		return {
			inputId: this.inputID === '' ? Math.random().toString(36).substring(3, 10) : this.inputID,
			focusing: this.isFocusing,
			showTip: false,
			content: this.text
		};
	},

	methods: {
		tipClick: function tipClick() {
			if (this.focusing === false) {
				this.showTip = true;

				// 焦点延时时间等于动效时间
				// setTimeout(() => {
				this.focusing = true;
				// ios10以上通过自定义指令focus没生效，所以通过手动focus
				document.getElementById(this.inputId).focus();
				// }, 100);

				this.$emit('tipClick', this.content);
			}
		},
		focusEvent: function focusEvent() {
			this.focusing = true;
		},
		blurEvent: function blurEvent() {
			// 当字数达到上限时会自动校验，防止多次校验
			if (this.content.length < this.maxLength) {
				this.focusing = false;
				if (this.content === '') {
					this.showTip = false;
				}
				this.$emit('blurEvent', this.content);
			}
		}
	},
	directives: {
		focus: {
			inserted: function inserted(el, _ref) {
				var value = _ref.value;

				if (value) {
					el.focus();
				}
			},
			//当绑定元素插入到DOM中
			update: function update(el, _ref2) {
				var value = _ref2.value;

				if (value) {
					el.focus(); //元素聚焦
				} else {
					el.blur();
				}
			}
		}
	}
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_scroller__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_scroller__);
 //
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		snapping: {
			type: Boolean,
			default: true
		},
		dataList: {
			type: Array,
			default: []
		},
		selectedIndex: {
			type: Number,
			default: 2
		},
		show: {
			type: Boolean,
			default: false
		},
		scrollIndex: {
			type: Number,
			default: 0
		}
	},
	data: function data() {
		return {
			containerId: 'ul-' + Math.random().toString(36).substring(3, 10),
			container: undefined,
			size: this.dataList.length,
			positionY: 0,
			snapHeight: 1,
			firstShow: true // 只有初始化展示进行定位，后面滚动之后的定位不再进行定位计算
		};
	},

	watch: {
		show: function show(val) {
			if (val) {
				// 初始化滚动行高及初始化位置
				if (this.snapping && this.snapHeight === 1) {
					this.$nextTick(function () {
						this.snapHeight = this.container.offsetHeight / this.dataList.length;
						this.positionY = this.snapHeight * this.selectedIndex;
					});
				}
			}
		}
	},
	mounted: function mounted() {
		this.container = document.getElementById(this.containerId);
	},

	components: {
		Scroller: __WEBPACK_IMPORTED_MODULE_0__58fe_v5_src_components_scroller___default.a
	},
	methods: {
		scrollEnd: function scrollEnd(position) {
			// 只存下展示时位置
			if (this.show) {
				var top = position.top,
				    selectedIndex = Math.round(top / this.snapHeight); // 滚动停止之后滚动距离顶部的个数
				this.$emit('scrollEnd', selectedIndex, this.scrollIndex);
			}
		}
	}
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			photoUrl: "//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/user_default@2x.png", // 默认头像
			sexClass: "sex-male",
			age: "",
			educationText: "",
			workExperience: ""
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["pic", "truename", "gender", "mobile", "birthday", "education", "workyears", "educations", "pagefrom"]), {
		// 是否展示教育经历
		needEducation: function needEducation() {
			// 大专及以上 + 校招 + 应届生必填
			return this.education > 3 && (this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") && this.workyears === 5;
		},

		// 最高学历
		getHighEdu: function getHighEdu() {
			var edus = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.educations));
			return edus.sort(function (x, y) {
				return y.endDate.replace(/-/g, "") - x.endDate.replace(/-/g, "");
			})[0];
		}
	}),
	created: function created() {
		this.setPhotoUrl(this.pic);
		this.setSexClass(this.gender);
		this.setAge(this.birthday);
		this.setEducation(this.education);
		this.setWorkExperience(this.workyears);
	},

	watch: {
		pic: function pic(val) {
			this.setPhotoUrl(val);
		},
		gender: function gender(val) {
			this.setSexClass(val);
		},
		birthday: function birthday(val) {
			this.setAge(val);
		},
		education: function education(val) {
			this.setEducation(val);
		},
		workyears: function workyears(val) {
			this.setWorkExperience(val);
		}
	},
	methods: {
		setPhotoUrl: function setPhotoUrl(val) {
			if (val) {
				this.photoUrl = val;
			} else {
				this.photoUrl = "//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/user_default@2x.png";
			}
		},
		setSexClass: function setSexClass(val) {
			if (val) {
				this.sexClass = "sex-female";
				this.sexBoxClass = "sex-female-box";
			} else {
				this.sexClass = "sex-male";
				this.sexBoxClass = "sex-male-box";
			}
		},
		setAge: function setAge(val) {
			var date = new Date(),
			    thisYear = date.getFullYear();
			this.age = thisYear - val;
		},
		setEducation: function setEducation(val) {
			// 教育经历从1开始
			this.educationText = __WEBPACK_IMPORTED_MODULE_2__util_config__["a" /* default */].educationList[val - 1];
		},
		setWorkExperience: function setWorkExperience(val) {
			var index = __WEBPACK_IMPORTED_MODULE_2__util_config__["a" /* default */].experienceArray.indexOf(val); // 工作年限对应的index需要转一下
			this.workExperience = __WEBPACK_IMPORTED_MODULE_2__util_config__["a" /* default */].experienceList[index];
		},
		backBasic: function backBasic() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__basicInfo__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__basicInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__basicInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jobIntention__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jobIntention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jobIntention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__privacySetting__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__privacySetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__privacySetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CallbackFn__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__showISDCaptcha__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(1);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		basicInfo: __WEBPACK_IMPORTED_MODULE_5__basicInfo___default.a,
		jobIntention: __WEBPACK_IMPORTED_MODULE_6__jobIntention___default.a,
		privacySetting: __WEBPACK_IMPORTED_MODULE_7__privacySetting___default.a,
		Toast: __WEBPACK_IMPORTED_MODULE_4__58fe_v5_src_components_toast___default.a,
		Loading: __WEBPACK_IMPORTED_MODULE_3__58fe_v5_src_components_loading___default.a
	},
	data: function data() {
		return {
			showToast: false,
			errorInfo: "",
			time: 1500,
			showLoading: false,
			isFirstClick: true, // 防止重复点击
			nameObj: {
				zpcateId: "期望职位",
				salary: "期望薪资",
				targetAreaId: "求职区域"
			},
			fromPageName: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParamVal("platform") || ""
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])(["expectionInfoOk", "expectionInfo", "submitState", "submitErrorInfo", "privacySettingState", "privacyErrorInfo", "resumeId", "resumeType", "pagefromUrl", "pagefromLog", "pagetypeLog", "deliveryCode", "deliveryMsg", "deliveryState", "infoId", "pagefrom", "showISDCaptcha", "responseObj", "areaInfo"]), {
		btnText: function btnText() {
			return this.pagefrom === "fromEducation" ? "创建并报名成功" : "创建基础简历";
		}
	}),
	watch: {
		privacySettingState: function privacySettingState(val) {
			// 隐私设置失败若页面还没进行跳转进行提示
			if (val === false) {
				this.errorInfo = this.privacyErrorInfo;
				this.showToast = true;
			}
		}
	},
	created: function created() {
		var _this = this;

		if (this.areaInfo.length < 1) {
			// 获取上一份简历基本信息
			this.$store.dispatch("getLastResumeInfo");

			// 获取账号绑定的手机号
			this.$store.dispatch("checkMobileAuth");

			// 获取用户隐私设置
			this.$store.dispatch("getPrivacy");

			// 获取区域
			this.$store.dispatch("getAreaInfo");
		}
		if (__WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParamVal("comefrom") === "auth") {
			this.$v5.confirm({
				title: "提示",
				text: "认证成功，点击保存进行下步流程",
				confirmText: "保存",
				cancelText: "取消"
			}).then(function (res) {
				if (res) {
					_this.saveResumeEvent();
				}
			});
		}
	},
	mounted: function mounted() {
		// 添加按下态监听
		var DomList = Array.prototype.slice.call(document.getElementsByClassName("expect-job-detail"));

		DomList.forEach(function (item, index) {
			item.addEventListener("touchstart", function (e) {
				this.parentNode.className += " item-active";
			});
			item.addEventListener("touchmove", function (e) {
				this.parentNode.className = this.parentNode.className.replace(/item-active/g, "");
			});
			item.addEventListener("touchend", function (e) {
				this.parentNode.className = this.parentNode.className.replace(/item-active/g, "");
			});
		});

		window.clickLog && window.clickLog("from=targetpage_normal_all" + this.pagetypeLog);

		window.clickLog && window.clickLog("from=targetpage_normal" + this.pagefromLog);

		// 校招来源埋点
		this.pagefrom === "fromXZ" && window.clickLog && window.clickLog("from=xiaozhao_resumecreate2_show");
		this.pagefrom === "fromCQXZ" && window.clickLog && window.clickLog("from=chongqingxiaozhao_resumecreate2_show");

		if (this.pagefrom === "fromWX" && this.fromPageName === "mp") {
			window.clickLog && window.clickLog("from=58yg_nojlpost_page2_show");
		} else if (this.pagefrom === "fromWX") {
			window.clickLog && window.clickLog("from=58yg_jlpost_page2_show");
		}
	},

	methods: {
		saveResumeEvent: function saveResumeEvent() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var obj, isFirstError, prop;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								window.clickLog && window.clickLog("from=jl_baocunall_all" + _this2.pagetypeLog);
								window.clickLog && window.clickLog("from=jl_baocunall" + _this2.pagefromLog);

								if (_this2.expectionInfoOk && _this2.isFirstClick) {
									window.clickLog && window.clickLog("from=jl_baocunclk" + _this2.pagetypeLog);
									window.clickLog && window.clickLog("from=jl_baocunclk" + _this2.pagefromLog);

									_this2.saveResume();
								} else {
									// 未填写的项进行错误提示
									obj = _this2.expectionInfo, isFirstError = true;

									for (prop in obj) {
										// 第一个错误信息toast提示，错误样式处理只需触发为空的项
										if (isFirstError && obj.hasOwnProperty(prop) && !obj[prop]) {
											_this2.errorInfo = "您的" + _this2.nameObj[prop] + "填写有误，请修改";
											_this2.showToast = true;
											isFirstError = false;
										}
										if (obj.hasOwnProperty(prop) && !obj[prop]) {
											_this2.$refs.intention.checkNull(prop);
										}
									}
								}

							case 3:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},

		// 保存简历请求
		saveResume: function saveResume() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var callbackFn;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								/*
        *简历发布来源：微信：70百度：71头条：70支付宝：70
        */
								if ([70, 71].indexOf(parseInt(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParamVal('sourceid'), 10)) > -1) {
									window.clickLog && clickLog("from=save_click");
								}

								if (_this3.pagefrom === "fromWX" && _this3.fromPageName === "mp") {
									window.clickLog && window.clickLog("from=58yg_nojlpost_success_click");
								} else if (_this3.pagefrom === "fromWX") {
									window.clickLog && window.clickLog("from=58yg_jlpost_success_click");
								}

								_this3.isFirstClick = false;
								_this3.showLoading = true;
								_context2.next = 6;
								return _this3.$store.dispatch("saveResume");

							case 6:
								if (!_this3.submitState) {
									_context2.next = 16;
									break;
								}

								// 隐私设置
								_this3.$store.dispatch("setPrivacy");

								// 简历进行投递

								if (!_this3.infoId) {
									_context2.next = 11;
									break;
								}

								_context2.next = 11;
								return _this3.$store.dispatch("delivery");

							case 11:
								_this3.showLoading = false;
								callbackFn = new __WEBPACK_IMPORTED_MODULE_9__CallbackFn__["a" /* CallbackFn */](_this3.pagefromUrl, _this3.deliveryCode, _this3.resumeId, _this3.$v5, _this3.deliveryMsg, _this3.deliveryState);

								callbackFn[_this3.pagefrom] ? callbackFn[_this3.pagefrom]() : callbackFn["default"]();
								_context2.next = 17;
								break;

							case 16:
								if (_this3.showISDCaptcha) {
									__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__showISDCaptcha__["a" /* showISDCaptcha */])(_this3.responseObj, _this3.saveResume);
									_this3.isFirstClick = true; // 重新设置为可点击
								} else {
									_this3.isFirstClick = true; // 重新设置为可点击
									_this3.errorInfo = _this3.submitErrorInfo;
									_this3.showToast = true;
								}

							case 17:
								_this3.showLoading = false;

							case 18:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		}
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		/*
  *简历发布来源：微信：70百度：71头条：70支付宝：70
  */
		if ([70, 71].indexOf(parseInt(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParamVal('sourceid'), 10)) > -1) {
			window.clickLog && clickLog("from=page2_show");
		}
		next();
	}
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Checklist: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default.a
	},
	data: function data() {
		return {
			showPop: false,
			selectedItems: [], // 选中的职位
			selectedText: "", // 选中职位名字拼接
			selectedIds: "", // 选中职位id拼接
			hasSelected: false,
			isError: false,
			areaList: []
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["areaInfo", "sessionAreaList", "pagetypeLog"])),
	watch: {
		selectedItems: function selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		},
		sessionAreaList: function sessionAreaList() {
			this.init();
		}
	},
	created: function created() {
		// 初始化选中项
		this.init();
	},

	methods: {
		init: function init() {
			// 初始化选中项
			var initList = this.sessionAreaList;

			if (initList && initList.length > 0) {
				this.selectedItems.push(initList);
				this.confirm(initList);
			}
		},
		showPopup: function showPopup() {
			this.showPop = true;
			window.clickLog && window.clickLog("from=jl_targetareaclick" + this.pagetypeLog);
		},
		close: function close() {
			window.clickLog && window.clickLog("from=jl_targetareaclick_close" + this.pagetypeLog);
			this.showPop = false;
		},
		confirm: function confirm(val) {
			var _this = this;

			var selectState = val.length > 0;
			window.clickLog && window.clickLog("from=jl_targetareaclick_confirm" + this.pagetypeLog);

			this.selectedItems = val;
			this.selectedText = "";
			this.selectedIds = "";
			val.forEach(function (item, i) {
				if (i > 0) {
					_this.selectedText += "/";
					_this.selectedIds += ",";
				}
				_this.selectedText += item.name;
				_this.selectedIds += item.id;
			});

			this.showPop = false;
			this.isError = !selectState;

			//  检查是否已填写完整所有必填项
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* CHECK_EXPECTIONINFO */], {
				key: "targetAreaId",
				value: this.selectedIds,
				state: selectState
			});
		},
		checkNull: function checkNull() {
			this.isError = true;
			window.clickLog && window.clickLog("from=jl_targetareamiss" + this.pagetypeLog);
		}
	}
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__titleIntention__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__titleIntention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__titleIntention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__salaryIntention__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__salaryIntention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__salaryIntention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__areaIntention__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__areaIntention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__areaIntention__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		titleIntention: __WEBPACK_IMPORTED_MODULE_0__titleIntention___default.a,
		salaryIntention: __WEBPACK_IMPORTED_MODULE_1__salaryIntention___default.a,
		areaIntention: __WEBPACK_IMPORTED_MODULE_2__areaIntention___default.a
	},
	data: function data() {
		return {};
	},

	methods: {
		checkNull: function checkNull(prop) {
			this.$refs[prop].checkNull();
		}
	}
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_selectScroll__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_selectScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_selectScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default.a,
		selectScroll: __WEBPACK_IMPORTED_MODULE_2__common_selectScroll___default.a
	},
	data: function data() {
		return {
			showBox: false,
			salaryList: ["", ""].concat(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].salaryList).concat(["", ""]),
			selectedIndex: 0,
			selectedText: "",
			hasSelected: false,
			isError: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["salary", "pagetypeLog"])),
	watch: {
		salary: function salary(val) {
			this.hasSelected = true;
			this.selectedIndex = val;
			this.selectedText = __WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].salaryList[val];
		}
	},
	created: function created() {
		if (this.salary !== "") {
			this.hasSelected = true;
			this.selectedIndex = this.salary;
			this.selectedText = __WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].salaryList[this.salary];
		}
	},

	methods: {
		hidePopup: function hidePopup() {
			this.showBox = false;
		},
		showPopup: function showPopup() {
			this.showBox = true;
			// 如果未选择，则选择默认
			if (this.selectedText === "") {
				this.scrollEnd(this.selectedIndex);
			}
			window.clickLog && window.clickLog("from=jl_targetsalaryclick" + this.pagetypeLog);
		},
		scrollEnd: function scrollEnd(index) {
			this.selectedIndex = index;
			this.hasSelected = true;
			this.selectedText = __WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].salaryList[index];
			this.isError = false;

			//  检查是否已填写完整所有必填项
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["b" /* CHECK_EXPECTIONINFO */], {
				key: "salary",
				value: index,
				state: true
			});
		},
		checkNull: function checkNull() {
			this.isError = true;
			window.clickLog && window.clickLog("from=jl_targetsalarymiss" + this.pagetypeLog);
		}
	}
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_configData__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import category from "../../../util/category";




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Checklist: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default.a
	},
	data: function data() {
		return {
			// titleList: category,
			titleList: [],
			selectedItems: [], // 选中的职位
			selectedText: "", // 选中职位名字拼接
			selectedIds: "", // 选中职位id拼接
			hasSelected: false,
			showPop: false,
			isError: false,
			checklistKey: 0
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["sessionCateList", "categoryInitList", "pagetypeLog"])),
	watch: {
		selectedItems: function selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		},
		sessionCateList: function sessionCateList(val) {
			this.init();
		}
	},
	created: function created() {
		this.getConfigJobsData();
		// 初始化选中项
		this.init();
	},

	methods: {
		init: function init() {
			// 初始化选中项
			var initList = this.categoryInitList;
			if (this.sessionCateList && this.sessionCateList.length > 0) {
				initList = this.sessionCateList;
			}
			if (initList && initList.length > 0) {
				this.selectedItems.push(initList);

				this.confirm(initList);
			}
		},
		showPopup: function showPopup() {
			this.showPop = true;
			window.clickLog && window.clickLog("from=jl_targetcateclick" + this.pagetypeLog);
		},
		close: function close(val) {
			window.clickLog && window.clickLog("from=jl_targetcateclick_close" + this.pagetypeLog);

			this.showPop = false;
		},
		confirm: function confirm(val) {
			var _this = this;

			var selectState = val.length > 0,
			    showIndustry = false; // 是否是二级销售类别

			window.clickLog && window.clickLog("from=jl_targetcateclick_confirm" + this.pagetypeLog);

			this.selectedItems = val;
			this.selectedText = "";
			this.selectedIds = "";
			val.forEach(function (item, i) {
				if (i > 0) {
					_this.selectedText += "/";
					_this.selectedIds += ",";
				}
				_this.selectedText += item.name;
				_this.selectedIds += item.id;

				// 二级类别为销售展示屏蔽行业
				if (item.parentId && item.parentId === 13139) {
					showIndustry = true;
				}
			});

			this.showPop = false;
			this.isError = !selectState;

			// 更改是否展示屏蔽行业状态字段
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["c" /* SET_BLOCK_INDUSTRY */], showIndustry);

			//  检查是否已填写完整所有必填项
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["b" /* CHECK_EXPECTIONINFO */], {
				key: "zpcateId",
				value: this.selectedIds,
				state: selectState
			});
		},
		checkNull: function checkNull() {
			this.isError = true;
			window.clickLog && window.clickLog("from=jl_targetcatemiss" + this.pagetypeLog);
		},
		getConfigJobsData: function getConfigJobsData() {
			var _this2 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_configData__["b" /* getConfigJobsData */])().then(function (data) {
				var list_0 = [];
				var list_1 = [];
				(data || []).forEach(function (item) {
					list_0.push({
						id: item.id,
						name: item.name
					});
					if (Array.isArray(item.subList) && item.subList.length > 0) {
						var subList = [];
						item.subList.forEach(function (sub, index) {
							subList.push({
								id: sub.DispCategoryID,
								name: sub.CateName
							});
							if (index === item.subList.length - 1) {
								list_1.push({
									parentId: item.id,
									list: subList
								});
							}
						});
					}
				});
				var list = [list_0, list_1];
				_this2.titleList = list;
				_this2.checklistKey = _this2.checklistKey + 1;
			});
		}
	}
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacyCompany__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacyCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__privacyCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacyIndustry__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacyIndustry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__privacyIndustry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		privacyCompany: __WEBPACK_IMPORTED_MODULE_1__privacyCompany___default.a,
		privacyIndustry: __WEBPACK_IMPORTED_MODULE_2__privacyIndustry___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['showIndustry']))
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Popup: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_popup___default.a
	},
	data: function data() {
		return {
			showBox: false,
			selectedIndex: 0, // 列表index
			selectedText: "所有招聘方",
			selectList: [{
				text: "所有招聘方",
				textTip: "通过营业执照或法人等认证的招聘方"
			}, {
				text: "仅我投递的招聘方",
				textTip: "不会出现在简历库中，不会被非投递的招聘方邀约"
			}]
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["showStatus", "pagetypeLog"])),
	created: function created() {
		var _this = this;

		// 选择的index（所有招聘方是1，仅我投递是0
		this.selectedIndex = this.showStatus === 1 ? 0 : 1;
		this.$nextTick(function () {
			_this.selectedText = _this.selectList[_this.selectedIndex].text;
		});
	},
	mounted: function mounted() {
		window.clickLog && window.clickLog("from=jl-postshuikeyikandao" + this.pagetypeLog);
	},

	watch: {
		showStatus: function showStatus(val) {
			this.selectedIndex = this.showStatus === 1 ? 0 : 1;
			this.selectedText = this.selectList[this.selectedIndex].text;
		}
	},
	methods: {
		showPopup: function showPopup() {
			this.showBox = true;
			window.clickLog && window.clickLog("from=jl-postshuikeyikandaoclick" + this.pagetypeLog);
		},
		hidePopup: function hidePopup() {
			this.showBox = false;
		},
		selectItem: function selectItem(index) {
			if (this.selectedIndex !== index) {
				var showStatusId = index === 1 ? 0 : 1; // index和id顺序正好相反（后端文档有误）
				this.selectedText = this.selectList[index].text;
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["a" /* SET_PRIVACY */], {
					key: "showStatus",
					value: showStatusId
				});
			}
			this.hidePopup();
		}
	}
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_industry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);

 //
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Checklist: __WEBPACK_IMPORTED_MODULE_1__58fe_v5_src_components_checklist___default.a
	},
	data: function data() {
		return {
			list: __WEBPACK_IMPORTED_MODULE_2__util_industry__["a" /* default */],
			selectedItems: [], // 选中的行业
			selectedText: '无', // 选中行业名字拼接
			selectedIds: '', // 选中行业id拼接
			hasSelected: false,
			showPop: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['blockIndustry', 'pagetypeLog'])),
	watch: {
		selectedItems: function selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		}
	},
	mounted: function mounted() {
		window.clickLog && window.clickLog('from=jl-postpingbihangye' + this.pagetypeLog);
	},

	methods: {
		showPopup: function showPopup() {
			this.showPop = true;
			window.clickLog && window.clickLog('from=jl-postpingbihangyeclick' + this.pagetypeLog);
		},
		close: function close() {
			this.showPop = false;
		},
		dataChange: function dataChange(currentSelected) {
			// 如果最后一个看是否点击的无，则关闭选择框，并且选中项置为空
			var length = currentSelected.length;
			if (length > 0 && currentSelected[length - 1].id === '0') {
				this.confirm([]);
			}
		},
		confirm: function confirm(val) {
			this.selectedItems = val;
			this.selectedText = '';
			this.selectedIds = '';
			for (var i in val) {
				if (i > 0) {
					this.selectedText += '/';
					this.selectedIds += ',';
				}
				this.selectedText += val[i].name;
				this.selectedIds += val[i].id;
			}
			this.showPop = false;
			// 选中项为空
			if (val.length === 0) {
				this.selectedText = '无';
				this.selectedIds = '';
			}
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* SET_PRIVACY */], {
				key: 'blockIndustry',
				value: this.selectedIds
			});
		}
	}
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['areaName', 'pagetypeLog', 'isLogin'])),
	methods: {
		changeCity: function changeCity() {
			if (location.hash.indexOf('expectation')) {
				window.clickLog && window.clickLog('from=jl_changecity_second' + this.pagetypeLog);
			} else {
				window.clickLog && window.clickLog('from=jl_changecity_first' + this.pagetypeLog);
			}
			location.href = '//m.58.com/city.html?from=click_city_new'; // 域名为简历的切换城市后返回首页
		}
	}
});

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_http__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_httpJsonp__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
	// 获取账号绑定的手机号
	checkMobileAuth: function checkMobileAuth() {
		var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var csrfToken = window.____global.csrfToken || '';
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumeapi/mobilestate?business=1&caller=1&mobile=' + mobile + '&csrfToken=' + csrfToken);
	},

	// 获取手机号验证码
	getCheckCode: function getCheckCode(mobile) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumecommon/getcaptcha?mobile=' + mobile + '&platform=3');
	},

	// 验证手机号验证码
	verifyCheckCode: function verifyCheckCode(mobile, checkCode, responseid) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumecommon/checkcaptcha?mobile=' + mobile + '&code=' + checkCode + '&responseid=' + responseid);
	},

	// 获取地域接口
	getAreaInfo: function getAreaInfo(cityname) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumecommon/city/zonebyname?cityname=' + cityname);
	},

	// 获取用户简历份数
	getResumeCount: function getResumeCount(userId) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumeapi/resumecount?userId=' + userId);
	},

	// 获取上一份简历信息接口
	getLastResumeInfo: function getLastResumeInfo() {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get('//jianli.58.com/resumeapi/lastresumeinfo');
	},

	// 获取用户隐私设置接口
	getPrivacy: function getPrivacy() {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/userprivacy/getprivacy');
	},

	// 上传图片
	uploadImg: function uploadImg(dataUrl) {
		var paramObj = {
			'Pic-Size': '0*0',
			'Pic-Encoding': 'base64',
			'Pic-Path': '/nowater/jltx/',
			'Pic-Data': dataUrl
		};
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].post('//upload.58cdn.com.cn/json?rand=' + Math.random(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(paramObj), 'text');
	},

	// 获取动态的图片上传url
	getUploadUrl: function getUploadUrl() {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].get("//jianli.58.com/resumeupdatev2/pic/authentication?type=1");
	},

	// input头像上传
	uploadPic: function uploadPic(_ref) {
		var imgData = _ref.imgData,
		    uploadUrl = _ref.uploadUrl;

		return __WEBPACK_IMPORTED_MODULE_2__util_httpJsonp__["a" /* default */].put(uploadUrl, imgData);
	},

	// 保存简历基本信息
	saveResume: function saveResume(params) {
		// 完整简历
		if (params.from === 3) {
			return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/resumepost/fulltime?isminiprogram=true', params, null, { headers: { flowsrc: __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('flowsrc') || 'public' } });
		} else {
			return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/resumepost/micro?isminiprogram=true', params, null, { headers: { flowsrc: __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('flowsrc') || 'public' } });
		}
	},

	// 隐私设置接口
	setPrivacy: function setPrivacy(params) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/userprivacy/postprivacy', params);
	},

	// 投递接口
	delivery: function delivery(params) {
		return __WEBPACK_IMPORTED_MODULE_1__util_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/resumedelivery/process', params, null, { headers: { flowsrc: __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('flowsrc') || 'public' } });
	}
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LimitFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_cookie__ = __webpack_require__(29);




var LimitFn = function () {
	function LimitFn(pagefromUrl, $v5) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LimitFn);

		this.pagefromUrl = pagefromUrl;
		this.$v5 = $v5;
	}

	// 微信小程序处理


	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LimitFn, [{
		key: 'fromWX',
		value: function fromWX() {
			var _this = this;

			// 小程序跳转
			this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU')) || '';
				window.wx.miniProgram.redirectTo({
					url: _this.pagefromUrl + '&ppu=' + ppu
				});
			});
		}

		// 百度小程序处理

	}, {
		key: 'fromBD',
		value: function fromBD() {
			var _this2 = this;

			// 跳回百度小程序
			this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU')) || '';
				window.swan.webView.redirectTo({
					url: _this2.pagefromUrl + '&ppu=' + ppu
				});
			});
		}

		// 支付宝小程序处理

	}, {
		key: 'fromZFB',
		value: function fromZFB() {
			var _this3 = this;

			// 跳回支付宝小程序
			this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU')) || '';
				window.my.redirectTo({
					url: _this3.pagefromUrl + '&ppu=' + ppu //路径可以使用相对路径或绝对路径的方式进行传递
				});
			});
		}

		// 头条小程序

	}, {
		key: 'fromTT',
		value: function fromTT() {
			var _this4 = this;

			// 跳转头条小程序
			this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU')) || '';
				window.tt.miniProgram.redirectTo({
					url: _this4.pagefromUrl + '&ppu=' + ppu
				});
			});
		}

		// 默认展示达到上限提示

	}, {
		key: 'defalut',
		value: function defalut() {
			return true;
		}
	}]);

	return LimitFn;
}();



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadSDK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var LoadSDK = function () {
	function LoadSDK() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LoadSDK);
	}

	// 微信小程序


	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LoadSDK, [{
		key: 'fromWX',
		value: function fromWX() {
			var wxurl = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
			this._addSDK(wxurl);
		}

		// 百度小程序

	}, {
		key: 'fromBD',
		value: function fromBD() {
			var bdurl = 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-1.7.0.js';
			this._addSDK(bdurl);
		}

		// 头条小程序

	}, {
		key: 'fromTT',
		value: function fromTT() {
			var tturl = 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk.js';
			this._addSDK(tturl);
		}

		// 支付宝小程序

	}, {
		key: 'fromZFB',
		value: function fromZFB() {
			var zfbUrl = 'https://appx/web-view.min.js';
			this._addSDK(zfbUrl);
		}

		// 同镇

	}, {
		key: 'fromTZ',
		value: function fromTZ() {
			// 加native协议
			var tzurl = 'https://a.58cdn.com.cn/app58/rms/app/js/app_30805.js';
			this._addSDK(tzurl);
		}

		// 加载对应的sdk

	}, {
		key: '_addSDK',
		value: function _addSDK(url) {
			var scriptDom = document.createElement('script');
			scriptDom.type = 'text/javascript';
			scriptDom.src = url;
			document.getElementsByTagName('body')[0].appendChild(scriptDom);
		}
	}]);

	return LoadSDK;
}();



/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_core_EXIF__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_core_BinaryFile__ = __webpack_require__(285);





var FixDirect = function () {
	function FixDirect() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FixDirect);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FixDirect, [{
		key: 'init',
		value: function init(file, callback) {
			// 创建一个reader
			var _this = this,
			    reader = new FileReader();
			// 读取成功后的回调
			reader.onload = function (e) {
				var oExif = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_core_EXIF__["a" /* default */])(new __WEBPACK_IMPORTED_MODULE_3__util_core_BinaryFile__["a" /* default */](e.target.result)) || {},
				    $img = document.createElement('img');

				$img.onload = function () {
					_this.fixDirect().fix($img, oExif, callback);
				};

				$img.src = window.webkitURL.createObjectURL(file);
			};
			// 将图片将转成二进制格式
			reader.readAsBinaryString(file);
		}
	}, {
		key: 'fixDirect',
		value: function fixDirect() {
			var r = {},
			    _this = this;
			r.fix = function (img, oExif, callback) {
				var n = img.naturalHeight,
				    i = img.naturalWidth,
				    c = 1024,
				    o = document.createElement('canvas'),
				    s = o.getContext('2d');
				oExif = oExif || {};

				if (n > c || i > c) {
					o.width = o.height = c;
				} else {
					o.width = i;
					o.height = n;
				}
				oExif.Orientation = oExif.Orientation || 1;
				r.detectSubSampling(img) && (i /= 2, n /= 2);
				var d = void 0,
				    h = void 0;
				i > n ? (d = c, h = Math.ceil(n / i * c)) : (h = c, d = Math.ceil(i / n * c));

				var g = Math.max(o.width, o.height) / 2,
				    l = document.createElement('canvas');
				if (n > c || i > c) {
					l.width = g, l.height = g;
				} else {
					l.width = i;
					l.height = n;
					d = i;
					h = n;
				}
				//l.width = g, l.height = g;
				var m = l.getContext('2d'),
				    u = r.detect(img, n) || 1;
				s.save();
				r.transformCoordinate(o, d, h, oExif.Orientation);

				var isUC = navigator.userAgent.match(/UCBrowser[\/]?([\d.]+)/i);
				if (isUC && /(Android)/i.test(navigator.userAgent)) {
					s.drawImage(img, 0, 0, d, h);
				} else {
					for (var f = g * d / i, w = g * h / n / u, I = 0, b = 0; n > I;) {
						for (var x = 0, C = 0; i > x;) {
							m.clearRect(0, 0, g, g), m.drawImage(img, -x, -I), s.drawImage(l, 0, 0, g, g, C, b, f, w), x += g, C += f;
						}I += g, b += w;
					}
				}

				s.restore();
				oExif.Orientation = 1;
				img = document.createElement('img');
				img.onload = function () {
					oExif.PixelXDimension = img.width;
					oExif.PixelYDimension = img.height;
				};
				callback && callback(o.toDataURL('image/jpeg', 0.5)); //压缩图片
			};
			r.detect = function (img, a) {
				var e = document.createElement('canvas');
				e.width = 1;
				e.height = a;
				var r = e.getContext('2d');
				r.drawImage(img, 0, 0);
				var n = r.getImageData(0, 0, 1, a).data,
				    c = a,
				    o = a;
				for (var i = 0; o > i;) {
					var s = n[4 * (o - 1) + 3];
					0 === s ? c = o : i = o, o = c + i >> 1;
				}
				var d = o / a;
				return 0 === d ? 1 : d;
			};
			r.detectSubSampling = function (img) {
				var a = img.naturalWidth,
				    e = img.naturalHeight;
				if (a * e > 1048576) {
					var _r = document.createElement('canvas');
					_r.width = _r.height = 1;
					var n = _r.getContext('2d');
					return n.drawImage(img, -a + 1, 0), 0 === n.getImageData(0, 0, 1, 1).data[3];
				}
				return !1;
			};
			// a: naturalWidth,e: naturalHeight
			r.transformCoordinate = function (img, a, e, Orientation) {
				console.log('Orientation:' + Orientation);
				switch (Orientation) {
					case 5:
					case 6:
					case 7:
					case 8:
						img.width = e, img.height = a;
						break;
					default:
						img.width = a, img.height = e;
				}
				var n = img.getContext('2d');
				switch (Orientation) {
					case 2:
						n.translate(a, 0), n.scale(-1, 1);
						break;
					case 3:
						n.translate(a, e), n.rotate(Math.PI);
						break;
					case 4:
						n.translate(0, e), n.scale(1, -1);
						break;
					case 5:
						n.rotate(0.5 * Math.PI), n.scale(1, -1);
						break;
					case 6:
						n.rotate(0.5 * Math.PI), n.translate(0, -e);
						break;
					case 7:
						n.rotate(0.5 * Math.PI), n.translate(a, -e), n.scale(-1, 1);
						break;
					case 8:
						n.rotate(-0.5 * Math.PI), n.translate(-a, 0);
				}
			};
			return r;
		}
	}]);

	return FixDirect;
}();

/* harmony default export */ __webpack_exports__["a"] = (FixDirect);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CallbackFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_cookie__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(14);






var CallbackFn = function () {
	function CallbackFn(pagefromUrl, deliveryCode, resumeId, $v5, deliveryMsg, deliveryState) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CallbackFn);

		this.pagefromUrl = pagefromUrl;
		this.deliveryCode = deliveryCode;
		this.deliveryMsg = deliveryMsg;
		this.deliveryState = deliveryState;
		this.resumeId = resumeId;
		this.$v5 = $v5;
		this.fromType = __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('formType');
		this.deliverySource = __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('deliverySource');
		this.backType = __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('backType');
	}
	// 来源教育经历


	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CallbackFn, [{
		key: 'fromEducation',
		value: function fromEducation() {
			var successUrl = '';
			if (this.pagefromUrl.indexOf('?') !== -1) {
				successUrl = this.pagefromUrl + '&deliveryCode=' + this.deliveryCode;
			} else {
				successUrl = this.pagefromUrl + '?deliveryCode=' + this.deliveryCode;
			}
			window.location.replace(successUrl);
		}

		// 微信小程序处理

	}, {
		key: 'fromWX',
		value: function fromWX() {
			var _this = this;

			var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU'));
			var successUrl = '';
			if (this.pagefromUrl.indexOf('?') > -1) {
				successUrl = this.pagefromUrl + '&deliveryCode=' + this.deliveryCode + '&ppu=' + ppu;
			} else {
				successUrl = this.pagefromUrl + '?deliveryCode=' + this.deliveryCode + '&ppu=' + ppu;
			}
			var message = '';
			if (__WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].getParamVal('infoids')) {
				message = this.deliveryState ? '简历创建并投递成功' : this.deliveryMsg || '网络异常，请稍后重试';
			} else {
				message = '简历创建成功';
			}
			this.$v5.toast(message).then(function () {
				switch (_this.fromType) {
					// 微信小程序 tabbar 页面跳转
					case 'weapp-tabBar':
						{
							window.wx.miniProgram.switchTab({
								url: successUrl
							});
							break;
						}
					default:
						{
							//navigateTo 打开简历创建页面，返回时通过 navigateBack 回到打开前的页面后，通过 redirectTo 替换页面栈（目前应用于：58本地招工回跳）
							if (_this.backType === '1') {
								window.wx.miniProgram.navigateBack({
									delta: 1,
									complete: function complete() {
										window.wx.miniProgram.redirectTo({
											url: successUrl
										});
									}
								});
							} else {
								window.wx.miniProgram.redirectTo({
									url: successUrl
								});
							}
						}
				}
			});
		}

		// 百度小程序处理

	}, {
		key: 'fromBD',
		value: function fromBD() {
			var _this2 = this;

			// 百度小程序跳转
			this.$v5.toast('简历创建并投递成功').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU'));
				window.swan.webView.redirectTo({
					url: _this2.pagefromUrl + '&deliveryCode=' + _this2.deliveryCode + '&ppu=' + ppu
				});
			});
		}

		// 支付宝小程序处理

	}, {
		key: 'fromZFB',
		value: function fromZFB() {
			var _this3 = this;

			// 支付宝小程序跳转
			this.$v5.toast('简历创建并投递成功').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU'));
				window.my.redirectTo({
					url: _this3.pagefromUrl + '&deliveryCode=' + _this3.deliveryCode + '&ppu=' + ppu
				});
			});
		}

		// 头条小程序

	}, {
		key: 'fromTT',
		value: function fromTT() {
			var _this4 = this;

			// 头条小程序跳转
			this.$v5.toast('简历创建并投递成功').then(function () {
				var ppu = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* default */].get('PPU'));
				window.tt.miniProgram.redirectTo({
					url: _this4.pagefromUrl + '&deliveryCode=' + _this4.deliveryCode + '&ppu=' + ppu
				});
			});
		}

		// 同镇

	}, {
		key: 'fromTZ',
		value: function fromTZ() {
			this.$v5.toast('简历创建并投递成功').then(function () {
				WBAPP.action.goback(true);
			});
		}
		// 校招

	}, {
		key: 'fromXZ',
		value: function fromXZ() {
			var _this5 = this;

			this.$v5.toast('简历创建成功').then(function () {
				window.location.replace(_this5.pagefromUrl);
			});
		}
	}, {
		key: 'fromCQXZ',
		value: function fromCQXZ() {
			var _this6 = this;

			this.$v5.toast('简历创建成功').then(function () {
				window.location.replace(_this6.pagefromUrl);
			});
		}

		// default

	}, {
		key: 'default',
		value: function _default() {
			var _this7 = this;

			//如果from参数不为空，则跳转指定落地页
			if (!!this.pagefromUrl) {
				this.$v5.toast('简历创建成功').then(function () {
					window.location.replace(_this7.pagefromUrl);
				});
				return;
			}
			window.location.replace(__WEBPACK_IMPORTED_MODULE_3__util_config__["a" /* default */].jlDomain + '/resumeupdate/perfectresume?rid=' + this.resumeId + '&authType=1');
		}
	}]);

	return CallbackFn;
}();



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showISDCaptcha; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var showISDCaptcha = function showISDCaptcha(responseObj, successCb) {
	var captcha = window.ISDCaptcha({
		element: 'ISDCaptcha', //验证码组件需要绑定的元素ID
		width: responseObj.controlParams.width, //图片宽度,需管理后台设置,不能再页面自定义，
		type: responseObj.level, //验证码类型; 从SCF服务register接口中组件参数返回
		showType: 'win', //展现形式;win:弹出，trigger:触发,embed:嵌入
		sessionId: responseObj.sessionId, //从SCF服务register接口中返回
		targetElm: 'loginBtn',
		winAutoShow: true, //弹出式时添加此属性会自动弹出,默认不自动弹出,点targetElm绑定的元素时弹出
		successCallback: function successCallback(data) {
			//验证码验证成功后的回调函数
			__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('captcha_successToken', data.successToken, { domain: '58.com', expires: 1 });
			__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('captcha_sessionId', responseObj.sessionId, { domain: '58.com', expires: 1 });
			successCb();
			/** 在这里可以将验证成功后的sucesstoken保存至表单中;可以做提交表单的操作*/
		},
		failCallback: function failCallback(data) {
			console.log(data.responseId);
			//alert(data.responseId);//如果有校验错误时需要做的操作时，请在这里写。暂时不要在这里写回调
		}
	});
	captcha.init(); //初始化组件
};



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_ems_plugins_lib_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__58fe_ems_plugins_lib_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__58fe_ems_plugins_lib_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_plugins_toast__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__58fe_v5_src_plugins_confirm__ = __webpack_require__(99);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__58fe_ems_plugins_lib_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__58fe_v5_src_plugins_toast__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_6__58fe_v5_src_plugins_confirm__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: {
		App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
	}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeCount", function() { return getResumeCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLastResumeInfo", function() { return getLastResumeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAreaInfo", function() { return getAreaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkMobileAuth", function() { return checkMobileAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckCode", function() { return getCheckCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verifyCheckCode", function() { return verifyCheckCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadImg", function() { return uploadImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveResume", function() { return saveResume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPrivacy", function() { return getPrivacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPrivacy", function() { return setPrivacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delivery", function() { return delivery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_cookie__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(14);




var _this = this;






// 获取简历份数
var getResumeCount = function getResumeCount(_ref, userId) {
	var commit = _ref.commit,
	    state = _ref.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getResumeCount(userId).then(function (res) {
		if (res.isSuccess) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* SET_RESUME_COUNT */], res.entity.fulltimeCount);
		}
	});
};

// 获取上一份简历信息
var getLastResumeInfo = function getLastResumeInfo(_ref2) {
	var commit = _ref2.commit,
	    state = _ref2.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getLastResumeInfo().then(function (res) {
		if (res.isSuccess) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* CHANGE_BASICINFO */], {
				key: 'pic',
				value: res.entity.picUrl
			});
			// 基础信息(必传)
			var basicInfo = {
				truename: res.entity.trueName,
				gender: res.entity.gender,
				birthday: res.entity.birthday,
				education: res.entity.education,
				workyears: res.entity.workYears
			};

			for (var key in basicInfo) {
				commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CHECK_BASICINFO */], {
					key: key,
					value: basicInfo[key],
					state: true
				});
			}
			// 修改教育经历
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CHECK_BASICINFO */], {
				key: 'educations',
				value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.entity.educations || []).replace(/profession/g, 'professional'),
				state: res.entity.educations && res.entity.educations.length > 0
			});

			// 非必填字段
			var otherInfo = {
				pic: res.entity.picUrl || ''
			};

			for (var _key in otherInfo) {
				commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* CHANGE_BASICINFO */], {
					key: _key,
					value: otherInfo[_key]
				});
			}

			// 如果存在期望信息
			if (res.entity.cateIds) {
				// 期望页面字段
				var expectInfo = {
					zpcateId: res.entity.cateIds, // 期望职位(测试)
					salary: res.entity.salaryId, //期望薪资
					targetAreaId: res.entity.targetAraeId //意向工作地点（测试）
				};

				for (var _key2 in expectInfo) {
					commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* CHECK_EXPECTIONINFO */], {
						key: _key2,
						value: expectInfo[_key2],
						state: true
					});
				}
			}

			// 如果存在期望信息数组
			if (res.entity.infoCates && res.entity.infoCates.length > 0) {
				// 期望页面字段
				var _expectInfo = {
					sessionCateList: res.entity.infoCates, // 期望职位(测试)
					sessionAreaList: res.entity.targetAreas //意向工作地点（测试）
				};

				for (var _key3 in _expectInfo) {
					commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* CHANGE_OPTION */], {
						key: _key3,
						value: _expectInfo[_key3]
					});
				}
			}
		}
	});
};

// 获取区域
var getAreaInfo = function getAreaInfo(_ref3) {
	var commit = _ref3.commit,
	    state = _ref3.state;

	var cityname = __WEBPACK_IMPORTED_MODULE_6__util__["a" /* default */].getParamVal('topArea') || __WEBPACK_IMPORTED_MODULE_5__util_cookie__["a" /* default */].get('mcity') || '';
	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getAreaInfo(cityname).then(function (res) {
		if (res.code === 0) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* SET_AREA_DATA */], res.object);
		}
	});
};

// 获取账号绑定的手机号，且校验手机号是否认证
var checkMobileAuth = function checkMobileAuth(_ref4) {
	var commit = _ref4.commit,
	    state = _ref4.state;
	var mobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	// 手机号正确
	if (mobile !== '') {
		commit('CHECK_BASICINFO', {
			key: 'mobile',
			value: mobile,
			state: true
		});
	}
	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].checkMobileAuth(mobile).then(function (res) {
		if (res.isSuccess) {
			// 初始化调用无手机号，则将返回的手机号存储到submitdata中并修改信息填写状态
			if (mobile === '' && res.entity.authMobile !== '') {
				commit('CHECK_BASICINFO', {
					key: 'mobile',
					value: res.entity.authMobile,
					state: true
				});
			}
			// 已认证
			if (res.entity.auth) {
				commit('CHECK_BASICINFO', {
					key: 'keyCode',
					value: '',
					state: true
				});
			} else {
				commit('CHECK_BASICINFO', {
					key: 'keyCode',
					value: '',
					state: false
				});
			}
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CHANGE_HASAUTHED */], res.entity);
		}
	}).catch(function (e) {
		console.log(e);
	});
};

// 获取手机验证码
var getCheckCode = function getCheckCode(_ref5, mobile) {
	var commit = _ref5.commit,
	    state = _ref5.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCheckCode(mobile).then(function (res) {
		if (res.isSuccess) {
			state.captcha.responseid = res.entity.responseid;
			state.submitData.responseid = res.entity.responseid;
		} else {
			state.captcha.errorInfo = res.returnMessage;
		}
		state.captcha.isSuccess = res.isSuccess; // 验证码获取状态
	}).catch(function (e) {
		state.captcha.isSuccess = false;
		state.captcha.errorInfo = '网络异常，请稍后重试';
	});
};

// 验证手机验证码
var verifyCheckCode = function verifyCheckCode(_ref6, params) {
	var commit = _ref6.commit,
	    state = _ref6.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].verifyCheckCode(params.mobile, params.code, state.captcha.responseid).then(function (res) {
		if (res.isSuccess) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CHECK_BASICINFO */], {
				key: 'keyCode',
				value: params.code,
				state: true
			});

			// 存储为已认证的手机号
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* SET_HASAUTHEDMOBILE */], params.mobile);
		} else {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CHECK_BASICINFO */], {
				key: 'keyCode',
				value: params.code,
				state: false
			});
		}
	}).catch(function (e) {});
};

// 头像上传
var uploadImg = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref8, params) {
		var commit = _ref8.commit,
		    state = _ref8.state;
		var imgData, res, data, code, uploadUrl, fileName, imgUrl, picRes;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						imgData = params.dataUrl;
						_context.prev = 1;
						_context.next = 4;
						return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUploadUrl();

					case 4:
						res = _context.sent;
						data = res.data, code = res.code;

						if (!code) {
							_context.next = 9;
							break;
						}

						commit('CHANGE_UPLOAD_STATE', {
							state: false,
							picUrl: ''
						});
						return _context.abrupt('return');

					case 9:
						uploadUrl = data[0].url;
						fileName = data[0].fileName;
						imgUrl = 'https://pic1.58cdn.com.cn/nowater/resume/' + fileName;
						_context.next = 14;
						return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadPic({ imgData: __WEBPACK_IMPORTED_MODULE_6__util__["a" /* default */].dataURLtoBlob(imgData, fileName), uploadUrl: uploadUrl });

					case 14:
						picRes = _context.sent;

						if (picRes.status === 200) {
							if (params.isOrigin) {
								state.originPic = imgUrl;
							} else {
								commit('CHANGE_UPLOAD_STATE', {
									state: true,
									picUrl: imgUrl
								});
							}
						}
						_context.next = 22;
						break;

					case 18:
						_context.prev = 18;
						_context.t0 = _context['catch'](1);

						console.error('upload error:', _context.t0);

						commit('CHANGE_UPLOAD_STATE', {
							state: false,
							picUrl: ''
						});

					case 22:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this, [[1, 18]]);
	}));

	return function uploadImg(_x2, _x3) {
		return _ref7.apply(this, arguments);
	};
}();

// 简历发布
var saveResume = function saveResume(_ref9) {
	var commit = _ref9.commit,
	    state = _ref9.state;

	// 非(大专及以上 + 校招 + 应届生)，教育经历置空
	if (!(state.submitData.education > 3 && (state.pagefrom === 'fromXZ' || state.pagefrom === 'fromCQXZ') && state.submitData.workyears === 5)) {
		commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CHECK_BASICINFO */], {
			key: 'educations',
			value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()([]),
			state: true
		});
	}
	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveResume(state.submitData).then(function (res) {
		// 发布成功
		if (res.code === 0) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* CHANGE_SUBMITSTATE */], {
				submitState: true,
				resumeId: res.data.resumeId,
				submitErrorInfo: ''
			});
		} else if (res.code === 13000002) {
			//简历分数达到上限3份
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* SET_RESUME_COUNT */], 3);
		} else if (res.code === 13000029) {
			// 出滑块验证码
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* CHANGE_SUBMITSTATE */], {
				submitState: false,
				responseObj: res.data
			});
		} else if (res.code === 13000030) {
			// 跳转个人认证页面（目前后端已加入白名单，小程序走不到该逻辑）
			location.href = 'https://authlist.58.com/authcustom/index?pId=2&appId=OLKcIUMVRg&callbackurl=' + encodeURIComponent(location.origin + location.pathname + location.search + '&comefrom=auth' + location.hash);
			return false;
		} else if (res.code === 302) {
			// 简历发布频繁
			location.href = res.data.url;
			return false;
		} else {
			var message = res.message || '网络异常，请稍后重试';
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* CHANGE_SUBMITSTATE */], {
				submitState: false,
				resumeId: '',
				submitErrorInfo: message
			});
		}
	}).catch(function (e) {
		commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* CHANGE_SUBMITSTATE */], {
			submitState: false,
			resumeId: '',
			submitErrorInfo: e.message.split(':')[1] || '网络异常，请稍后重试'
		});
	});
};

// 获取用户隐私设置
var getPrivacy = function getPrivacy(_ref10) {
	var commit = _ref10.commit,
	    state = _ref10.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getPrivacy().then(function (res) {
		if (res.code === 0) {
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_PRIVACY */], {
				key: 'showStatus',
				value: res.object.showStatus
			});
			commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_PRIVACY */], {
				key: 'blockIndustry',
				value: res.object.blockIndustry
			});
		}
	});
};

// 保存隐私设置
var setPrivacy = function setPrivacy(_ref11) {
	var commit = _ref11.commit,
	    state = _ref11.state;

	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].setPrivacy(state.privacyData).then(function (res) {
		if (res.code === 0) {
			state.privacySettingState = true;
		} else {
			state.privacySettingState = false;
			state.privacyErrorInfo = res.message;
		}
	}).catch(function (e) {
		state.privacySettingState = false;
		state.privacyErrorInfo = e.message;
	});
};

// 投递操作
var delivery = function delivery(_ref12) {
	var commit = _ref12.commit,
	    state = _ref12.state;

	var params = state.deliveryObj;
	params.resumeId = state.resumeId;
	return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].delivery(params).then(function (res) {
		var successCode = [12000011, 12000012, 12000013, 12000014, 12000015, 12000016, 12000017, 12000018];

		// 投递结果code
		state.deliveryCode = res.code;

		// 成功回调
		if (successCode.indexOf(res.code) > -1) {
			state.deliveryState = true;
		} else {
			state.deliveryMsg = res.msg;
			state.deliveryState = false;
		}
	}).catch(function (e) {
		state.deliveryState = false;
	});
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "source", function() { return source; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resumeType", function() { return resumeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user58pic", function() { return user58pic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobUrl", function() { return jobUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categoryInitList", function() { return categoryInitList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pagefromLog", function() { return pagefromLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pagetypeLog", function() { return pagetypeLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pagefromUrl", function() { return pagefromUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pagefrom", function() { return pagefrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resumeCount", function() { return resumeCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "basicInfo", function() { return basicInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "basicInfoOk", function() { return basicInfoOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expectionInfo", function() { return expectionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expectionInfoOk", function() { return expectionInfoOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasAuthedMobile", function() { return hasAuthedMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authMobile", function() { return authMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasAuthed", function() { return hasAuthed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCaptchaState", function() { return getCaptchaState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCaptchaErrorInfo", function() { return getCaptchaErrorInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkCodeRight", function() { return checkCodeRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pic", function() { return pic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "originPic", function() { return originPic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truename", function() { return truename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gender", function() { return gender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mobile", function() { return mobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "birthday", function() { return birthday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "education", function() { return education; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workyears", function() { return workyears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "educations", function() { return educations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "infoId", function() { return infoId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sessionCateList", function() { return sessionCateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "salary", function() { return salary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sessionAreaList", function() { return sessionAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showStatus", function() { return showStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showIndustry", function() { return showIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockIndustry", function() { return blockIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resumeId", function() { return resumeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitState", function() { return submitState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitErrorInfo", function() { return submitErrorInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "privacySettingState", function() { return privacySettingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "privacyErrorInfo", function() { return privacyErrorInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areaInfo", function() { return areaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areaName", function() { return areaName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadState", function() { return uploadState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryCode", function() { return deliveryCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryState", function() { return deliveryState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryMsg", function() { return deliveryMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "educationInfo", function() { return educationInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "educationCheck", function() { return educationCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "educationOk", function() { return educationOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradschool", function() { return gradschool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradmajor", function() { return gradmajor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradtime", function() { return gradtime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eduIndex", function() { return eduIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eduState", function() { return eduState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showISDCaptcha", function() { return showISDCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "responseObj", function() { return responseObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allConfigOtherData", function() { return allConfigOtherData; });
// global中的信息
var source = function source(state) {
	return state.global.source;
}; // 完整简历3，M微简历13，联盟18
var resumeType = function resumeType(state) {
	return state.global.resumeType;
}; // 完整简历1，M微简历2，联盟3
var user58pic = function user58pic(state) {
	return state.global.user58pic;
}; // 58用户头像
var jobUrl = function jobUrl(state) {
	return state.global.jobUrl;
}; // 达到6份后的引导职位列表页链接
var categoryInitList = function categoryInitList(state) {
	return state.global.categoryInitList;
}; // 默认选择的职位

// 页面来源（区分微简历/联盟以及是否登录）
var pagefromLog = function pagefromLog(state) {
	var suffix = ''; // 后缀

	// 埋点中需要区分初始登录状态
	if (state.global.isLogin) {
		suffix += '_login';
	} else {
		suffix += '_nologin';
	}

	// 微简历/联盟区分
	if (state.global.resumeType === 2) {
		suffix += '_micro';
	} else if (state.global.resumeType === 3) {
		suffix += '_union';
	}

	return suffix; // 简历来源log标识
};

// 页面类型（只区分微简历/联盟简历，不区分登录态）
var pagetypeLog = function pagetypeLog(state) {
	var suffix = ''; // 后缀

	// 微简历/联盟区分
	if (state.global.resumeType === 2) {
		suffix += '_micro';
	} else if (state.global.resumeType === 3) {
		suffix += '_union';
	}

	return suffix; // 简历来源log标识
};

// 基本简历状态信息
var pagefromUrl = function pagefromUrl(state) {
	return state.pagefromUrl;
};
var isLogin = function isLogin(state) {
	return state.isLogin;
};
var pagefrom = function pagefrom(state) {
	return state.pagefrom;
}; // 页面来源
var resumeCount = function resumeCount(state) {
	return state.resumeCount;
};
var basicInfo = function basicInfo(state) {
	return state.basicInfo;
};
var basicInfoOk = function basicInfoOk(state) {
	return state.basicInfoOk;
};
var expectionInfo = function expectionInfo(state) {
	return state.expectionInfo;
};
var expectionInfoOk = function expectionInfoOk(state) {
	return state.expectionInfoOk;
};

// 手机号相关信息
var hasAuthedMobile = function hasAuthedMobile(state) {
	return state.hasAuthedMobile;
}; // 后置登录使用的手机号或已通过认证的手机号
var authMobile = function authMobile(state) {
	return state.authMobile;
}; // 已认证手机号
var hasAuthed = function hasAuthed(state) {
	return state.hasAuthed;
}; // 手机号是否已认证
var getCaptchaState = function getCaptchaState(state) {
	return state.captcha.isSuccess;
}; // 获取验证码状态
var getCaptchaErrorInfo = function getCaptchaErrorInfo(state) {
	return state.captcha.errorInfo;
}; // 获取验证码失败错误信息
var checkCodeRight = function checkCodeRight(state) {
	return state.basicInfo.keyCode;
}; // 验证码是否正确

// 基本信息
var pic = function pic(state) {
	return state.submitData.pic;
};
var originPic = function originPic(state) {
	return state.originPic;
};
var truename = function truename(state) {
	return state.submitData.truename;
};
var gender = function gender(state) {
	return state.submitData.gender;
};
var mobile = function mobile(state) {
	return state.submitData.mobile;
};
var birthday = function birthday(state) {
	return state.submitData.birthday.split('-')[0];
};
var education = function education(state) {
	return state.submitData.education;
};
var workyears = function workyears(state) {
	return state.submitData.workyears;
};
var educations = function educations(state) {
	return JSON.parse(state.submitData.educations || '[]');
};
var infoId = function infoId(state) {
	return state.infoId;
}; // 职位id

// 期望信息
var sessionCateList = function sessionCateList(state) {
	return state.sessionCateList;
};
var salary = function salary(state) {
	return state.submitData.salary;
};
var sessionAreaList = function sessionAreaList(state) {
	return state.sessionAreaList;
};

// 隐私设置信息
var showStatus = function showStatus(state) {
	return state.privacyData.showStatus;
};
var showIndustry = function showIndustry(state) {
	return state.showIndustry;
};
var blockIndustry = function blockIndustry(state) {
	return state.privacyData.blockIndustry;
};

// 保存简历接口返回结果
var resumeId = function resumeId(state) {
	return state.resumeId;
};
var submitState = function submitState(state) {
	return state.submitState;
};
var submitErrorInfo = function submitErrorInfo(state) {
	return state.submitErrorInfo;
};
var privacySettingState = function privacySettingState(state) {
	return state.privacySettingState;
};
var privacyErrorInfo = function privacyErrorInfo(state) {
	return state.privacyErrorInfo;
};

// 选择区域列表
var areaInfo = function areaInfo(state) {
	return state.areaInfo;
};
var areaName = function areaName(state) {
	return state.global.areaName ? state.global.areaName : '北京';
}; // 当前城市名称(默认北京)

// 头像上传结果
var uploadState = function uploadState(state) {
	return state.uploadState;
}; // 头像上传结果

// 投递返回code
var deliveryCode = function deliveryCode(state) {
	return state.deliveryCode;
}; // 投递返回code

// 投递的状态
var deliveryState = function deliveryState(state) {
	return state.deliveryState;
}; // 投递返回code

// 投递错误提示
var deliveryMsg = function deliveryMsg(state) {
	return state.deliveryMsg;
}; // 投递返回code

// 教育经历相关
var educationInfo = function educationInfo(state) {
	return state.educationInfo;
};
var educationCheck = function educationCheck(state) {
	return state.educationCheck;
};
var educationOk = function educationOk(state) {
	return state.educationOk;
};

var gradschool = function gradschool(state) {
	return state.educationInfo.gradschool;
};
var gradmajor = function gradmajor(state) {
	return state.educationInfo.gradmajor;
};
var gradtime = function gradtime(state) {
	return state.educationInfo.gradtime;
};
var eduIndex = function eduIndex(state) {
	return state.educationInfo.eduIndex;
};
var eduState = function eduState(state) {
	return state.educationInfo.eduState;
};

// 滑块验证码
var showISDCaptcha = function showISDCaptcha(state) {
	return state.showISDCaptcha;
};
var responseObj = function responseObj(state) {
	return state.responseObj;
};

// 静态数据
var allConfigOtherData = function allConfigOtherData(state) {
	return state.allConfigOtherData;
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(31);


var _types$CHANGE_LOGINST;




/* harmony default export */ __webpack_exports__["a"] = (_types$CHANGE_LOGINST = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CHANGE_LOGINSTATE */], function (state, payload) {
	state.isLogin = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_HASAUTHEDMOBILE */], function (state, payload) {
	state.hasAuthedMobile = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_RESUME_COUNT */], function (state, payload) {
	state.resumeCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_AREA_DATA */], function (state, payload) {
	var secondarea = payload.secondarea,
	    thridarea = payload.thridarea;
	// 一级城市全部的子元素
	var item = { parentId: secondarea[0].id, list: [secondarea[0]] };
	thridarea.unshift(item);

	state.areaInfo = [secondarea, thridarea];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CHANGE_HASAUTHED */], function (state, payload) {
	state.hasAuthed = payload.auth; // 是否已认证
	if (payload.authMobile) {
		state.authMobile = payload.authMobile; // 存储返回的手机号
	}

	// 如果为已认证状态，则手机号/验证码置为true
	if (payload.auth) {
		state.basicInfo.mobile = true; // 修改填写状态
		state.basicInfo.keyCode = true; // 修改填写状态

		var basicInfo = state.basicInfo;
		for (var prop in basicInfo) {
			if (basicInfo.hasOwnProperty(prop)) {
				if (basicInfo[prop]) {
					state.basicInfoOk = true;
				} else {
					state.basicInfoOk = false;
					break;
				}
			}
		}
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_PRIVACY */], function (state, payload) {
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.privacyData, payload.key, payload.value); // 修改填写的值，为了能够监测到修改，所以使用set
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_BLOCK_INDUSTRY */], function (state, payload) {
	state.showIndustry = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* CHANGE_UPLOAD_STATE */], function (state, payload) {
	state.uploadState = payload.state;
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.submitData, 'pic', payload.picUrl); // 修改填写的值，为了第二页能够监测到修改，所以使用set
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* CHANGE_SUBMITSTATE */], function (state, payload) {
	state.submitState = payload.submitState;
	state.resumeId = payload.resumeId;
	state.submitErrorInfo = payload.submitErrorInfo;
	state.responseObj = payload.responseObj; // 滑块验证码参数
	state.showISDCaptcha = payload.responseObj ? true : false; // 是否展示滑块验证码
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* CHANGE_OPTION */], function (state, payload) {
	state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* CHANGE_BASICINFO */], function (state, payload) {
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* CHECK_BASICINFO */], function (state, payload) {
	state.basicInfo[payload.key] = payload.state; // 修改填写状态
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

	var basicInfo = state.basicInfo;
	for (var prop in basicInfo) {
		if (basicInfo.hasOwnProperty(prop)) {
			if (basicInfo[prop]) {
				state.basicInfoOk = true;
			} else {
				state.basicInfoOk = false;
				break;
			}
		}
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CHECK_EXPECTIONINFO */], function (state, payload) {
	state.expectionInfo[payload.key] = payload.state; // 修改填写状态
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

	var expectionInfo = state.expectionInfo;
	for (var prop in expectionInfo) {
		if (expectionInfo.hasOwnProperty(prop)) {
			if (expectionInfo[prop]) {
				state.expectionInfoOk = true;
			} else {
				state.expectionInfoOk = false;
				break;
			}
		}
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CHANGE_EDUTION */], function (state, payload) {
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.educationInfo, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CHECK_EDUINFO */], function (state, payload) {
	state.educationCheck[payload.key] = payload.state;
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.educationInfo, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

	var educationCheck = state.educationCheck;
	for (var prop in educationCheck) {
		if (educationCheck.hasOwnProperty(prop)) {
			if (educationCheck[prop]) {
				state.educationOk = true;
			} else {
				state.educationOk = false;
				break;
			}
		}
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CHANGE_LOGINST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_ALLCONFIGOTHERDATA */], function (state, payload) {
	state.allConfigOtherData = payload;
}), _types$CHANGE_LOGINST);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var backAlert = function backAlert(callbackFn, from) {
	window.history.replaceState({
		goback: true
	}, '', '');
	window.history.pushState({
		goback: true
	}, '', '');
	window.onpopstate = function (e) {
		if (e.state.goback) {
			window.clickLog && window.clickLog('from=jianli_post_tstc_full' + from);
			callbackFn();
		}
	};
};

/* harmony default export */ __webpack_exports__["a"] = (backAlert);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
	comment: 行业类别数据
*/
var industryList = [[{
	id: '0',
	name: '无'
}, {
	id: '269',
	name: '房地产/物业管理'
}, {
	id: '253',
	name: '保险'
}, {
	id: '251',
	name: '财务/审计'
}, {
	id: '252',
	name: '金融/银行'
}, {
	id: '295',
	name: '信托/拍卖'
}, {
	id: '275',
	name: '教育/科研/培训'
}, {
	id: '272',
	name: '中介/专业服务'
}, {
	id: '3527',
	name: '人力资源服务'
}, {
	id: '262',
	name: '医疗/保健/卫生/美容'
}, {
	id: '277',
	name: '娱乐休闲/餐饮/服务'
}, {
	id: '276',
	name: '旅游/酒店'
}, {
	id: '278',
	name: '交通/运输/物流'
}, {
	id: '261',
	name: '汽车/摩托车'
}, {
	id: '244',
	name: '互联网/电子商务'
}, {
	id: '245',
	name: '计算机软件'
}, {
	id: '246',
	name: '计算机硬件'
}, {
	id: '291',
	name: '游戏'
}, {
	id: '254',
	name: '贸易/进出口'
}, {
	id: '259',
	name: '办公用品及设备'
}, {
	id: '255',
	name: '批发/零售'
}, {
	id: '258',
	name: '服装/纺织/皮革'
}, {
	id: '288',
	name: '陶瓷卫浴'
}, {
	id: '289',
	name: '家具灯饰'
}, {
	id: '256',
	name: '快速消费品(食品/饮料等)'
}, {
	id: '257',
	name: '耐用消费品(家具/家电等)'
}, {
	id: '296',
	name: '租赁服务'
}, {
	id: '270',
	name: '建筑/建材'
}, {
	id: '271',
	name: '家居/室内设计/装潢'
}, {
	id: '260',
	name: '钢铁/机械/设备/重工'
}, {
	id: '268',
	name: '出版/印刷/造纸'
}, {
	id: '282',
	name: '原材料和加工'
}, {
	id: '263',
	name: '生物/制药/医疗器械'
}, {
	id: '248',
	name: '通信/电信'
}, {
	id: '247',
	name: 'IT服务/系统集成'
}, {
	id: '249',
	name: '电子技术/半导体/集成电路'
}, {
	id: '250',
	name: '仪器仪表/工业自动化'
}, {
	id: '264',
	name: '广告/创意'
}, {
	id: '265',
	name: '公关/市场推广/会展'
}, {
	id: '266',
	name: '文体/影视/艺术'
}, {
	id: '267',
	name: '媒体传播'
}, {
	id: '280',
	name: '化工/采掘/冶炼'
}, {
	id: '281',
	name: '能源(电力/水利/矿产'
}, {
	id: '284',
	name: '环保'
}, {
	id: '279',
	name: '航天/航空'
}, {
	id: '283',
	name: '政府/非盈利机构'
}, {
	id: '285',
	name: '农林牧渔'
}, {
	id: '286',
	name: '多元化集团'
}, {
	id: '273',
	name: '检测/认证'
}, {
	id: '274',
	name: '法律/法务'
}, {
	id: '294',
	name: '咨询/顾问'
}, {
	id: '287',
	name: '其他行业'
}]];

/* harmony default export */ __webpack_exports__["a"] = (industryList);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
	comment: M端BinaryFile模块
*/
var BinaryFile = function BinaryFile(strData, iDataOffset, iDataLength) {
	var data = strData;
	var dataOffset = iDataOffset || 0;
	var dataLength = 0;
	this.getRawData = function () {
		return data;
	};
	if (typeof strData == 'string') {
		dataLength = iDataLength || data.length;
		this.getByteAt = function (iOffset) {
			return data.charCodeAt(iOffset + dataOffset) & 255;
		};
		this.getBytesAt = function (iOffset, iLength) {
			var aBytes = [];
			for (var i = 0; i < iLength; i++) {
				aBytes[i] = data.charCodeAt(iOffset + i + dataOffset) & 255;
			}
			return aBytes;
		};
	} else if (typeof strData == 'unknown') {
		dataLength = iDataLength || IEBinary_getLength(data);
		this.getByteAt = function (iOffset) {
			return IEBinary_getByteAt(data, iOffset + dataOffset);
		};
		this.getBytesAt = function (iOffset, iLength) {
			return new VBArray(IEBinary_getBytesAt(data, iOffset + dataOffset, iLength)).toArray();
		};
	}
	this.getLength = function () {
		return dataLength;
	};
	this.getSByteAt = function (iOffset) {
		var iByte = this.getByteAt(iOffset);
		if (iByte > 127) return iByte - 256;else return iByte;
	};
	this.getShortAt = function (iOffset, bBigEndian) {
		var iShort = bBigEndian ? (this.getByteAt(iOffset) << 8) + this.getByteAt(iOffset + 1) : (this.getByteAt(iOffset + 1) << 8) + this.getByteAt(iOffset);
		if (iShort < 0) iShort += 65536;
		return iShort;
	};
	this.getSShortAt = function (iOffset, bBigEndian) {
		var iUShort = this.getShortAt(iOffset, bBigEndian);
		if (iUShort > 32767) return iUShort - 65536;else return iUShort;
	};
	this.getLongAt = function (iOffset, bBigEndian) {
		var iByte1 = this.getByteAt(iOffset),
		    iByte2 = this.getByteAt(iOffset + 1),
		    iByte3 = this.getByteAt(iOffset + 2),
		    iByte4 = this.getByteAt(iOffset + 3);
		var iLong = bBigEndian ? (((iByte1 << 8) + iByte2 << 8) + iByte3 << 8) + iByte4 : (((iByte4 << 8) + iByte3 << 8) + iByte2 << 8) + iByte1;
		if (iLong < 0) iLong += 4294967296;
		return iLong;
	};
	this.getSLongAt = function (iOffset, bBigEndian) {
		var iULong = this.getLongAt(iOffset, bBigEndian);
		if (iULong > 2147483647) return iULong - 4294967296;else return iULong;
	};
	this.getStringAt = function (iOffset, iLength) {
		var aStr = [];
		var aBytes = this.getBytesAt(iOffset, iLength);
		for (var j = 0; j < iLength; j++) {
			aStr[j] = String.fromCharCode(aBytes[j]);
		}
		return aStr.join('');
	};
	this.getCharAt = function (iOffset) {
		return String.fromCharCode(this.getByteAt(iOffset));
	};
	this.toBase64 = function () {
		return window.btoa(data);
	};
	this.fromBase64 = function (strBase64) {
		data = window.atob(strBase64);
	};
};

/* harmony default export */ __webpack_exports__["a"] = (BinaryFile);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EXIF = {
	Tags: {
		36864: 'ExifVersion',
		40960: 'FlashpixVersion',
		40961: 'ColorSpace',
		40962: 'PixelXDimension',
		40963: 'PixelYDimension',
		37121: 'ComponentsConfiguration',
		37122: 'CompressedBitsPerPixel',
		37500: 'MakerNote',
		37510: 'UserComment',
		40964: 'RelatedSoundFile',
		36867: 'DateTimeOriginal',
		36868: 'DateTimeDigitized',
		37520: 'SubsecTime',
		37521: 'SubsecTimeOriginal',
		37522: 'SubsecTimeDigitized',
		33434: 'ExposureTime',
		33437: 'FNumber',
		34850: 'ExposureProgram',
		34852: 'SpectralSensitivity',
		34855: 'ISOSpeedRatings',
		34856: 'OECF',
		37377: 'ShutterSpeedValue',
		37378: 'ApertureValue',
		37379: 'BrightnessValue',
		37380: 'ExposureBias',
		37381: 'MaxApertureValue',
		37382: 'SubjectDistance',
		37383: 'MeteringMode',
		37384: 'LightSource',
		37385: 'Flash',
		37396: 'SubjectArea',
		37386: 'FocalLength',
		41483: 'FlashEnergy',
		41484: 'SpatialFrequencyResponse',
		41486: 'FocalPlaneXResolution',
		41487: 'FocalPlaneYResolution',
		41488: 'FocalPlaneResolutionUnit',
		41492: 'SubjectLocation',
		41493: 'ExposureIndex',
		41495: 'SensingMethod',
		41728: 'FileSource',
		41729: 'SceneType',
		41730: 'CFAPattern',
		41985: 'CustomRendered',
		41986: 'ExposureMode',
		41987: 'WhiteBalance',
		41988: 'DigitalZoomRation',
		41989: 'FocalLengthIn35mmFilm',
		41990: 'SceneCaptureType',
		41991: 'GainControl',
		41992: 'Contrast',
		41993: 'Saturation',
		41994: 'Sharpness',
		41995: 'DeviceSettingDescription',
		41996: 'SubjectDistanceRange',
		40965: 'InteroperabilityIFDPointer',
		42016: 'ImageUniqueID'
	},
	TiffTags: {
		256: 'ImageWidth',
		257: 'ImageHeight',
		34665: 'ExifIFDPointer',
		34853: 'GPSInfoIFDPointer',
		40965: 'InteroperabilityIFDPointer',
		258: 'BitsPerSample',
		259: 'Compression',
		262: 'PhotometricInterpretation',
		274: 'Orientation',
		277: 'SamplesPerPixel',
		284: 'PlanarConfiguration',
		530: 'YCbCrSubSampling',
		531: 'YCbCrPositioning',
		282: 'XResolution',
		283: 'YResolution',
		296: 'ResolutionUnit',
		273: 'StripOffsets',
		278: 'RowsPerStrip',
		279: 'StripByteCounts',
		513: 'JPEGInterchangeFormat',
		514: 'JPEGInterchangeFormatLength',
		301: 'TransferFunction',
		318: 'WhitePoint',
		319: 'PrimaryChromaticities',
		529: 'YCbCrCoefficients',
		532: 'ReferenceBlackWhite',
		306: 'DateTime',
		270: 'ImageDescription',
		271: 'Make',
		272: 'Model',
		305: 'Software',
		315: 'Artist',
		33432: 'Copyright'
	},
	GPSTags: {
		0: 'GPSVersionID',
		1: 'GPSLatitudeRef',
		2: 'GPSLatitude',
		3: 'GPSLongitudeRef',
		4: 'GPSLongitude',
		5: 'GPSAltitudeRef',
		6: 'GPSAltitude',
		7: 'GPSTimeStamp',
		8: 'GPSSatellites',
		9: 'GPSStatus',
		10: 'GPSMeasureMode',
		11: 'GPSDOP',
		12: 'GPSSpeedRef',
		13: 'GPSSpeed',
		14: 'GPSTrackRef',
		15: 'GPSTrack',
		16: 'GPSImgDirectionRef',
		17: 'GPSImgDirection',
		18: 'GPSMapDatum',
		19: 'GPSDestLatitudeRef',
		20: 'GPSDestLatitude',
		21: 'GPSDestLongitudeRef',
		22: 'GPSDestLongitude',
		23: 'GPSDestBearingRef',
		24: 'GPSDestBearing',
		25: 'GPSDestDistanceRef',
		26: 'GPSDestDistance',
		27: 'GPSProcessingMethod',
		28: 'GPSAreaInformation',
		29: 'GPSDateStamp',
		30: 'GPSDifferential'
	},
	StringValues: {
		ExposureProgram: {
			0: 'Not defined',
			1: 'Manual',
			2: 'Normal program',
			3: 'Aperture priority',
			4: 'Shutter priority',
			5: 'Creative program',
			6: 'Action program',
			7: 'Portrait mode',
			8: 'Landscape mode'
		},
		MeteringMode: {
			0: 'Unknown',
			1: 'Average',
			2: 'CenterWeightedAverage',
			3: 'Spot',
			4: 'MultiSpot',
			5: 'Pattern',
			6: 'Partial',
			255: 'Other'
		},
		LightSource: {
			0: 'Unknown',
			1: 'Daylight',
			2: 'Fluorescent',
			3: 'Tungsten (incandescent light)',
			4: 'Flash',
			9: 'Fine weather',
			10: 'Cloudy weather',
			11: 'Shade',
			12: 'Daylight fluorescent (D 5700 - 7100K)',
			13: 'Day white fluorescent (N 4600 - 5400K)',
			14: 'Cool white fluorescent (W 3900 - 4500K)',
			15: 'White fluorescent (WW 3200 - 3700K)',
			17: 'Standard light A',
			18: 'Standard light B',
			19: 'Standard light C',
			20: 'D55',
			21: 'D65',
			22: 'D75',
			23: 'D50',
			24: 'ISO studio tungsten',
			255: 'Other'
		},
		Flash: {
			0: 'Flash did not fire',
			1: 'Flash fired',
			5: 'Strobe return light not detected',
			7: 'Strobe return light detected',
			9: 'Flash fired, compulsory flash mode',
			13: 'Flash fired, compulsory flash mode, return light not detected',
			15: 'Flash fired, compulsory flash mode, return light detected',
			16: 'Flash did not fire, compulsory flash mode',
			24: 'Flash did not fire, auto mode',
			25: 'Flash fired, auto mode',
			29: 'Flash fired, auto mode, return light not detected',
			31: 'Flash fired, auto mode, return light detected',
			32: 'No flash function',
			65: 'Flash fired, red-eye reduction mode',
			69: 'Flash fired, red-eye reduction mode, return light not detected',
			71: 'Flash fired, red-eye reduction mode, return light detected',
			73: 'Flash fired, compulsory flash mode, red-eye reduction mode',
			77: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
			79: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
			89: 'Flash fired, auto mode, red-eye reduction mode',
			93: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
			95: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
		},
		SensingMethod: {
			1: 'Not defined',
			2: 'One-chip color area sensor',
			3: 'Two-chip color area sensor',
			4: 'Three-chip color area sensor',
			5: 'Color sequential area sensor',
			7: 'Trilinear sensor',
			8: 'Color sequential linear sensor'
		},
		SceneCaptureType: {
			0: 'Standard',
			1: 'Landscape',
			2: 'Portrait',
			3: 'Night scene'
		},
		SceneType: {
			1: 'Directly photographed'
		},
		CustomRendered: {
			0: 'Normal process',
			1: 'Custom process'
		},
		WhiteBalance: {
			0: 'Auto white balance',
			1: 'Manual white balance'
		},
		GainControl: {
			0: 'None',
			1: 'Low gain up',
			2: 'High gain up',
			3: 'Low gain down',
			4: 'High gain down'
		},
		Contrast: {
			0: 'Normal',
			1: 'Soft',
			2: 'Hard'
		},
		Saturation: {
			0: 'Normal',
			1: 'Low saturation',
			2: 'High saturation'
		},
		Sharpness: {
			0: 'Normal',
			1: 'Soft',
			2: 'Hard'
		},
		SubjectDistanceRange: {
			0: 'Unknown',
			1: 'Macro',
			2: 'Close view',
			3: 'Distant view'
		},
		FileSource: {
			3: 'DSC'
		},
		Components: {
			0: '',
			1: 'Y',
			2: 'Cb',
			3: 'Cr',
			4: 'R',
			5: 'G',
			6: 'B'
		}
	}
};

var bDebug = false;

function findEXIFinJPEG(oFile) {
	if (oFile.getByteAt(0) !== 255 || oFile.getByteAt(1) !== 216) {
		return false;
	}
	var iOffset = 2;
	var iLength = oFile.getLength();
	while (iOffset < iLength) {
		if (oFile.getByteAt(iOffset) !== 255) {
			if (bDebug) {
				console.log('Not a valid marker at offset ' + iOffset + ', found: ' + oFile.getByteAt(iOffset));
			}

			return false;
		}
		var iMarker = oFile.getByteAt(iOffset + 1);
		if (iMarker === 22400) {
			if (bDebug) {
				console.log('Found 0xFFE1 marker');
			}
			return readEXIFData(oFile, iOffset + 4, oFile.getShortAt(iOffset + 2, true) - 2);
			// iOffset += 2 + oFile.getShortAt(iOffset + 2, true);
		} else if (iMarker === 225) {
			if (bDebug) {
				console.log('Found 0xFFE1 marker');
			}
			return readEXIFData(oFile, iOffset + 4, oFile.getShortAt(iOffset + 2, true) - 2);
		} else {
			iOffset += 2 + oFile.getShortAt(iOffset + 2, true);
		}
	}
}

function readTags(oFile, iTIFFStart, iDirStart, oStrings, bBigEnd) {
	var iEntries = oFile.getShortAt(iDirStart, bBigEnd);
	var oTags = {};
	for (var i = 0; i < iEntries; i++) {
		var iEntryOffset = iDirStart + i * 12 + 2;
		var strTag = oStrings[oFile.getShortAt(iEntryOffset, bBigEnd)];
		if (!strTag && bDebug) {
			console.log('Unknown tag: ' + oFile.getShortAt(iEntryOffset, bBigEnd));
		}

		oTags[strTag] = readTagValue(oFile, iEntryOffset, iTIFFStart, iDirStart, bBigEnd);
	}
	return oTags;
}

function readTagValue(oFile, iEntryOffset, iTIFFStart, iDirStart, bBigEnd) {
	var iType = oFile.getShortAt(iEntryOffset + 2, bBigEnd);
	var iNumValues = oFile.getLongAt(iEntryOffset + 4, bBigEnd);
	var iValueOffset = oFile.getLongAt(iEntryOffset + 8, bBigEnd) + iTIFFStart;
	switch (iType) {
		case 1:
		case 7:
			if (iNumValues === 1) {
				return oFile.getByteAt(iEntryOffset + 8, bBigEnd);
			} else {
				var iValOffset = iNumValues > 4 ? iValueOffset : iEntryOffset + 8;
				var aVals = [];
				for (var n = 0; n < iNumValues; n++) {
					aVals[n] = oFile.getByteAt(iValOffset + n);
				}
				return aVals;
			}
		case 2:
			var iStringOffset = iNumValues > 4 ? iValueOffset : iEntryOffset + 8;
			return oFile.getStringAt(iStringOffset, iNumValues - 1);
		case 3:
			if (iNumValues === 1) {
				return oFile.getShortAt(iEntryOffset + 8, bBigEnd);
			} else {
				var _iValOffset = iNumValues > 2 ? iValueOffset : iEntryOffset + 8;
				var _aVals = [];
				for (var _n = 0; _n < iNumValues; _n++) {
					_aVals[_n] = oFile.getShortAt(_iValOffset + 2 * _n, bBigEnd);
				}
				return _aVals;
			}
		case 4:
			if (iNumValues === 1) {
				return oFile.getLongAt(iEntryOffset + 8, bBigEnd);
			} else {
				var _aVals2 = [];
				for (var _n2 = 0; _n2 < iNumValues; _n2++) {
					_aVals2[_n2] = oFile.getLongAt(iValueOffset + 4 * _n2, bBigEnd);
				}
				return _aVals2;
			}
		case 5:
			if (iNumValues === 1) {
				return oFile.getLongAt(iValueOffset, bBigEnd) / oFile.getLongAt(iValueOffset + 4, bBigEnd);
			} else {
				var _aVals3 = [];
				for (var _n3 = 0; _n3 < iNumValues; _n3++) {
					_aVals3[_n3] = oFile.getLongAt(iValueOffset + 8 * _n3, bBigEnd) / oFile.getLongAt(iValueOffset + 4 + 8 * _n3, bBigEnd);
				}
				return _aVals3;
			}
		case 9:
			if (iNumValues === 1) {
				return oFile.getSLongAt(iEntryOffset + 8, bBigEnd);
			} else {
				var _aVals4 = [];
				for (var _n4 = 0; _n4 < iNumValues; _n4++) {
					_aVals4[_n4] = oFile.getSLongAt(iValueOffset + 4 * _n4, bBigEnd);
				}
				return _aVals4;
			}
		case 10:
			if (iNumValues === 1) {
				return oFile.getSLongAt(iValueOffset, bBigEnd) / oFile.getSLongAt(iValueOffset + 4, bBigEnd);
			} else {
				var _aVals5 = [];
				for (var _n5 = 0; _n5 < iNumValues; _n5++) {
					_aVals5[_n5] = oFile.getSLongAt(iValueOffset + 8 * _n5, bBigEnd) / oFile.getSLongAt(iValueOffset + 4 + 8 * _n5, bBigEnd);
				}
				return _aVals5;
			}
	}
}

function readEXIFData(oFile, iStart, iLength) {
	if (oFile.getStringAt(iStart, 4) !== 'Exif') {
		if (bDebug) {
			console.log('Not valid EXIF data! ' + oFile.getStringAt(iStart, 4));
		}
		return false;
	}
	var bBigEnd = void 0;
	var iTIFFOffset = iStart + 6;
	if (oFile.getShortAt(iTIFFOffset) === 18761) {
		bBigEnd = false;
	} else if (oFile.getShortAt(iTIFFOffset) === 19789) {
		bBigEnd = true;
	} else {
		if (bDebug) {
			console.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
		}
		return false;
	}
	if (oFile.getShortAt(iTIFFOffset + 2, bBigEnd) !== 42) {
		if (bDebug) {
			console.log('Not valid TIFF data! (no 0x002A)');
		}
		return false;
	}
	if (oFile.getLongAt(iTIFFOffset + 4, bBigEnd) !== 8) {
		if (bDebug) {
			console.log('Not valid TIFF data! (First offset not 8)', oFile.getShortAt(iTIFFOffset + 4, bBigEnd));
		}

		return false;
	}
	var oTags = readTags(oFile, iTIFFOffset, iTIFFOffset + 8, EXIF.TiffTags, bBigEnd);
	if (oTags.ExifIFDPointer) {
		var oEXIFTags = readTags(oFile, iTIFFOffset, iTIFFOffset + oTags.ExifIFDPointer, EXIF.Tags, bBigEnd);
		for (var strTag in oEXIFTags) {
			switch (strTag) {
				case 'LightSource':
				case 'Flash':
				case 'MeteringMode':
				case 'ExposureProgram':
				case 'SensingMethod':
				case 'SceneCaptureType':
				case 'SceneType':
				case 'CustomRendered':
				case 'WhiteBalance':
				case 'GainControl':
				case 'Contrast':
				case 'Saturation':
				case 'Sharpness':
				case 'SubjectDistanceRange':
				case 'FileSource':
					oEXIFTags[strTag] = EXIF.StringValues[strTag][oEXIFTags[strTag]];
					break;
				case 'ExifVersion':
				case 'FlashpixVersion':
					oEXIFTags[strTag] = String.fromCharCode(oEXIFTags[strTag][0], oEXIFTags[strTag][1], oEXIFTags[strTag][2], oEXIFTags[strTag][3]);
					break;
				case 'ComponentsConfiguration':
					oEXIFTags[strTag] = EXIF.StringValues.Components[oEXIFTags[strTag][0]] + EXIF.StringValues.Components[oEXIFTags[strTag][1]] + EXIF.StringValues.Components[oEXIFTags[strTag][2]] + EXIF.StringValues.Components[oEXIFTags[strTag][3]];
					break;
			}
			oTags[strTag] = oEXIFTags[strTag];
		}
	}
	if (oTags.GPSInfoIFDPointer) {
		var oGPSTags = readTags(oFile, iTIFFOffset, iTIFFOffset + oTags.GPSInfoIFDPointer, EXIF.GPSTags, bBigEnd);
		for (var _strTag in oGPSTags) {
			switch (_strTag) {
				case 'GPSVersionID':
					oGPSTags[_strTag] = oGPSTags[_strTag][0] + '.' + oGPSTags[_strTag][1] + '.' + oGPSTags[_strTag][2] + '.' + oGPSTags[_strTag][3];
					break;
			}
			oTags[_strTag] = oGPSTags[_strTag];
		}
	}
	return oTags;
}

/* harmony default export */ __webpack_exports__["a"] = (findEXIFinJPEG);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__);





/**
 * [post]
 * @param  {[String]} url              [资源路径]
 * @param  {[String]} data             [发送数据]
 * @param  {[String]} responseDataType [响应数据格式]
 * @param  {[Object]} options 		   [其他参数]
 * @return {[Promise]}                  [description]
 */
function post(url, data, responseDataType) {
	var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	    _ref$headers = _ref.headers,
	    headers = _ref$headers === undefined ? {} : _ref$headers;

	return fetch(url, {
		headers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
			Accept: 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
		}, headers),
		credentials: 'include',
		mode: 'cors',
		method: 'POST',
		body: _urlEncode(data)
	}).then(function (response) {
		return _formatData(response, responseDataType);
	});
}
/**
 * [get]
 * @param  {[String]} url              [资源路径]
 * @param  {[String]} responseDataType [响应数据格式]
 * @return {[Promise]}                  [description]
 */
function get(url, responseDataType) {
	return fetch(url, {
		method: 'GET',
		mode: 'cors',
		credentials: 'include'
	}).then(function (response) {
		return _formatData(response, responseDataType);
	});
}
/**
 * [_formatData 格式化response]
 * @param  {[type]} response [响应]
 * @param  {[String]} type     [数据格式]
 * @return {[type]}          [description]
 */
function _formatData(response, type) {
	switch (type) {
		case 'arrayBuffer':
			return response.arrayBuffer();
		case 'blob':
			return response.blob();
		case 'formData':
			return response.formData();
		case 'text':
			return response.text();
		default:
			return response.json();
	}
}
/**
 * [_urlEncode 格式化json为url参数]
 * @param  {[type]} params
 * @return {[type]} string         [description]
 */
function _urlEncode(params) {
	if ((typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(params)) === 'object') {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
			return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
		}).join('&');
	} else {
		return params;
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	post: post,
	get: get
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios_jsonp_pro__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios_jsonp_pro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios_jsonp_pro__);



var httpJsonp = __WEBPACK_IMPORTED_MODULE_1_axios_jsonp_pro___default.a.create({
    baseURL: "", // api的base_url
    timeout: 10000 // 请求超时时间
    // withCredentials: true,
});

// Add a request interceptor
httpJsonp.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Add a response interceptor
httpJsonp.interceptors.response.use(function (response) {
    return response.data || response;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (httpJsonp);

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAABlBMVEUAAAD/VS4A5Sn8AAAAAXRSTlMAQObYZgAAABZJREFUCNdjwA2YiSOY//8HE8TrIAwAUGYEM3e5PYQAAAAASUVORK5CYII="

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAUVBMVEUAAABxcXFnZ2dmZmZmZmZoaGhnZ2dnZ2doaGhmZmZnZ2dnZ2dnZ2doaGhoaGhnZ2dmZmZnZ2dnZ2dnZ2dnZ2doaGhnZ2dtbW1nZ2dmZmZmZmY/Pn55AAAAGnRSTlMACt3o9CZnjkrLtXFVQB7QwKujmXw3LxWFXVt4FP8AAADDSURBVDjLzZDNCsIwEAY3SZP+W2ut2nn/BxWWHLvrRcQ5BXYgfCN/QTfkj06I0AbxGQFScZ1ng7LMjrRBnCJws50H0EmB5mJLVxgkJLjbzgRkaSEGf75kYBKTO6QgA1xt59JAkQ542NINFv1ys50dmGWE5mlLPaxafLSdQwtu/vwEr1rc5KXztbg7/6jFTVboa3GbBF0t7oZsRy3uUFCWkxNQXxllPjkCUkmktWTxpVkFT1J+IfmoFHGJKu09Dv0uX+QNvH4bc6PiJ3MAAAAASUVORK5CYII="

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(367),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(368),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(360),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(332),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(365),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79b1464c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65bdbe1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(366),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(347),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(357),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dfafaaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-210014c7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a29947c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(361),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71370792",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(353),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-584b72f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(350),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(364),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-748bff14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(348),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-484bb5be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(349),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49d01650",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-317d7ce1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa2a39e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(351),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ec227ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(362),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-720926ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(346),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-458c257f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-352acb2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(354),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58e7d0a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(331),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0022cf12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39c3d5d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc1fa74a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(333),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08807d1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(363),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72de51cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(355),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a4a68f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail expect-salary",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "name-tip",
    class: {
      'title-tip': _vm.hasSelected, 'error': _vm.isError
    }
  }, [_vm._v("期望薪资")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSelected),
      expression: "hasSelected"
    }],
    staticClass: "selected-text"
  }, [_vm._v(_vm._s(_vm.selectedText))])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("请选择您期望的薪资范围")]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.hidePopup
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('select-scroll', {
    attrs: {
      "dataList": _vm.salaryList,
      "selectedIndex": _vm.selectedIndex,
      "show": _vm.showBox
    },
    on: {
      "scrollEnd": _vm.scrollEnd
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "v5-x-radiolist"
  }, _vm._l((_vm.currentData), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "v5-x-radiolist-item"
    }, [_c('label', {
      attrs: {
        "for": ("v5-x-radiolist-" + _vm.uuid + "-" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "v5-x-radiolist-radio",
      attrs: {
        "type": "radio",
        "name": ("v5-x-radiolist-" + _vm.uuid),
        "id": ("v5-x-radiolist-" + _vm.uuid + "-" + index)
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.currentValue, item.id)
      },
      on: {
        "change": [function($event) {
          _vm.currentValue = item.id
        }, _vm.change]
      }
    }), _vm._v(" "), _vm._t("default", null, {
      "props": item
    })], 2)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "title-tip"
  }, [_vm._v("谁能看到这份简历")]), _vm._v(" "), _c('span', {
    staticClass: "selected-text"
  }, [_vm._v(_vm._s(_vm.selectedText))])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("选择能看到这份简历的招聘方范围")])]), _vm._v(" "), _c('ul', _vm._l((_vm.selectList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      class: {
        'selected': index === _vm.selectedIndex
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "text-tip"
    }, [_vm._v(_vm._s(item.textTip))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.selectedIndex),
        expression: "index === selectedIndex"
      }]
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "division"
  }), _vm._v(" "), _c('div', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.hidePopup
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-choose"
  }, _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "choose-detail-item",
      on: {
        "click": function($event) {
          return _vm.chooseItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "choose-detail"
    }, [_c('span', {
      class: {
        'title-tip': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "select-tip",
      class: {
        'title-tip': !item.hasSelected, 'selected-text': item.hasSelected, 'error': item.isError && !item.hasSelected
      }
    }, [_vm._v(_vm._s(item.selectedText))])])])
  }), 0), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-top"
  }, [_c('div', {
    staticClass: "user-choose"
  }, _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "choose-detail-item",
      class: {
        active: _vm.selectedItem === index
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "choose-detail"
    }, [_c('span', {
      class: {
        'title-tip': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      class: {
        'title-tip': !item.hasSelected, 'selected-text': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.selectedText))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.multSelectArray[_vm.selectedItem].title))]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.nextSelect(_vm.selectedItem)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('select-scroll', {
      key: index,
      attrs: {
        "dataList": item.list,
        "selectedIndex": item.selectedIndex,
        "show": _vm.showBox && index === _vm.selectedItem
      },
      on: {
        "scrollEnd": _vm.scrollEnd
      }
    })
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "v5-x-checklist"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "v5-x-checklist-item"
    }, [_c('label', {
      attrs: {
        "for": ("v5-x-checklist-" + _vm.uuid + "-" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "v5-x-checklist-checkbox",
      attrs: {
        "type": "checkbox",
        "name": ("v5-x-checklist-" + _vm.uuid),
        "id": ("v5-x-checklist-" + _vm.uuid + "-" + index),
        "disabled": _vm.isDisabled(item)
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, item.id) > -1 : (_vm.currentValue)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }, function($event) {
          return _vm.change(item)
        }]
      }
    }), _vm._v(" "), _vm._t("default", null, {
      "props": item
    })], 2)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "cut_container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    ref: "overlayTop",
    staticClass: "outer-img",
    class: _vm.overlayTopClass
  }), _vm._v(" "), _c('div', {
    ref: "overlayBottom",
    staticClass: "outer-img",
    class: _vm.overlayBottomClass
  }), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "overlay",
    class: _vm.overlayClass
  }, [_c('div', {
    staticClass: "overlay-inner"
  })]), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "resize-container",
    style: ({
      top: _vm.toTop + 'px',
      left: _vm.toLeft + 'px'
    }),
    on: {
      "touchstart": _vm.startMoving,
      "touchmove": _vm.moving,
      "touchend": _vm.endMoving
    }
  }, [_c('img', {
    ref: "img",
    style: ({
      width: _vm.imgWidth,
      height: _vm.imgHeight
    }),
    attrs: {
      "id": "img",
      "src": _vm.dataUrl,
      "crossorigin": "anonymous",
      "alt": "croper"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cut_bottom"
  }, [_c('div', {
    staticClass: "btn_cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn_crop js_crop",
    on: {
      "click": _vm.croper
    }
  }, [_vm._v("选取")])])])
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-toast",
    class: ("" + _vm.position)
  }, [(_vm.text) ? _c('div', {
    staticClass: "v5-toast-content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('div', {
    staticClass: "v5-toast-content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "v5-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mobile-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.mobileTip,
      "text": _vm.mobile,
      "isError": _vm.mobileIsError,
      "maxLength": _vm.mobileMaxLength,
      "inputType": _vm.inputType
    },
    on: {
      "tipClick": _vm.mobileClick,
      "blurEvent": _vm.checkMobile,
      "on-change": _vm.mobileChange
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileRight && !_vm.mobileAuthState),
      expression: "mobileRight && !mobileAuthState"
    }],
    staticClass: "checkCode-btn",
    class: _vm.btnState,
    on: {
      "click": _vm.getCheckCode
    }
  }, [_vm._v(_vm._s(_vm.getCheckCodeText))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileAuthState),
      expression: "mobileAuthState"
    }],
    staticClass: "icon-mobile"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCheckCode),
      expression: "showCheckCode"
    }],
    staticClass: "checkCode-input"
  }, [_c('my-input', {
    attrs: {
      "inputID": "checkCodeInput",
      "tipText": _vm.checkCodeTip,
      "text": _vm.checkCode,
      "isError": _vm.checkCodeIsError,
      "maxLength": _vm.checkCodeMaxLength,
      "isFocusing": _vm.focusCheckCode,
      "inputType": _vm.inputType
    },
    on: {
      "tipClick": _vm.checkCodeClick,
      "blurEvent": _vm.verifyCheckCode
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCodeState),
      expression: "checkCodeState"
    }],
    staticClass: "checkCode-right"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail expect-area",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "name-tip",
    class: {
      'title-tip': _vm.hasSelected, 'error': _vm.isError
    }
  }, [_vm._v("求职区域")]), _vm._v(" "), _c('div', {
    staticClass: "selected-text"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSelected),
      expression: "hasSelected"
    }],
    staticClass: "selected-text"
  }, [_vm._v(_vm._s(_vm.selectedText))])])]), _vm._v(" "), (_vm.areaInfo.length > 0) ? _c('checklist', {
    attrs: {
      "data": _vm.areaInfo,
      "selects": _vm.selectedItems,
      "max": 3,
      "title": "选择求职区域（可多选）"
    },
    on: {
      "on-close": _vm.close,
      "on-confirm": _vm.confirm
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eduadd-wrap"
  }, [_c('div', {
    staticClass: "eduadd-input"
  }, [_c('grad-school'), _vm._v(" "), _c('grad-major'), _vm._v(" "), _c('grad-time')], 1), _vm._v(" "), _c('div', {
    staticClass: "eduadd-save"
  }, [(_vm.eduState === 2) ? _c('span', {
    staticClass: "eduadd-btn eduadd-delete-btn",
    on: {
      "click": _vm.deleteEdu
    }
  }, [_vm._v("\n\t\t\t\t删除\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "eduadd-btn eduadd-save-btn",
    class: {
      'disabled': _vm.noRight
    },
    on: {
      "click": _vm.saveEdu
    }
  }, [_vm._v("\n\t\t\t\t保存\n\t\t\t")])]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.errorTip),
      callback: function($$v) {
        _vm.errorTip = $$v
      },
      expression: "errorTip"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))])], 1)
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "name-tip",
    class: {
      'title-tip': _vm.hasSelected, 'error': _vm.isError
    }
  }, [_vm._v("期望职位")]), _vm._v(" "), _c('div', {
    staticClass: "selected-text"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSelected),
      expression: "hasSelected"
    }]
  }, [_vm._v(_vm._s(_vm.selectedText))])])]), _vm._v(" "), _c('checklist', {
    key: _vm.checklistKey,
    attrs: {
      "data": _vm.titleList,
      "selects": _vm.selectedItems,
      "max": 5,
      "title": "选择期望职位（可多选）"
    },
    on: {
      "on-close": _vm.close,
      "on-confirm": _vm.confirm
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expect-job"
  }, [_c('basic-info'), _vm._v(" "), _c('job-intention', {
    ref: "intention"
  }), _vm._v(" "), _c('privacy-setting'), _vm._v(" "), _c('div', {
    staticClass: "basic-info-save-box"
  }, [_c('div', {
    staticClass: "page-btn",
    class: {
      'btn-disabled': !_vm.expectionInfoOk
    },
    on: {
      "click": _vm.saveResumeEvent
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))]), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-popup"
  }, [_c('transition', {
    attrs: {
      "name": "v5-mask-fade"
    }
  }, [(_vm.isShowMask) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-popup-mask",
    on: {
      "click": _vm.hidePopup,
      "touchmove": function($event) {
        return _vm.lockScroll($event)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": ("v5-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-popup-content",
    class: ("" + _vm.position),
    style: (_vm.styles)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-info basic-info-detail",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "touchend": _vm.tipClick
    }
  }, [_c('a', {
    staticClass: "placeholder",
    class: {
      'input-tip': _vm.showTip, 'error': _vm.isError
    }
  }, [_vm._v(_vm._s(_vm.tipText))]), _vm._v(" "), ((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.content) ? _vm._i(_vm.content, null) > -1 : (_vm.content)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "change": function($event) {
        var $$a = _vm.content,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.content = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.content = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.content = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.content, null)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "change": function($event) {
        _vm.content = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-info-finish-box",
    on: {
      "click": _vm.backBasic
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish"
  }, [_c('img', {
    staticClass: "basic-info-finish-pic",
    attrs: {
      "src": _vm.photoUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish-detail"
  }, [_c('div', {
    staticClass: "basic-info-finish-name"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.truename))]), _vm._v(" "), _c('div', {
    staticClass: "personal-info",
    class: _vm.sexBoxClass
  }, [_c('i', {
    staticClass: "sex",
    class: _vm.sexClass
  }), _vm._v(" "), _c('span', {
    staticClass: "age"
  }, [_vm._v(_vm._s(_vm.age))])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish-other"
  }, [_c('span', {
    staticClass: "save-edu"
  }, [_vm._v(_vm._s(_vm.educationText))]), _vm._v(" "), _c('span', {
    staticClass: "save-job"
  }, [_vm._v(_vm._s(_vm.workExperience))]), _vm._v(" "), _c('span', {
    staticClass: "save-phone"
  }, [_vm._v(_vm._s(_vm.mobile))])]), _vm._v(" "), (_vm.needEducation) ? _c('div', {
    staticClass: "basic-info-finish-edu"
  }, [_c('span', {
    staticClass: "edu-item"
  }, [_vm._v(_vm._s(_vm.getHighEdu.school))]), _vm._v(" "), _c('span', {
    staticClass: "edu-item"
  }, [_vm._v(_vm._s(_vm.getHighEdu.professional) + "专业")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-user-info-finish-tit"
  }, [_c('span', [_vm._v("个人资料")]), _vm._v(" "), _c('div', {
    staticClass: "modify"
  }, [_c('span', [_vm._v("修改")]), _vm._v(" "), _c('i', {
    staticClass: "icon-modify"
  })])])
}]}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edulist-wrap"
  }, [_c('div', {
    staticClass: "edulist-item",
    class: {
      'edulist-item-last': _vm.eduLength === _vm.index + 1
    }
  }, [_c('p', {
    staticClass: "edulist-time"
  }, [_vm._v(_vm._s(_vm.getTime) + "毕业于")]), _vm._v(" "), _c('p', {
    staticClass: "edulist-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.eduList.school))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.eduList.professional) + "专业")])]), _vm._v(" "), _c('img', {
    staticClass: "edulist-edit-icon",
    attrs: {
      "src": __webpack_require__(295)
    },
    on: {
      "click": _vm.editEdu
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "imgCode-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "imgCodeBox"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("图片验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-imgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    staticClass: "imgCode-input",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入图片验证码"
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "blur": _vm.checkInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "imgCode",
    attrs: {
      "src": _vm.imgCodeUrl
    },
    on: {
      "click": _vm.freshValidateCode
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "error-p"
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorInfo))])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "btn main-btn",
    on: {
      "click": _vm.checkImgCode
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mobile-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.mobileTip,
      "text": _vm.mobile,
      "isError": _vm.mobileIsError,
      "maxLength": _vm.mobileMaxLength,
      "inputType": _vm.inputType
    },
    on: {
      "tipClick": _vm.mobileClick,
      "blurEvent": _vm.checkMobile,
      "on-change": _vm.mobileChange
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileRight),
      expression: "mobileRight"
    }],
    staticClass: "checkCode-btn",
    class: _vm.btnState,
    on: {
      "click": function($event) {
        return _vm.getCheckCode('')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCheckCodeText))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCheckCode),
      expression: "showCheckCode"
    }],
    staticClass: "checkCode-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.checkCodeTip,
      "text": _vm.checkCode,
      "isError": _vm.checkCodeIsError,
      "maxLength": _vm.checkCodeMaxLength,
      "isFocusing": _vm.focusCheckCode,
      "inputType": _vm.inputType
    },
    on: {
      "tipClick": _vm.checkCodeClick,
      "blurEvent": _vm.verifyCheckCode
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCodeState),
      expression: "checkCodeState"
    }],
    staticClass: "checkCode-right"
  })], 1), _vm._v(" "), (_vm.showImgCodeBox) ? _c('img-code', {
    on: {
      "getCheckCode": _vm.getCheckCode,
      "closeImgBox": _vm.closeImgBox
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-info"
  }, [(['fromWX', 'fromBD', 'fromZFB', 'fromTT'].indexOf(_vm.pagefrom) === -1 && (_vm.resumeType === 2 && !_vm.isLogin)) ? _c('login-guide') : _vm._e(), _vm._v(" "), _c('head-portrait'), _vm._v(" "), _c('div', {
    staticClass: "basic-info-box"
  }, [_c('name', {
    ref: "truename"
  }), _vm._v(" "), _c('sex', {
    ref: "gender"
  }), _vm._v(" "), _c('mobile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    ref: "mobile"
  }), _vm._v(" "), _c('login-captcha', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    ref: "loginMobile"
  }), _vm._v(" "), _c('experience', {
    ref: "experience"
  })], 1), _vm._v(" "), (_vm.needEducation) ? _c('div', {
    staticClass: "basic-education"
  }, [_c('my-education')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "basic-info-save-box"
  }, [_c('div', {
    staticClass: "page-btn",
    class: {
      'btn-disabled': !_vm.basicInfoOk
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.errorTip),
      callback: function($$v) {
        _vm.errorTip = $$v
      },
      expression: "errorTip"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))]), _vm._v(" "), (_vm.showStay) ? _c('my-dialog', {
    attrs: {
      "title": "提示",
      "content": "离好工作仅差一步，是否确认退出？",
      "btnCancel": "确定退出",
      "btnConfirm": "继续填写"
    },
    on: {
      "cancel": _vm.quit,
      "confirm": _vm.noQuit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLimit) ? _c('my-dialog', {
    attrs: {
      "title": "提示",
      "content": "您的简历已达到上限了哦",
      "btnCancel": "查看职位",
      "btnConfirm": "查看简历"
    },
    on: {
      "cancel": _vm.goJobList,
      "confirm": _vm.goMyResume
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sex-info",
    class: {
      'item-error': _vm.isError
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMale || _vm.selectedFemale),
      expression: "selectedMale || selectedFemale"
    }],
    staticClass: "user-sex-tit"
  }, [_vm._v("性别")]), _vm._v(" "), _c('div', {
    staticClass: "sex-item",
    class: {
      selected: _vm.selectedMale, hidden: _vm.selectedFemale
    },
    on: {
      "click": function($event) {
        return _vm.sexSelect(false)
      }
    }
  }, [_c('a', {
    staticClass: "user-sex male"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sex-item",
    class: {
      selected: _vm.selectedFemale, hidden: _vm.selectedMale
    },
    on: {
      "click": function($event) {
        return _vm.sexSelect(true)
      }
    }
  }, [_c('a', {
    staticClass: "user-sex female"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-scroller",
    attrs: {
      "id": _vm.containerId
    },
    on: {
      "touchstart": function($event) {
        return _vm.touchStart($event)
      },
      "touchmove": function($event) {
        return _vm.touchMove($event)
      },
      "touchend": function($event) {
        return _vm.touchEnd($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }],
    staticClass: "upload_toutu_type"
  }, [_c('div', {
    staticClass: "select_type"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "upload_type"
  }, [_c('li', {
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img my_img"
  }, [_c('input', {
    ref: "inputer",
    staticClass: "upload-btn",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/my_img.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("我的照片")])]), _vm._v(" "), _c('li', {
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img virtual_img",
    on: {
      "click": _vm.showVirtualBox
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/virtual_img.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("默认头像")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user58pic !== ''),
      expression: "user58pic !== ''"
    }],
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img",
    on: {
      "click": _vm.selectUserPic
    }
  }, [_c('img', {
    staticClass: "third-img",
    attrs: {
      "src": _vm.user58pic
    }
  })]), _vm._v(" "), _c('p', [_vm._v("58头像")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.hidePop
    }
  }, [_c('span', [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSelect && _vm.showVirtual),
      expression: "!showSelect && showVirtual"
    }],
    staticClass: "virtual"
  }, [_c('div', {
    staticClass: "virtual_toutu"
  }, [_c('ul', {
    staticClass: "virtual_toutuList"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "virtual_item",
      class: {
        selected: index === _vm.selectedItem
      },
      on: {
        "click": function($event) {
          return _vm.chooseVirtual(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.backSelect
    }
  }, [_c('span', [_vm._v("返回")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload_title"
  }, [_c('p', [_vm._v("选个上传的方式")])])
}]}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expect-job-info"
  }, [_c('p', {
    staticClass: "job-apply-text"
  }, [_vm._v("求职意向")]), _vm._v(" "), _c('div', [_c('title-intention', {
    ref: "zpcateId"
  }), _vm._v(" "), _c('salary-intention', {
    ref: "salary"
  }), _vm._v(" "), _c('area-intention', {
    ref: "targetAreaId"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "changeCity",
    on: {
      "click": _vm.changeCity
    }
  }, [_c('span', {
    attrs: {
      "id": "city"
    }
  }, [_vm._v(_vm._s(_vm.areaName))])]), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "my58",
    attrs: {
      "onclick": "document.location.href='//m.m.58.com/index/'"
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo_a",
    attrs: {
      "href": "//m.58.com"
    }
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "popup-content"
  }, [_c('div', {
    staticClass: "line-one"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-two"
  }), _vm._v(" "), _c('scroller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "snapping": _vm.snapping,
      "size": _vm.size,
      "positionY": _vm.positionY,
      "autoResize": false
    },
    on: {
      "on-scrollend": _vm.scrollEnd
    }
  }, [_c('ul', {
    staticClass: "popup-ul",
    attrs: {
      "id": _vm.containerId
    }
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "popup-li"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sel-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-bottom"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "educations-wrap"
  }, [_c('div', {
    staticClass: "educations-title"
  }, [_vm._v("教育经历")]), _vm._v(" "), (_vm.educations.length > 0) ? _c('div', {
    staticClass: "educations-items"
  }, [_vm._l((_vm.educations), function(edu, n) {
    return [(_vm.eduIndex !== n) ? _c('div', {
      key: n,
      staticClass: "educations-item"
    }, [_c('edu-list', {
      attrs: {
        "eduList": edu,
        "index": n,
        "eduLength": _vm.educations.length
      }
    })], 1) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "educations-add"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.educations.length > 0 && _vm.eduState === 0) ? _c('span', {
    staticClass: "educations-add-btn",
    on: {
      "click": _vm.addEdu
    }
  }, [_c('img', {
    staticClass: "educations-add-icon",
    attrs: {
      "src": __webpack_require__(294)
    }
  }), _vm._v(" "), _c('span', [_vm._v("添加教育经历")])]) : _c('edu-add')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.schoolTip,
      "text": _vm.school,
      "isError": _vm.isError,
      "maxLength": _vm.maxLength
    },
    on: {
      "tipClick": _vm.schoolClick,
      "blurEvent": _vm.checkSchool
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(['fromWX', 'fromBD', 'fromZFB', 'fromTT', 'fromTZ'].indexOf(_vm.pagefrom) === -1 && _vm.resumeType !== 3) ? _c('Nav') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-x-dialog",
    on: {
      "touchmove": function($event) {
        return _vm.lockScroll($event)
      }
    }
  }, [(_vm.isMask) ? _c('transition', {
    attrs: {
      "name": "v5-mask-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-x-dialog-mask",
    on: {
      "click": _vm.clickMask
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "v5-x-dialog-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-x-dialog-content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "img_preview"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "back_desc",
    on: {
      "click": _vm.hideBox
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/pointer_left.png"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "picture_div"
  }, [_c('img', {
    staticClass: "picture",
    class: _vm.imgClass,
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change_img",
    on: {
      "click": _vm.changeImg
    }
  }, [_c('span', [_vm._v("更换头像")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_div"
  }, [_c('span', {
    staticClass: "preview_title"
  }, [_vm._v("简历头像")])])
}]}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-dialog-warp"
  }, [_c('div', {
    staticClass: "com-dialog-main"
  }, [_c('h5', {
    staticClass: "com-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "com-dialog-content"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "com-dialog-footer"
  }, [_c('a', {
    staticClass: "com-dialog-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.btnCancel))]), _vm._v(" "), _c('a', {
    staticClass: "com-dialog-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.btnConfirm))])])])])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "title-tip"
  }, [_vm._v("不想从事的行业")]), _vm._v(" "), _c('div', {
    staticClass: "selected-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedText))])])]), _vm._v(" "), _c('checklist', {
    attrs: {
      "data": _vm.list,
      "selects": _vm.selectedItems,
      "max": 5,
      "title": "简历屏蔽行业"
    },
    on: {
      "on-close": _vm.close,
      "on-confirm": _vm.confirm,
      "on-change": _vm.dataChange
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('p', {
    staticClass: "checklist-tips",
    attrs: {
      "slot": "extend"
    },
    slot: "extend"
  }, [_vm._v("我不想让以下行业搜到我的简历（可多选）")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-guide-box"
  }, [_c('span', {
    staticClass: "login-text"
  }, [_vm._v("若您已有简历，可直接登录")]), _vm._v(" "), _c('a', {
    staticClass: "login-btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "major-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.majorTip,
      "text": _vm.major,
      "isError": _vm.isError,
      "maxLength": _vm.maxLength
    },
    on: {
      "tipClick": _vm.majorClick,
      "blurEvent": _vm.checkMajor
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradtime-wrap"
  }, [_c('div', {
    staticClass: "gradtime-input"
  }, [_c('div', {
    staticClass: "gradtime-info",
    on: {
      "click": _vm.showPopup
    }
  }, [_c('a', {
    staticClass: "gradtime-placeholder",
    class: {
      'gradtime-placeholder-tip': _vm.showTip
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.timeTip) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "gradtime-time",
    class: {
      'gradtime-time-tip': _vm.showTip
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.time) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.DateObj.title))]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.finishSelect
    }
  }, [_vm._v(_vm._s(_vm.DateObj.btnText))])]), _vm._v(" "), _c('div', {
    staticClass: "popup-main"
  }, _vm._l((_vm.DateArray), function(item, index) {
    return _c('select-scroll', {
      key: index,
      attrs: {
        "dataList": item.list,
        "selectedIndex": item.selectedIndex,
        "show": _vm.showBox,
        "scrollIndex": index
      },
      on: {
        "scrollEnd": _vm.scrollEnd
      }
    })
  }), 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "isShowMask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-checklist-selected-wrap"
  }, [_c('div', {
    staticClass: "v5-checklist-selected"
  }, [_c('span', {
    staticClass: "v5-checklist-selected-title"
  }, [_vm._v("已选")]), _vm._v(" "), _c('div', {
    staticClass: "v5-checklist-selected-scroller-wrap"
  }, [_c('scroller', {
    attrs: {
      "scrollingX": true,
      "scrollingY": false,
      "positionX": _vm.positionX
    }
  }, [_c('div', {
    staticClass: "v5-checklist-selected-list"
  }, _vm._l((_vm.currentValue), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "v5-checklist-selected-item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.remove(item.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "v5-checklist-selected-item-close"
    })])
  }), 0)])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "v5-checklist-selected-btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确认 " + _vm._s(_vm.selLength) + "/" + _vm._s(_vm.max))])])])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "isLockScroll": _vm.isLockScroll
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-confirm-content"
  }, [_c('strong', {
    staticClass: "v5-confirm-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "v5-confirm-message",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('div', {
    staticClass: "v5-confirm-message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "v5-confirm-footer"
  }, [_c('x-button', {
    staticClass: "v5-confirm-btn",
    attrs: {
      "activeColor": "#ccc"
    },
    on: {
      "on-click": _vm.cancel
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.cancelText) + "\n\t\t\t\t")]), _vm._v(" "), _c('x-button', {
    staticClass: "v5-confirm-btn",
    attrs: {
      "activeColor": "#ccc"
    },
    on: {
      "on-click": _vm.confirm
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.confirmText) + "\n\t\t\t\t")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-pic-bg",
    on: {
      "click": _vm.imgBtnClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    ref: "img",
    staticClass: "user-pic",
    attrs: {
      "src": _vm.pic
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "user-pic-tit"
  }, [_vm._v("头像，一个好工作的开始")]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showSelectBox),
      callback: function($$v) {
        _vm.showSelectBox = $$v
      },
      expression: "showSelectBox"
    }
  }, [_c('selext-box', {
    on: {
      "hidePop": _vm.hidePop,
      "chooseImg": _vm.chooseImg,
      "choose58pic": _vm.choose58pic,
      "imgSelect": _vm.imgSelect
    },
    model: {
      value: (_vm.showSelectBox),
      callback: function($$v) {
        _vm.showSelectBox = $$v
      },
      expression: "showSelectBox"
    }
  })], 1), _vm._v(" "), _c('preview', {
    attrs: {
      "imgSrc": _vm.pic
    },
    on: {
      "changImg": _vm.changImg
    },
    model: {
      value: (_vm.showPreview),
      callback: function($$v) {
        _vm.showPreview = $$v
      },
      expression: "showPreview"
    }
  }), _vm._v(" "), _c('cut-img', {
    attrs: {
      "dataUrl": _vm.dataUrl
    },
    on: {
      "afterCrop": _vm.submit,
      "chooseOther": _vm.chooseOther
    },
    model: {
      value: (_vm.showCutBox),
      callback: function($$v) {
        _vm.showCutBox = $$v
      },
      expression: "showCutBox"
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_vm._v(_vm._s(_vm.toastTip))]), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic-wrap"
  }, [_c('div', {
    staticClass: "user-pic-content"
  })])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.nameTip,
      "text": _vm.name,
      "isError": _vm.isError,
      "maxLength": _vm.maxLength
    },
    on: {
      "tipClick": _vm.nameClick,
      "blurEvent": _vm.checkName
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-info"
  }, [_c('span', {
    staticClass: "privacy-title"
  }, [_vm._v("隐私设置")]), _vm._v(" "), _c('privacy-company'), _vm._v(" "), (_vm.showIndustry) ? _c('privacy-industry') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "v5-loading"
  }, [_c('div', {
    staticClass: "v5-loading-content"
  })])
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "height": "100%",
      "isShowMask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-checklist-content"
  }, [_c('div', {
    staticClass: "v5-checklist-header"
  }, [_c('div', {
    staticClass: "v5-checklist-header-content"
  }, [_c('a', {
    staticClass: "v5-checklist-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")])]), _vm._v(" "), _vm._t("extend"), _vm._v(" "), _c('div', {
    staticClass: "v5-checklist-main",
    class: {
      'v5-checklist-main-wrap': _vm.isShowFooter
    }
  }, _vm._l((_vm.currentData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "v5-checklist-content-wrap"
    }, [(_vm.level === 1 || index === _vm.level - 1) ? _c('x-checklist', {
      staticClass: "v5-checklist-content",
      attrs: {
        "options": item,
        "max": _vm.max
      },
      on: {
        "on-limit": _vm.limit
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var props = ref.props;

          return _c('span', {
            staticClass: "v5-checklist-content-item"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(props.name) + "\n\t\t\t\t\t")])
        }
      }], null, true),
      model: {
        value: (_vm.currentValue[index]),
        callback: function($$v) {
          _vm.$set(_vm.currentValue, index, $$v)
        },
        expression: "currentValue[index]"
      }
    }) : _c('x-radiolist', {
      staticClass: "v5-checklist-content",
      attrs: {
        "options": item
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var props = ref.props;

          return _c('span', {
            staticClass: "v5-checklist-content-item"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(props.name) + "\n\t\t\t\t\t")])
        }
      }], null, true),
      model: {
        value: (_vm.currentValue[index]),
        callback: function($$v) {
          _vm.$set(_vm.currentValue, index, $$v)
        },
        expression: "currentValue[index]"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('selected', {
    attrs: {
      "selects": _vm.currentValue[_vm.level - 1],
      "max": _vm.max
    },
    on: {
      "update": _vm.updateValue,
      "confirm": _vm.confirm
    },
    model: {
      value: (_vm.isShowFooter),
      callback: function($$v) {
        _vm.isShowFooter = $$v
      },
      expression: "isShowFooter"
    }
  }), _vm._v(" "), _c('toast', {
    model: {
      value: (_vm.isShowToast),
      callback: function($$v) {
        _vm.isShowToast = $$v
      },
      expression: "isShowToast"
    }
  }, [_vm._v("最多只能选择" + _vm._s(_vm.max) + "个")])], 2)])
},staticRenderFns: []}

/***/ })
],[279]);


// WEBPACK FOOTER //
// js/app.js